webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(22);
	module.exports = __webpack_require__(68);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _components = __webpack_require__(71);

	var _components2 = _interopRequireDefault(_components);

	var _services = __webpack_require__(77);

	var _services2 = _interopRequireDefault(_services);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('app.core', [_components2.default.name, _services2.default.name]).name;

/***/ },
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _playlistEditor = __webpack_require__(41);

	Object.keys(_playlistEditor).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _playlistEditor[key];
	    }
	  });
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularUiRouter = __webpack_require__(5);

	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _playlistEditorSettings = __webpack_require__(42);

	var _playlistEditorSettings2 = _interopRequireDefault(_playlistEditorSettings);

	var _angularUiBootstrap = __webpack_require__(8);

	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('playlist-editor', [_core2.default, _angularUiBootstrap2.default, _angularUiRouter2.default]).config(config).service('PlaylistEditorSettings', _playlistEditorSettings2.default).component(_playlistEditor.playlistEditorComponent.selector, _playlistEditor.playlistEditorComponent).name;
	/* @ngInject */

	function config($stateProvider) {
	  $stateProvider.state('addVideo', {
	    url: '/add-video/:id',
	    template: '<playlist-editor></playlist-editor>',
	    resolve: {
	      /* @ngInject */
	      video: ["YoutubeVideoInfo", "$stateParams", "PlaylistEditorSettings", function video(YoutubeVideoInfo, $stateParams, PlaylistEditorSettings) {
	        return YoutubeVideoInfo.list($stateParams.id).then(function (items) {
	          PlaylistEditorSettings.add(items[0]);
	          return items[0];
	        });
	      }]
	    }
	  });
	}
	config.$inject = ["$stateProvider"];

/***/ },
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _mediaInfoService = __webpack_require__(53);

	var _mediaInfoService2 = _interopRequireDefault(_mediaInfoService);

	var _angularSocialshare = __webpack_require__(14);

	var _angularSocialshare2 = _interopRequireDefault(_angularSocialshare);

	var _youtubePlayerComponent = __webpack_require__(61);

	var _youtubePlayerApiSrv = __webpack_require__(60);

	var _youtubePlayerApiSrv2 = _interopRequireDefault(_youtubePlayerApiSrv);

	var _youtubePlayerCreatorSrv = __webpack_require__(62);

	var _youtubePlayerCreatorSrv2 = _interopRequireDefault(_youtubePlayerCreatorSrv);

	var _youtubePlayerSettingsSrv = __webpack_require__(63);

	var _youtubePlayerSettingsSrv2 = _interopRequireDefault(_youtubePlayerSettingsSrv);

	var _playerResizerSrv = __webpack_require__(59);

	var _playerResizerSrv2 = _interopRequireDefault(_playerResizerSrv);

	var _playerResizerComponent = __webpack_require__(58);

	var _playerResizerComponent2 = _interopRequireDefault(_playerResizerComponent);

	var _playerControls = __webpack_require__(56);

	var _playerControls2 = _interopRequireDefault(_playerControls);

	var _mediaInfo = __webpack_require__(54);

	var _mediaInfo2 = _interopRequireDefault(_mediaInfo);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('youtube.player', [_core2.default, 'LocalStorageModule', '720kb.socialshare', _playerControls2.default, _mediaInfo2.default]).config(config).factory('MediaInfoService', _mediaInfoService2.default).service('YoutubePlayerApi', _youtubePlayerApiSrv2.default).service('YoutubePlayerCreator', _youtubePlayerCreatorSrv2.default).factory('YoutubePlayerSettings', _youtubePlayerSettingsSrv2.default).factory('PlayerResizer', _playerResizerSrv2.default).directive('playerResizer', _playerResizerComponent2.default).component(_youtubePlayerComponent.YoutubePlayerComponent.selector, _youtubePlayerComponent.YoutubePlayerComponent).name;

	/* @ngInject */

	function config() {}

/***/ },
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {(function commonJS(require, module) {
	    'use strict';

	    __webpack_require__(15);

	    module.exports = '720kb.socialshare';
	}(require, module));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ },
/* 15 */
/***/ function(module, exports) {

	/*
	 * angular-socialshare
	 * 0.2.1-beta
	 *
	 * A social urls and content sharing directive for angularjs.
	 * http://720kb.githb.io/angular-socialshare
	 *
	 * MIT license
	 * Thu Feb 04 2016
	 */
	/*global angular*/
	/*eslint no-loop-func:0, func-names:0*/

	(function withAngular(angular) {
	  'use strict';

	  var directiveName = 'socialshare'
	    , socialshareProviderNames = ['facebook', 'twitter', 'linkedin', 'google+', 'pinterest', 'tumblr', 'reddit', 'stumbleupon', 'buffer', 'digg', 'delicious', 'vk', 'pocket', 'wordpress', 'flipboard', 'xing', 'hackernews', 'evernote']
	    , socialshareConfigurationProvider = /*@ngInject*/ function socialshareConfigurationProvider() {

	      var socialshareConfigurationDefault = [{
	        'provider': 'facebook',
	        'conf': {
	            'url':'',
	            'text': '',
	            'media': '',
	            'type': '',
	            'via': '',
	            'to': '',
	            'from': '',
	            'ref': '',
	            'display': '',
	            'source': '',
	            'caption': '',
	            'redirectUri': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'twitter',
	          'conf': {
	            'url': '',
	            'text': '',
	            'via': '',
	            'hashtags': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'linkedin',
	          'conf': {
	            'url': '',
	            'text': '',
	            'description': '',
	            'source': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'reddit',
	          'conf': {
	            'url': '',
	            'text': '',
	            'subreddit': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'vk',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'digg',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'delicious',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'stumbleupon',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'pinterest',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'google+',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'tumblr',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'buffer',
	          'conf': {
	            'url': '',
	            'text': '',
	            'via': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'pocket',
	          'conf': {
	            'url': '',
	            'text': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'flipboard',
	          'conf': {
	            'url': '',
	            'text': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'hackernews',
	          'conf': {
	            'url': '',
	            'text': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'wordpress',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'xing',
	          'conf': {
	            'url': '',
	            'text': '',
	            'media': '',
	            'follow' : '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        },
	        {
	          'provider': 'evernote',
	          'conf': {
	            'url': '',
	            'text': '',
	            'trigger': 'click',
	            'popupHeight': 300,
	            'popupWidth': 400
	          }
	        }];

	      return {
	        'configure': function configure(configuration) {

	          var configIndex = 0
	            , configurationKeys
	            , configurationIndex
	            , aConfigurationKey
	            , configElement
	            , internIndex = 0
	          //this is necessary becuase provider run before any service
	          //so i have to take the log from another injector
	          , $log = angular.injector(['ng']).get('$log');

	          if (configuration && configuration.length > 0) {
	            for (; configIndex < configuration.length; configIndex += 1) {
	              if (configuration[configIndex].provider && socialshareProviderNames.indexOf(configuration[configIndex].provider) > -1) {

	                for (; internIndex < socialshareConfigurationDefault.length; internIndex += 1) {
	                  configElement = socialshareConfigurationDefault[internIndex];

	                  if (configElement &&
	                    configElement.provider &&
	                    configuration[configIndex].provider === configElement.provider) {

	                      configurationKeys = Object.keys(configElement.conf);
	                      configurationIndex = 0;

	                      for (; configurationIndex < configurationKeys.length; configurationIndex += 1) {

	                        aConfigurationKey = configurationKeys[configurationIndex];
	                        if (aConfigurationKey && configuration[configIndex].conf[aConfigurationKey]) {

	                          configElement.conf[aConfigurationKey] = configuration[configIndex].conf[aConfigurationKey];
	                        }
	                      }
	                    }
	                  }
	                } else {
	                  $log.warn('Invalid provider at element ' + configIndex + ' with name:' + configuration[configIndex].provider);
	                }
	              }
	            }
	        }
	        , '$get': /*@ngInject*/ function instantiateProvider() {

	            return socialshareConfigurationDefault;
	        }
	      };
	    }
	    , socialshareDirective = /*@ngInject*/ ["$window", "$location", "socialshareConf", "$log", function socialshareDirective($window, $location, socialshareConf, $log) {

	      var linkingFunction = function linkingFunction($scope, element, attrs) {

	        // observe the values in each of the properties so that if they're updated elsewhere,
	        // they are updated in this directive.
	        var configurationElement
	        , index = 0
	        , onEventTriggered = function onEventTriggered() {
	          /*eslint-disable no-use-before-define*/
	          switch (attrs.socialshareProvider) {
	            case 'facebook': {

	              facebookShare($window, $location, attrs);
	              break;
	            }
	            case 'google+': {

	              googlePlusShare($window, $location, attrs);
	              break;
	            }
	            case 'twitter': {

	              twitterShare($window, $location, attrs);
	              break;
	            }
	            case 'stumbleupon': {

	              stumbleuponShare($window, $location, attrs);
	              break;
	            }
	            case 'reddit': {

	              redditShare($window, $location, attrs);
	              break;
	            }
	            case 'pinterest': {

	              pinterestShare($window, $location, attrs);
	              break;
	            }
	            case 'linkedin': {

	              linkedinShare($window, $location, attrs);
	              break;
	            }
	            case 'digg': {

	              diggShare($window, $location, attrs);
	              break;
	            }
	            case 'tumblr': {

	              tumblrShare($window, $location, attrs);
	              break;
	            }
	            case 'delicious': {

	              deliciousShare($window, $location, attrs);
	              break;
	            }
	            case 'vk': {

	              vkShare($window, $location, attrs);
	              break;
	            }
	            case 'buffer': {

	              bufferShare($window, $location, attrs);
	              break;
	            }
	            case 'pocket': {

	              pocketShare($window, $location, attrs);
	              break;
	            }
	            case 'wordpress': {

	              wordpressShare($window, $location, attrs);
	              break;
	            }
	            case 'flipboard': {

	              flipboardShare($window, $location, attrs);
	              break;
	            }
	            case 'hackernews': {

	              hackernewsShare($window, $location, attrs);
	              break;
	            }
	            case 'xing': {

	              xingShare($window, $location, attrs);
	              break;
	            }
	            case 'evernote': {

	              evernoteShare($window, $location, attrs);
	              break;
	            }
	            default: {
	              return true;
	            }
	          }
	        };
	        /*eslint-enable no-use-before-define*/
	        //looking into configuration if there is a config for the current provider
	        for (; index < socialshareConf.length; index += 1) {
	          if (socialshareConf[index].provider === attrs.socialshareProvider) {
	            configurationElement = socialshareConf[index];
	            break;
	          }
	        }

	        if (socialshareProviderNames.indexOf(configurationElement.provider) === -1) {
	          $log.warn('Invalid Provider Name : ' + attrs.socialshareProvider);
	        }

	        //if some attribute is not define provide a default one
	        attrs.socialshareUrl = attrs.socialshareUrl || configurationElement.conf.url;
	        attrs.socialshareText = attrs.socialshareText || configurationElement.conf.text;
	        attrs.socialshareMedia = attrs.socialshareMedia || configurationElement.conf.media;
	        attrs.socialshareType =  attrs.socialshareType || configurationElement.conf.type;
	        attrs.socialshareVia = attrs.socialshareVia || configurationElement.conf.via;
	        attrs.socialshareTo =  attrs.socialshareTo || configurationElement.conf.to;
	        attrs.socialshareFrom =  attrs.socialshareFrom || configurationElement.conf.from;
	        attrs.socialshareRef = attrs.socialshareRef || configurationElement.conf.ref;
	        attrs.socialshareDislay = attrs.socialshareDislay || configurationElement.conf.display;
	        attrs.socialshareSource = attrs.socialshareSource || configurationElement.conf.source;
	        attrs.socialshareCaption = attrs.socialshareCaption || configurationElement.conf.caption;
	        attrs.socialshareRedirectUri = attrs.socialshareRedirectUri || configurationElement.conf.redirectUri;
	        attrs.socialshareTrigger =  attrs.socialshareTrigger || configurationElement.conf.trigger;
	        attrs.socialsharePopupHeight = attrs.socialsharePopupHeight || configurationElement.conf.popupHeight;
	        attrs.socialsharePopupWidth = attrs.socialsharePopupWidth || configurationElement.conf.popupWidth;
	        attrs.socialshareSubreddit = attrs.socialshareSubreddit || configurationElement.conf.subreddit;
	        attrs.socialshareDescription = attrs.socialshareDescription || configurationElement.conf.description;
	        attrs.socialshareFollow = attrs.socialshareFollow || configurationElement.conf.follow;
	        attrs.socialshareHashtags = attrs.socialshareHashtags || configurationElement.conf.hashtags;

	        element.bind(attrs.socialshareTrigger, onEventTriggered);
	      };

	      return {
	        'restrict': 'A',
	        'link': linkingFunction
	      };
	    }]
	    , manageFacebookShare = function manageFacebookShare($window, $location, attrs) {
	      if (attrs.socialshareType && attrs.socialshareType === 'feed') {
	        // if user specifies that they want to use the Facebook feed dialog (https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4)
	        var urlString = 'https://www.facebook.com/dialog/feed?display=popup';

	        if (attrs.socialshareVia) {
	          urlString += '&app_id=' + encodeURIComponent(attrs.socialshareVia);
	        }

	        if (attrs.socialshareRedirectUri) {
	          urlString += '&redirect_uri=' + encodeURIComponent(attrs.socialshareRedirectUri);
	        }
	        if (attrs.socialshareUrl) {
	          urlString += '&link=' + encodeURIComponent(attrs.socialshareUrl);
	        }

	        if (attrs.socialshareTo) {
	          urlString += '&to=' + encodeURIComponent(attrs.socialshareTo);
	        }

	        if (attrs.socialshareDisplay) {
	          urlString += '&display=' + encodeURIComponent(attrs.socialshareDisplay);
	        }

	        if (attrs.socialshareRef) {
	          urlString += '&ref=' + encodeURIComponent(attrs.socialshareRef);
	        }

	        if (attrs.socialshareFrom) {
	          urlString += '&from=' + encodeURIComponent(attrs.socialshareFrom);
	        }

	        if (attrs.socialshareDescription) {
	          urlString += '&description=' + encodeURIComponent(attrs.socialshareDescription);
	        }

	        if (attrs.socialshareText) {
	          urlString += '&name=' + encodeURIComponent(attrs.socialshareText);
	        }

	        if (attrs.socialshareCaption) {
	          urlString += '&caption=' + encodeURIComponent(attrs.socialshareCaption);
	        }

	        if (attrs.socialshareMedia) {
	          urlString += '&picture=' + encodeURIComponent(attrs.socialshareMedia);
	        }

	        if (attrs.socialshareSource) {
	          urlString += '&source=' + encodeURIComponent(attrs.socialshareSource);
	        }

	        $window.open(
	          urlString,
	          'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);

	      } else {
	        //otherwise default to using sharer.php
	        $window.open(
	          'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl())
	          , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    }
	    , manageTwitterShare = function manageTwitterShare($window, $location, attrs) {
	      var urlString = 'https://www.twitter.com/intent/tweet?';

	      if (attrs.socialshareText) {
	        urlString += 'text=' + encodeURIComponent(attrs.socialshareText);
	      }

	      if (attrs.socialshareVia) {
	        urlString += '&via=' + encodeURIComponent(attrs.socialshareVia);
	      }

	      if (attrs.socialshareHashtags) {
	        urlString += '&hashtags=' + encodeURIComponent(attrs.socialshareHashtags);
	      }

	      //default to the current page if a URL isn't specified
	      urlString += '&url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      $window.open(
	        urlString,
	        'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageGooglePlusShare = function manageGooglePlusShare($window, $location, attrs) {

	      $window.open(
	        'https://plus.google.com/share?url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl())
	        , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    , manageRedditShare = function manageRedditShare($window, $location, attrs) {
	      var urlString = 'https://www.reddit.com/';

	      if (attrs.socialshareSubreddit) {
	        urlString += 'r/' + attrs.socialshareSubreddit + '/submit?url=';
	      } else {
	        urlString += 'submit?url=';
	      }
	      /*-
	      * Reddit isn't responsive and at default width for our popups (500 x 500), everything is messed up.
	      * So, overriding the width if it is less than 900 (played around to settle on this) and height if
	      * it is less than 650px.
	      */
	      if (attrs.socialsharePopupWidth < 900) {
	        attrs.socialsharePopupWidth = 900;
	      }

	      if (attrs.socialsharePopupHeight < 650) {
	        attrs.socialsharePopupHeight = 650;
	      }

	      $window.open(
	        urlString + encodeURIComponent(attrs.socialshareUrl || $location.absUrl()) + '&title=' + encodeURIComponent(attrs.socialshareText)
	        , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    , manageStumbleuponShare = function manageStumbleuponShare($window, $location, attrs) {

	      $window.open(
	        'https://www.stumbleupon.com/submit?url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl()) + '&title=' + encodeURIComponent(attrs.socialshareText)
	        , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageLinkedinShare = function manageLinkedinShare($window, $location, attrs) {
	      /*
	      * Refer: https://developer.linkedin.com/docs/share-on-linkedin
	      * Tab: Customized URL
	      */
	      var urlString = 'https://www.linkedin.com/shareArticle?mini=true';

	      urlString += '&url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      if (attrs.socialshareText) {
	        urlString += '&title=' + encodeURIComponent(attrs.socialshareText);
	      }

	      if (attrs.socialshareDescription) {
	        urlString += '&summary=' + encodeURIComponent(attrs.socialshareDescription);
	      }

	      if (attrs.socialshareSource) {
	        urlString += '&source=' + encodeURIComponent(attrs.socialshareSource);
	      }

	      $window.open(
	        urlString,
	        'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , managePinterestShare = function managePinterestShare($window, $location, attrs) {

	      $window.open(
	        'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl()) + '&media=' + encodeURIComponent(attrs.socialshareMedia) + '&description=' + encodeURIComponent(attrs.socialshareText)
	        , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageDiggShare = function manageDiggShare($window, $location, attrs) {

	      $window.open(
	        'https://www.digg.com/submit?url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl()) + '&title=' + encodeURIComponent(attrs.socialshareText)
	        , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageTumblrShare = function manageTumblrShare($window, $location, attrs) {

	      if (attrs.socialshareMedia) {
	        var urlString = 'https://www.tumblr.com/share/photo?source=' + encodeURIComponent(attrs.socialshareMedia);

	        if (attrs.socialshareText) {
	          urlString += '&caption=' + encodeURIComponent(attrs.socialshareText);
	        }

	        $window.open(
	          urlString,
	          'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      } else {

	        $window.open(
	          'https://www.tumblr.com/share/link?url=' + encodeURIComponent(attrs.socialshareUrl) + '&description=' + encodeURIComponent(attrs.socialshareText)
	          , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	          + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	      }
	    }
	    , manageVkShare = function manageVkShare($window, $location, attrs) {

	     $window.open(
	       'https://www.vk.com/share.php?url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl())
	       , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	       + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageDeliciousShare = function manageDeliciousShare($window, $location, attrs) {

	     $window.open(
	       'https://www.delicious.com/save?v=5&noui&jump=close&url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl()) + '&title=' + encodeURIComponent(attrs.socialshareText)
	       , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	       + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageBufferShare = function manageBufferShare($window, $location, attrs) {
	      var urlString = 'https://bufferapp.com/add?';

	      if (attrs.socialshareText) {
	        urlString += 'text=' + encodeURIComponent(attrs.socialshareText);
	      }

	      if (attrs.socialshareVia) {
	        urlString += '&via=' + encodeURIComponent(attrs.socialshareVia);
	      }

	      //default to the current page if a URL isn't specified
	      urlString += '&url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      $window.open(
	        urlString,
	        'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageHackernewsShare = function manageHackernewsShare($window, $location, attrs) {
	      var urlString = 'https://news.ycombinator.com/submitlink?';

	      if (attrs.socialshareText) {
	        urlString += 't=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }
	      //default to the current page if a URL isn't specified
	      urlString += 'u=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      $window.open(
	       urlString,
	       'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	      + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageFlipboardShare = function manageFlipboardShare($window, $location, attrs) {
	      var urlString = 'https://share.flipboard.com/bookmarklet/popout?v=2&';

	      if (attrs.socialshareText) {
	        urlString += 'title=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }

	      //default to the current page if a URL isn't specified
	      urlString += 'url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      $window.open(
	        urlString,
	        'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , managePocketShare = function managePocketShare($window, $location, attrs) {
	      var urlString = 'https://getpocket.com/save?';

	      if (attrs.socialshareText) {
	        urlString += 'text=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }

	      //default to the current page if a URL isn't specified
	      urlString += 'url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      $window.open(
	        urlString,
	        'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageWordpressShare = function manageWordpressShare($window, $location, attrs) {
	      var urlString = 'http://wordpress.com/press-this.php?';

	      if (attrs.socialshareText) {
	        urlString += 't=' + encodeURIComponent(attrs.socialshareText) + '&';
	      }
	      if (attrs.socialshareMedia) {
	        urlString += 'i=' + encodeURIComponent(attrs.socialshareMedia) + '&';
	      }

	      //default to the current page if a URL isn't specified
	      urlString += 'u=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      $window.open(
	        urlString,
	        'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageXingShare = function manageXingShare($window, $location, attrs) {
	      var followUrl = '';

	      if (attrs.socialshareFollow) {
	        followUrl = '&follow_url=' + encodeURIComponent(attrs.socialshareFollow);
	      }
	      $window.open(
	        'https://www.xing.com/spi/shares/new?url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl()) + followUrl
	        , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , manageEvernoteShare = function manageEvernoteShare($window, $location, attrs) {

	      var urlString = 'http://www.evernote.com/clip.action?url=' + encodeURIComponent(attrs.socialshareUrl || $location.absUrl());

	      if (attrs.socialshareText) {
	        urlString += '&title=' + encodeURIComponent(attrs.socialshareText);
	      }

	      $window.open(
	        urlString
	        , 'sharer', 'toolbar=0,status=0,width=' + attrs.socialsharePopupWidth + ',height=' + attrs.socialsharePopupHeight
	        + ',top=' + ($window.innerHeight - attrs.socialsharePopupHeight) / 2 + ',left=' + ($window.innerWidth - attrs.socialsharePopupWidth) / 2);
	    }
	    , facebookShare = manageFacebookShare
	    , twitterShare = manageTwitterShare
	    , googlePlusShare = manageGooglePlusShare
	    , redditShare = manageRedditShare
	    , stumbleuponShare = manageStumbleuponShare
	    , linkedinShare = manageLinkedinShare
	    , pinterestShare = managePinterestShare
	    , diggShare = manageDiggShare
	    , tumblrShare = manageTumblrShare
	    , vkShare = manageVkShare
	    , deliciousShare = manageDeliciousShare
	    , bufferShare = manageBufferShare
	    , hackernewsShare = manageHackernewsShare
	    , flipboardShare = manageFlipboardShare
	    , pocketShare = managePocketShare
	    , wordpressShare = manageWordpressShare
	    , xingShare = manageXingShare
	    , evernoteShare = manageEvernoteShare;


	  angular.module('720kb.socialshare', [])
	  .provider(directiveName + 'Conf', socialshareConfigurationProvider)
	  .directive(directiveName, socialshareDirective);
	}(angular));


/***/ },
/* 16 */
/***/ function(module, exports) {

	//
	// Copyright Kamil Pękala http://github.com/kamilkp
	// angular-sortable-view v0.0.13 2015/01/13
	//

	;(function(window, angular){
		'use strict';
		/* jshint eqnull:true */
		/* jshint -W041 */
		/* jshint -W030 */

		var module = angular.module('angular-sortable-view', []);
		module.directive('svRoot', [function(){
			function shouldBeAfter(elem, pointer, isGrid){
				return isGrid ? elem.x - pointer.x < 0 : elem.y - pointer.y < 0;
			}
			function getSortableElements(key){
				return ROOTS_MAP[key];
			}
			function removeSortableElements(key){
				delete ROOTS_MAP[key];
			}

			var sortingInProgress;
			var ROOTS_MAP = Object.create(null);
			// window.ROOTS_MAP = ROOTS_MAP; // for debug purposes

			return {
				restrict: 'A',
				controller: ['$scope', '$attrs', '$interpolate', '$parse', function($scope, $attrs, $interpolate, $parse){
					var mapKey = $interpolate($attrs.svRoot)($scope) || $scope.$id;
					if(!ROOTS_MAP[mapKey]) ROOTS_MAP[mapKey] = [];

					var that         = this;
					var candidates;  // set of possible destinations
					var $placeholder;// placeholder element
					var options;     // sortable options
					var $helper;     // helper element - the one thats being dragged around with the mouse pointer
					var $original;   // original element
					var $target;     // last best candidate
					var isGrid       = false;
					var onSort       = $parse($attrs.svOnSort);

					// ----- hack due to https://github.com/angular/angular.js/issues/8044
					$attrs.svOnStart = $attrs.$$element[0].attributes['sv-on-start'];
					$attrs.svOnStart = $attrs.svOnStart && $attrs.svOnStart.value;

					$attrs.svOnStop = $attrs.$$element[0].attributes['sv-on-stop'];
					$attrs.svOnStop = $attrs.svOnStop && $attrs.svOnStop.value;
					// -------------------------------------------------------------------

					var onStart = $parse($attrs.svOnStart);
					var onStop = $parse($attrs.svOnStop);

					this.sortingInProgress = function(){
						return sortingInProgress;
					};

					if($attrs.svGrid){ // sv-grid determined explicite
						isGrid = $attrs.svGrid === "true" ? true : $attrs.svGrid === "false" ? false : null;
						if(isGrid === null)
							throw 'Invalid value of sv-grid attribute';
					}
					else{
						// check if at least one of the lists have a grid like layout
						$scope.$watchCollection(function(){
							return getSortableElements(mapKey);
						}, function(collection){
							isGrid = false;
							var array = collection.filter(function(item){
								return !item.container;
							}).map(function(item){
								return {
									part: item.getPart().id,
									y: item.element[0].getBoundingClientRect().top
								};
							});
							var dict = Object.create(null);
							array.forEach(function(item){
								if(dict[item.part])
									dict[item.part].push(item.y);
								else
									dict[item.part] = [item.y];
							});
							Object.keys(dict).forEach(function(key){
								dict[key].sort();
								dict[key].forEach(function(item, index){
									if(index < dict[key].length - 1){
										if(item > 0 && item === dict[key][index + 1]){
											isGrid = true;
										}
									}
								});
							});
						});
					}

					this.$moveUpdate = function(opts, mouse, svElement, svOriginal, svPlaceholder, originatingPart, originatingIndex){
						var svRect = svElement[0].getBoundingClientRect();
						if(opts.tolerance === 'element')
							mouse = {
								x: ~~(svRect.left + svRect.width/2),
								y: ~~(svRect.top + svRect.height/2)
							};

						sortingInProgress = true;
						candidates = [];
						if(!$placeholder){
							if(svPlaceholder){ // custom placeholder
								$placeholder = svPlaceholder.clone();
								$placeholder.removeClass('ng-hide');
							}
							else{ // default placeholder
								$placeholder = svOriginal.clone();
								$placeholder.addClass('sv-visibility-hidden');
								$placeholder.addClass('sv-placeholder');
								$placeholder.css({
									'height': svRect.height + 'px',
									'width': svRect.width + 'px'
								});
							}

							svOriginal.after($placeholder);
							svOriginal.addClass('ng-hide');

							// cache options, helper and original element reference
							$original = svOriginal;
							options = opts;
							$helper = svElement;

							onStart($scope, {
								$helper: {element: $helper},
								$part: originatingPart.model(originatingPart.scope),
								$index: originatingIndex,
								$item: originatingPart.model(originatingPart.scope)[originatingIndex]
							});
							$scope.$root && $scope.$root.$$phase || $scope.$apply();
						}

						// ----- move the element
						$helper[0].reposition({
							x: mouse.x + document.body.scrollLeft - mouse.offset.x*svRect.width,
							y: mouse.y + document.body.scrollTop - mouse.offset.y*svRect.height
						});

						// ----- manage candidates
						getSortableElements(mapKey).forEach(function(se, index){
							if(opts.containment != null){
								// TODO: optimize this since it could be calculated only once when the moving begins
								if(
									!elementMatchesSelector(se.element, opts.containment) &&
									!elementMatchesSelector(se.element, opts.containment + ' *')
								) return; // element is not within allowed containment
							}
							var rect = se.element[0].getBoundingClientRect();
							var center = {
								x: ~~(rect.left + rect.width/2),
								y: ~~(rect.top + rect.height/2)
							};
							if(!se.container && // not the container element
								(se.element[0].scrollHeight || se.element[0].scrollWidth)){ // element is visible
								candidates.push({
									element: se.element,
									q: (center.x - mouse.x)*(center.x - mouse.x) + (center.y - mouse.y)*(center.y - mouse.y),
									view: se.getPart(),
									targetIndex: se.getIndex(),
									after: shouldBeAfter(center, mouse, isGrid)
								});
							}
							if(se.container && !se.element[0].querySelector('[sv-element]:not(.sv-placeholder):not(.sv-source)')){ // empty container
								candidates.push({
									element: se.element,
									q: (center.x - mouse.x)*(center.x - mouse.x) + (center.y - mouse.y)*(center.y - mouse.y),
									view: se.getPart(),
									targetIndex: 0,
									container: true
								});
							}
						});
						var pRect = $placeholder[0].getBoundingClientRect();
						var pCenter = {
							x: ~~(pRect.left + pRect.width/2),
							y: ~~(pRect.top + pRect.height/2)
						};
						candidates.push({
							q: (pCenter.x - mouse.x)*(pCenter.x - mouse.x) + (pCenter.y - mouse.y)*(pCenter.y - mouse.y),
							element: $placeholder,
							placeholder: true
						});
						candidates.sort(function(a, b){
							return a.q - b.q;
						});

						candidates.forEach(function(cand, index){
							if(index === 0 && !cand.placeholder && !cand.container){
								$target = cand;
								cand.element.addClass('sv-candidate');
								if(cand.after)
									cand.element.after($placeholder);
								else
									insertElementBefore(cand.element, $placeholder);
							}
							else if(index === 0 && cand.container){
								$target = cand;
								cand.element.append($placeholder);
							}
							else
								cand.element.removeClass('sv-candidate');
						});
					};

					this.$drop = function(originatingPart, index, options){
						if(!$placeholder) return;

						if(options.revert){
							var placeholderRect = $placeholder[0].getBoundingClientRect();
							var helperRect = $helper[0].getBoundingClientRect();
							var distance = Math.sqrt(
								Math.pow(helperRect.top - placeholderRect.top, 2) +
								Math.pow(helperRect.left - placeholderRect.left, 2)
							);

							var duration = +options.revert*distance/200; // constant speed: duration depends on distance
							duration = Math.min(duration, +options.revert); // however it's not longer that options.revert

							['-webkit-', '-moz-', '-ms-', '-o-', ''].forEach(function(prefix){
								if(typeof $helper[0].style[prefix + 'transition'] !== "undefined")
									$helper[0].style[prefix + 'transition'] = 'all ' + duration + 'ms ease';
							});
							setTimeout(afterRevert, duration);
							$helper.css({
								'top': placeholderRect.top + document.body.scrollTop + 'px',
								'left': placeholderRect.left + document.body.scrollLeft + 'px'
							});
						}
						else
							afterRevert();

						function afterRevert(){
							sortingInProgress = false;
							$placeholder.remove();
							$helper.remove();
							$original.removeClass('ng-hide');

							candidates = void 0;
							$placeholder = void 0;
							options = void 0;
							$helper = void 0;
							$original = void 0;

							// sv-on-stop callback
							onStop($scope, {
								$part: originatingPart.model(originatingPart.scope),
								$index: index,
								$item: originatingPart.model(originatingPart.scope)[index]
							});

							if($target){
								$target.element.removeClass('sv-candidate');
								var spliced = originatingPart.model(originatingPart.scope).splice(index, 1);
								var targetIndex = $target.targetIndex;
								if($target.view === originatingPart && $target.targetIndex > index)
									targetIndex--;
								if($target.after)
									targetIndex++;
								$target.view.model($target.view.scope).splice(targetIndex, 0, spliced[0]);

								// sv-on-sort callback
								if($target.view !== originatingPart || index !== targetIndex)
									onSort($scope, {
										$partTo: $target.view.model($target.view.scope),
										$partFrom: originatingPart.model(originatingPart.scope),
										$item: spliced[0],
										$indexTo: targetIndex,
										$indexFrom: index
									});

							}
							$target = void 0;

							$scope.$root && $scope.$root.$$phase || $scope.$apply();
						}
					};

					this.addToSortableElements = function(se){
						getSortableElements(mapKey).push(se);
					};
					this.removeFromSortableElements = function(se){
						var elems = getSortableElements(mapKey);
						var index = elems.indexOf(se);
						if(index > -1){
							elems.splice(index, 1);
							if(elems.length === 0)
								removeSortableElements(mapKey);
						}
					};
				}]
			};
		}]);

		module.directive('svPart', ['$parse', function($parse){
			return {
				restrict: 'A',
				require: '^svRoot',
				controller: ['$scope', function($scope){
					$scope.$ctrl = this;
					this.getPart = function(){
						return $scope.part;
					};
					this.$drop = function(index, options){
						$scope.$sortableRoot.$drop($scope.part, index, options);
					};
				}],
				scope: true,
				link: function($scope, $element, $attrs, $sortable){
					if(!$attrs.svPart) throw new Error('no model provided');
					var model = $parse($attrs.svPart);
					if(!model.assign) throw new Error('model not assignable');

					$scope.part = {
						id: $scope.$id,
						element: $element,
						model: model,
						scope: $scope
					};
					$scope.$sortableRoot = $sortable;

					var sortablePart = {
						element: $element,
						getPart: $scope.$ctrl.getPart,
						container: true
					};
					$sortable.addToSortableElements(sortablePart);
					$scope.$on('$destroy', function(){
						$sortable.removeFromSortableElements(sortablePart);
					});
				}
			};
		}]);

		module.directive('svElement', ['$parse', function($parse){
			return {
				restrict: 'A',
				require: ['^svPart', '^svRoot'],
				controller: ['$scope', function($scope){
					$scope.$ctrl = this;
				}],
				link: function($scope, $element, $attrs, $controllers){
					var sortableElement = {
						element: $element,
						getPart: $controllers[0].getPart,
						getIndex: function(){
							return $scope.$index;
						}
					};
					$controllers[1].addToSortableElements(sortableElement);
					$scope.$on('$destroy', function(){
						$controllers[1].removeFromSortableElements(sortableElement);
					});

					var handle = $element;
					handle.on('mousedown touchstart', onMousedown);
					$scope.$watch('$ctrl.handle', function(customHandle){
						if(customHandle){
							handle.off('mousedown touchstart', onMousedown);
							handle = customHandle;
							handle.on('mousedown touchstart', onMousedown);
						}
					});

					var helper;
					$scope.$watch('$ctrl.helper', function(customHelper){
						if(customHelper){
							helper = customHelper;
						}
					});

					var placeholder;
					$scope.$watch('$ctrl.placeholder', function(customPlaceholder){
						if(customPlaceholder){
							placeholder = customPlaceholder;
						}
					});

					var body = angular.element(document.body);
					var html = angular.element(document.documentElement);

					var moveExecuted;

					function onMousedown(e){
						touchFix(e);

						if($controllers[1].sortingInProgress()) return;
						if(e.button != 0 && e.type === 'mousedown') return;

						moveExecuted = false;
						var opts = $parse($attrs.svElement)($scope);
						opts = angular.extend({}, {
							tolerance: 'pointer',
							revert: 200,
							containment: 'html'
						}, opts);
						if(opts.containment){
							var containmentRect = closestElement.call($element, opts.containment)[0].getBoundingClientRect();
						}

						var target = $element;
						var clientRect = $element[0].getBoundingClientRect();
						var clone;

						if(!helper) helper = $controllers[0].helper;
						if(!placeholder) placeholder = $controllers[0].placeholder;
						if(helper){
							clone = helper.clone();
							clone.removeClass('ng-hide');
							clone.css({
								'left': clientRect.left + document.body.scrollLeft + 'px',
								'top': clientRect.top + document.body.scrollTop + 'px'
							});
							target.addClass('sv-visibility-hidden');
						}
						else{
							clone = target.clone();
							clone.addClass('sv-helper').css({
								'left': clientRect.left + document.body.scrollLeft + 'px',
								'top': clientRect.top + document.body.scrollTop + 'px',
								'width': clientRect.width + 'px'
							});
						}

						clone[0].reposition = function(coords){
							var targetLeft = coords.x;
							var targetTop = coords.y;
							var helperRect = clone[0].getBoundingClientRect();

							var body = document.body;

							if(containmentRect){
								if(targetTop < containmentRect.top + body.scrollTop) // top boundary
									targetTop = containmentRect.top + body.scrollTop;
								if(targetTop + helperRect.height > containmentRect.top + body.scrollTop + containmentRect.height) // bottom boundary
									targetTop = containmentRect.top + body.scrollTop + containmentRect.height - helperRect.height;
								if(targetLeft < containmentRect.left + body.scrollLeft) // left boundary
									targetLeft = containmentRect.left + body.scrollLeft;
								if(targetLeft + helperRect.width > containmentRect.left + body.scrollLeft + containmentRect.width) // right boundary
									targetLeft = containmentRect.left + body.scrollLeft + containmentRect.width - helperRect.width;
							}
							this.style.left = targetLeft - body.scrollLeft + 'px';
							this.style.top = targetTop - body.scrollTop + 'px';
						};

						var pointerOffset = {
							x: (e.clientX - clientRect.left)/clientRect.width,
							y: (e.clientY - clientRect.top)/clientRect.height
						};
						html.addClass('sv-sorting-in-progress');
						html.on('mousemove touchmove', onMousemove).on('mouseup touchend touchcancel', function mouseup(e){
							html.off('mousemove touchmove', onMousemove);
							html.off('mouseup touchend', mouseup);
							html.removeClass('sv-sorting-in-progress');
							if(moveExecuted)
								$controllers[0].$drop($scope.$index, opts);
							else
								$element.removeClass('sv-visibility-hidden');
						});

						// onMousemove(e);
						function onMousemove(e){
							touchFix(e);
							if(!moveExecuted){
								$element.parent().prepend(clone);
								moveExecuted = true;
							}
							$controllers[1].$moveUpdate(opts, {
								x: e.clientX,
								y: e.clientY,
								offset: pointerOffset
							}, clone, $element, placeholder, $controllers[0].getPart(), $scope.$index);
						}
					}
				}
			};
		}]);

		module.directive('svHandle', function(){
			return {
				require: '?^svElement',
				link: function($scope, $element, $attrs, $ctrl){
					if($ctrl)
						$ctrl.handle = $element.add($ctrl.handle); // support multiple handles
				}
			};
		});

		module.directive('svHelper', function(){
			return {
				require: ['?^svPart', '?^svElement'],
				link: function($scope, $element, $attrs, $ctrl){
					$element.addClass('sv-helper').addClass('ng-hide');
					if($ctrl[1])
						$ctrl[1].helper = $element;
					else if($ctrl[0])
						$ctrl[0].helper = $element;
				}
			};
		});

		module.directive('svPlaceholder', function(){
			return {
				require: ['?^svPart', '?^svElement'],
				link: function($scope, $element, $attrs, $ctrl){
					$element.addClass('sv-placeholder').addClass('ng-hide');
					if($ctrl[1])
						$ctrl[1].placeholder = $element;
					else if($ctrl[0])
						$ctrl[0].placeholder = $element;
				}
			};
		});

		angular.element(document.head).append([
			'<style>' +
			'.sv-helper{' +
				'position: fixed !important;' +
				'z-index: 99999;' +
				'margin: 0 !important;' +
			'}' +
			'.sv-candidate{' +
			'}' +
			'.sv-placeholder{' +
				// 'opacity: 0;' +
			'}' +
			'.sv-sorting-in-progress{' +
				'-webkit-user-select: none;' +
				'-moz-user-select: none;' +
				'-ms-user-select: none;' +
				'user-select: none;' +
			'}' +
			'.sv-visibility-hidden{' +
				'visibility: hidden !important;' +
				'opacity: 0 !important;' +
			'}' +
			'</style>'
		].join(''));

		function touchFix(e){
			if(!('clientX' in e) && !('clientY' in e)) {
				var touches = e.touches || e.originalEvent.touches;
				if(touches && touches.length) {
					e.clientX = touches[0].clientX;
					e.clientY = touches[0].clientY;
				}
				e.preventDefault();
			}
		}

		function getPreviousSibling(element){
			element = element[0];
			if(element.previousElementSibling)
				return angular.element(element.previousElementSibling);
			else{
				var sib = element.previousSibling;
				while(sib != null && sib.nodeType != 1)
					sib = sib.previousSibling;
				return angular.element(sib);
			}
		}

		function insertElementBefore(element, newElement){
			var prevSibl = getPreviousSibling(element);
			if(prevSibl.length > 0){
				prevSibl.after(newElement);
			}
			else{
				element.parent().prepend(newElement);
			}
		}

		var dde = document.documentElement,
		matchingFunction = dde.matches ? 'matches' :
							dde.matchesSelector ? 'matchesSelector' :
							dde.webkitMatches ? 'webkitMatches' :
							dde.webkitMatchesSelector ? 'webkitMatchesSelector' :
							dde.msMatches ? 'msMatches' :
							dde.msMatchesSelector ? 'msMatchesSelector' :
							dde.mozMatches ? 'mozMatches' :
							dde.mozMatchesSelector ? 'mozMatchesSelector' : null;
		if(matchingFunction == null)
			throw 'This browser doesn\'t support the HTMLElement.matches method';

		function elementMatchesSelector(element, selector){
			if(element instanceof angular.element) element = element[0];
			if(matchingFunction !== null)
				return element[matchingFunction](selector);
		}

		var closestElement = angular.element.prototype.closest || function (selector){
			var el = this[0].parentNode;
			while(el !== document.documentElement && !el[matchingFunction](selector))
				el = el.parentNode;

			if(el[matchingFunction](selector))
				return angular.element(el);
			else
				return angular.element();
		};

		/*
			Simple implementation of jQuery's .add method
		 */
		if(typeof angular.element.prototype.add !== 'function'){
			angular.element.prototype.add = function(elem){
				var i, res = angular.element();
				elem = angular.element(elem);
				for(i=0;i<this.length;i++){
					res.push(this[i]);
				}
				for(i=0;i<elem.length;i++){
					res.push(elem[i]);
				}
				return res;
			};
		}

	})(window, window.angular);

/***/ },
/* 17 */
/***/ function(module, exports) {

	(function() {
	  'use strict';

	  angular.module('toastr', [])
	    .factory('toastr', toastr);

	  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];

	  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
	    var container;
	    var index = 0;
	    var toasts = [];

	    var previousToastMessage = '';
	    var openToasts = {};

	    var containerDefer = $q.defer();

	    var toast = {
	      active: active,
	      clear: clear,
	      error: error,
	      info: info,
	      remove: remove,
	      success: success,
	      warning: warning,
	      refreshTimer: refreshTimer
	    };

	    return toast;

	    /* Public API */
	    function active() {
	      return toasts.length;
	    }

	    function clear(toast) {
	      // Bit of a hack, I will remove this soon with a BC
	      if (arguments.length === 1 && !toast) { return; }

	      if (toast) {
	        remove(toast.toastId);
	      } else {
	        for (var i = 0; i < toasts.length; i++) {
	          remove(toasts[i].toastId);
	        }
	      }
	    }

	    function error(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.error;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function info(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.info;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function success(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.success;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function warning(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.warning;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function refreshTimer(toast, newTime) {
	      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
	          toast.scope.refreshTimer(newTime);
	      }
	    }

	    function remove(toastId, wasClicked) {
	      var toast = findToast(toastId);

	      if (toast && ! toast.deleting) { // Avoid clicking when fading out
	        toast.deleting = true;
	        toast.isOpened = false;
	        $animate.leave(toast.el).then(function() {
	          if (toast.scope.options.onHidden) {
	            toast.scope.options.onHidden(!!wasClicked, toast);
	          }
	          toast.scope.$destroy();
	          var index = toasts.indexOf(toast);
	          delete openToasts[toast.scope.message];
	          toasts.splice(index, 1);
	          var maxOpened = toastrConfig.maxOpened;
	          if (maxOpened && toasts.length >= maxOpened) {
	            toasts[maxOpened - 1].open.resolve();
	          }
	          if (lastToast()) {
	            container.remove();
	            container = null;
	            containerDefer = $q.defer();
	          }
	        });
	      }

	      function findToast(toastId) {
	        for (var i = 0; i < toasts.length; i++) {
	          if (toasts[i].toastId === toastId) {
	            return toasts[i];
	          }
	        }
	      }

	      function lastToast() {
	        return !toasts.length;
	      }
	    }

	    /* Internal functions */
	    function _buildNotification(type, message, title, optionsOverride) {
	      if (angular.isObject(title)) {
	        optionsOverride = title;
	        title = null;
	      }

	      return _notify({
	        iconClass: type,
	        message: message,
	        optionsOverride: optionsOverride,
	        title: title
	      });
	    }

	    function _getOptions() {
	      return angular.extend({}, toastrConfig);
	    }

	    function _createOrGetContainer(options) {
	      if(container) { return containerDefer.promise; }

	      container = angular.element('<div></div>');
	      container.attr('id', options.containerId);
	      container.addClass(options.positionClass);
	      container.css({'pointer-events': 'auto'});

	      var target = angular.element(document.querySelector(options.target));

	      if ( ! target || ! target.length) {
	        throw 'Target for toasts doesn\'t exist';
	      }

	      $animate.enter(container, target).then(function() {
	        containerDefer.resolve();
	      });

	      return containerDefer.promise;
	    }

	    function _notify(map) {
	      var options = _getOptions();

	      if (shouldExit()) { return; }

	      var newToast = createToast();

	      toasts.push(newToast);

	      if (ifMaxOpenedAndAutoDismiss()) {
	        var oldToasts = toasts.slice(0, (toasts.length - options.maxOpened));
	        for (var i = 0, len = oldToasts.length; i < len; i++) {
	          remove(oldToasts[i].toastId);
	        }
	      }

	      if (maxOpenedNotReached()) {
	        newToast.open.resolve();
	      }

	      newToast.open.promise.then(function() {
	        _createOrGetContainer(options).then(function() {
	          newToast.isOpened = true;
	          if (options.newestOnTop) {
	            $animate.enter(newToast.el, container).then(function() {
	              newToast.scope.init();
	            });
	          } else {
	            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
	            $animate.enter(newToast.el, container, sibling).then(function() {
	              newToast.scope.init();
	            });
	          }
	        });
	      });

	      return newToast;

	      function ifMaxOpenedAndAutoDismiss() {
	        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
	      }

	      function createScope(toast, map, options) {
	        if (options.allowHtml) {
	          toast.scope.allowHtml = true;
	          toast.scope.title = $sce.trustAsHtml(map.title);
	          toast.scope.message = $sce.trustAsHtml(map.message);
	        } else {
	          toast.scope.title = map.title;
	          toast.scope.message = map.message;
	        }

	        toast.scope.toastType = toast.iconClass;
	        toast.scope.toastId = toast.toastId;
	        toast.scope.extraData = options.extraData;

	        toast.scope.options = {
	          extendedTimeOut: options.extendedTimeOut,
	          messageClass: options.messageClass,
	          onHidden: options.onHidden,
	          onShown: generateEvent('onShown'),
	          onTap: generateEvent('onTap'),
	          progressBar: options.progressBar,
	          tapToDismiss: options.tapToDismiss,
	          timeOut: options.timeOut,
	          titleClass: options.titleClass,
	          toastClass: options.toastClass
	        };

	        if (options.closeButton) {
	          toast.scope.options.closeHtml = options.closeHtml;
	        }

	        function generateEvent(event) {
	          if (options[event]) {
	            return function() {
	              options[event](toast);
	            };
	          }
	        }
	      }

	      function createToast() {
	        var newToast = {
	          toastId: index++,
	          isOpened: false,
	          scope: $rootScope.$new(),
	          open: $q.defer()
	        };
	        newToast.iconClass = map.iconClass;
	        if (map.optionsOverride) {
	          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
	          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
	        }

	        createScope(newToast, map, options);

	        newToast.el = createToastEl(newToast.scope);

	        return newToast;

	        function cleanOptionsOverride(options) {
	          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop',
	                            'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
	          for (var i = 0, l = badOptions.length; i < l; i++) {
	            delete options[badOptions[i]];
	          }

	          return options;
	        }
	      }

	      function createToastEl(scope) {
	        var angularDomEl = angular.element('<div toast></div>'),
	          $compile = $injector.get('$compile');
	        return $compile(angularDomEl)(scope);
	      }

	      function maxOpenedNotReached() {
	        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
	      }

	      function shouldExit() {
	        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
	        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];

	        if (isDuplicateOfLast || isDuplicateOpen) {
	          return true;
	        }

	        previousToastMessage = map.message;
	        openToasts[map.message] = true;

	        return false;
	      }
	    }
	  }
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .constant('toastrConfig', {
	      allowHtml: false,
	      autoDismiss: false,
	      closeButton: false,
	      closeHtml: '<button>&times;</button>',
	      containerId: 'toast-container',
	      extendedTimeOut: 1000,
	      iconClasses: {
	        error: 'toast-error',
	        info: 'toast-info',
	        success: 'toast-success',
	        warning: 'toast-warning'
	      },
	      maxOpened: 0,
	      messageClass: 'toast-message',
	      newestOnTop: true,
	      onHidden: null,
	      onShown: null,
	      onTap: null,
	      positionClass: 'toast-top-right',
	      preventDuplicates: false,
	      preventOpenDuplicates: false,
	      progressBar: false,
	      tapToDismiss: true,
	      target: 'body',
	      templates: {
	        toast: 'directives/toast/toast.html',
	        progressbar: 'directives/progressbar/progressbar.html'
	      },
	      timeOut: 5000,
	      titleClass: 'toast-title',
	      toastClass: 'toast'
	    });
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .directive('progressBar', progressBar);

	  progressBar.$inject = ['toastrConfig'];

	  function progressBar(toastrConfig) {
	    return {
	      require: '^toast',
	      templateUrl: function() {
	        return toastrConfig.templates.progressbar;
	      },
	      link: linkFunction
	    };

	    function linkFunction(scope, element, attrs, toastCtrl) {
	      var intervalId, currentTimeOut, hideTime;

	      toastCtrl.progressBar = scope;

	      scope.start = function(duration) {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }

	        currentTimeOut = parseFloat(duration);
	        hideTime = new Date().getTime() + currentTimeOut;
	        intervalId = setInterval(updateProgress, 10);
	      };

	      scope.stop = function() {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	      };

	      function updateProgress() {
	        var percentage = ((hideTime - (new Date().getTime())) / currentTimeOut) * 100;
	        element.css('width', percentage + '%');
	      }

	      scope.$on('$destroy', function() {
	        // Failsafe stop
	        clearInterval(intervalId);
	      });
	    }
	  }
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .controller('ToastController', ToastController);

	  function ToastController() {
	    this.progressBar = null;

	    this.startProgressBar = function(duration) {
	      if (this.progressBar) {
	        this.progressBar.start(duration);
	      }
	    };

	    this.stopProgressBar = function() {
	      if (this.progressBar) {
	        this.progressBar.stop();
	      }
	    };
	  }
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .directive('toast', toast);

	  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];

	  function toast($injector, $interval, toastrConfig, toastr) {
	    return {
	      templateUrl: function() {
	        return toastrConfig.templates.toast;
	      },
	      controller: 'ToastController',
	      link: toastLinkFunction
	    };

	    function toastLinkFunction(scope, element, attrs, toastCtrl) {
	      var timeout;

	      scope.toastClass = scope.options.toastClass;
	      scope.titleClass = scope.options.titleClass;
	      scope.messageClass = scope.options.messageClass;
	      scope.progressBar = scope.options.progressBar;

	      if (wantsCloseButton()) {
	        var button = angular.element(scope.options.closeHtml),
	          $compile = $injector.get('$compile');
	        button.addClass('toast-close-button');
	        button.attr('ng-click', 'close(true, $event)');
	        $compile(button)(scope);
	        element.children().prepend(button);
	      }

	      scope.init = function() {
	        if (scope.options.timeOut) {
	          timeout = createTimeout(scope.options.timeOut);
	        }
	        if (scope.options.onShown) {
	          scope.options.onShown();
	        }
	      };

	      element.on('mouseenter', function() {
	        hideAndStopProgressBar();
	        if (timeout) {
	          $interval.cancel(timeout);
	        }
	      });

	      scope.tapToast = function () {
	        if (angular.isFunction(scope.options.onTap)) {
	          scope.options.onTap();
	        }
	        if (scope.options.tapToDismiss) {
	          scope.close(true);
	        }
	      };

	      scope.close = function (wasClicked, $event) {
	        if ($event && angular.isFunction($event.stopPropagation)) {
	          $event.stopPropagation();
	        }
	        toastr.remove(scope.toastId, wasClicked);
	      };
	      
	      scope.refreshTimer = function(newTime) {
	        if (timeout) {
	          $interval.cancel(timeout);
	          timeout = createTimeout(newTime || scope.options.timeOut);
	        }
	      };

	      element.on('mouseleave', function() {
	        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) { return; }
	        scope.$apply(function() {
	          scope.progressBar = scope.options.progressBar;
	        });
	        timeout = createTimeout(scope.options.extendedTimeOut);
	      });

	      function createTimeout(time) {
	        toastCtrl.startProgressBar(time);
	        return $interval(function() {
	          toastCtrl.stopProgressBar();
	          toastr.remove(scope.toastId);
	        }, time, 1);
	      }

	      function hideAndStopProgressBar() {
	        scope.progressBar = false;
	        toastCtrl.stopProgressBar();
	      }

	      function wantsCloseButton() {
	        return scope.options.closeHtml;
	      }
	    }
	  }
	}());

	angular.module("toastr").run(["$templateCache", function($templateCache) {$templateCache.put("directives/progressbar/progressbar.html","<div class=\"toast-progress\"></div>\n");
	$templateCache.put("directives/toast/toast.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");}]);

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(17);
	module.exports = 'toastr';



/***/ },
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppComponent = undefined;

	var _app = __webpack_require__(121);

	var _app2 = _interopRequireDefault(_app);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AppComponent = exports.AppComponent = {
	  templateUrl: _app2.default,
	  selector: 'app',
	  bindings: {},
	  controller:
	  /* @ngInject */
	  ["$state", function AppCtrl($state) {
	    _classCallCheck(this, AppCtrl);

	    Object.assign(this, { $state: $state });
	  }]
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(110);

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularUiRouter = __webpack_require__(5);

	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

	var _angularAnimate = __webpack_require__(6);

	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

	var _angularSanitize = __webpack_require__(10);

	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

	var _angularUiBootstrap = __webpack_require__(8);

	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

	var _angularToastr = __webpack_require__(18);

	var _angularToastr2 = _interopRequireDefault(_angularToastr);

	var _angularLocalStorage = __webpack_require__(7);

	var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _components = __webpack_require__(29);

	var _components2 = _interopRequireDefault(_components);

	var _app = __webpack_require__(21);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(115);
	__webpack_require__(90);
	// import Angular2To1 from 'angular2to1';

	/*eslint-disable */

	/*eslint-enable */


	_angular2.default.module('echoes', [
	// framework wide components
	_angularUiRouter2.default, _angularAnimate2.default, _angularSanitize2.default, _angularUiBootstrap2.default, _angularToastr2.default,

	// services
	'LocalStorageModule', _core2.default,

	// ui-components
	_components2.default
	// '720kb.socialshare',
	]).config(config).component(_app.AppComponent.selector, _app.AppComponent);

	/* @ngInject */
	function config($stateProvider, $urlRouterProvider, localStorageServiceProvider, GapiApiSetterProvider, toastrConfig) {
	  GapiApiSetterProvider.config({
	    scope: 'youtube',
	    api: {
	      client: 'youtube',
	      version: 'v3'
	    },
	    clientId: '971861197531'
	  });

	  localStorageServiceProvider.setPrefix('EchoesPlayer');

	  $stateProvider.state('videos', {
	    url: '/',
	    template: '<youtube-videos></youtube-videos>'
	  });

	  $urlRouterProvider.otherwise('/');

	  _angular2.default.extend(toastrConfig, {
	    allowHtml: true,
	    extendedTimeOut: 10000,
	    iconClasses: {
	      error: 'toast-error',
	      info: 'toast-info',
	      success: 'toast-success',
	      warning: 'toast-warning'
	    },
	    messageClass: 'toast-message',
	    progressBar: true,
	    tapToDismiss: true,
	    positionClass: 'toast-bottom-right',
	    // templates: {
	    //   toast: 'directives/toast/toast.html',
	    //   progressbar: 'directives/progressbar/progressbar.html'
	    // },
	    timeOut: 10000,
	    titleClass: 'toast-title',
	    toastClass: 'toast'
	  });
	}
	config.$inject = ["$stateProvider", "$urlRouterProvider", "localStorageServiceProvider", "GapiApiSetterProvider", "toastrConfig"];

	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, [("echoes")]);
	});

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = drawerClosed;
	/* @ngInject */
	function drawerClosed(DrawerSettings) {
	    // Usage:
	    //	<button drawer-closed="css-class-to-apply-when-closed" drawer-not-closed="css-to-apply"></button>
	    // Creates:
	    //	an action which will toggle the drawer
	    var directive = {
	        link: link,
	        restrict: 'A'
	    };
	    return directive;

	    function link(scope, element, attrs) {
	        var cssClosed = attrs.drawerClosed;
	        var cssNotClosed = attrs.drawerNotClosed;
	        scope.drawerOpened = DrawerSettings.opened;
	        scope.$watch('drawerOpened()', function (nState, oldState) {
	            if (nState !== oldState) {
	                addStateAsClass(nState);
	            }
	        });

	        addStateAsClass();

	        function addStateAsClass() {
	            element.toggleClass(cssClosed, !DrawerSettings.opened()).toggleClass(cssNotClosed, DrawerSettings.opened());
	        }
	    }
	}
	drawerClosed.$inject = ["DrawerSettings"];

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DrawerSettings;
	/* @ngInject */
	function DrawerSettings() {
	    var isOpen = true;
	    var service = {
	        toggle: toggle,
	        opened: opened
	    };
	    return service;

	    ////////////////

	    function toggle() {
	        isOpen = !isOpen;
	    }

	    function opened() {
	        return isOpen;
	    }
	}

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = drawerToggle;
	/* @ngInject */
	function drawerToggle(DrawerSettings) {
	    // Usage:
	    //	<button drawer-toggle="css-class-to-apply" drawer-content="dom-selector"></button>
	    // Creates:
	    //	an action which will toggle the drawer
	    // drawer-toggle - a css class to apply to this element
	    // drawer-content - a selector to apply the drawer-toggle class to
	    var directive = {
	        link: link,
	        restrict: 'A'
	    };
	    return directive;

	    function link(scope, element, attrs) {
	        var cssClassToApply = attrs.drawerToggle;
	        // var drawerContent =
	        element.bind('click', function (ev) {
	            ev.preventDefault();
	            DrawerSettings.toggle();
	            if (cssClassToApply && cssClassToApply.length) {
	                addStateAsClass();
	            }
	            scope.$apply();
	        });

	        addStateAsClass();

	        function addStateAsClass() {
	            element.toggleClass(cssClassToApply, DrawerSettings.opened());
	        }
	    }
	}
	drawerToggle.$inject = ["DrawerSettings"];

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _drawerSettingsService = __webpack_require__(24);

	var _drawerSettingsService2 = _interopRequireDefault(_drawerSettingsService);

	var _drawerToggle = __webpack_require__(25);

	var _drawerToggle2 = _interopRequireDefault(_drawerToggle);

	var _drawerClosed = __webpack_require__(23);

	var _drawerClosed2 = _interopRequireDefault(_drawerClosed);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('drawer', ['app.core']).factory('DrawerSettings', _drawerSettingsService2.default).directive('drawerToggle', _drawerToggle2.default).directive('drawerClosed', _drawerClosed2.default).name;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FeedFilterComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(91);

	var _feedFilterTpl = __webpack_require__(122);

	var _feedFilterTpl2 = _interopRequireDefault(_feedFilterTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// Usage:
	//	<feed-filter></feed-filter>
	var FeedFilterComponent = exports.FeedFilterComponent = {
	    templateUrl: _feedFilterTpl2.default,
	    controllerAs: 'vm',
	    scope: {},
	    bindToController: true,
	    replace: true,
	    restrict: 'E',
	    /* @ngInject */
	    controller: function () {
	        /* @ngInject */
	        function FeedFilterCtrl(YoutubeSearch) {
	            _classCallCheck(this, FeedFilterCtrl);

	            Object.assign(this, { YoutubeSearch: YoutubeSearch });
	            this.data = {
	                items: [{ label: 'Videos', icon: 'film', value: 'video' }, { label: 'Playlists', icon: 'th-list', value: 'playlist' }]
	            };
	            var activeFeedType = this.YoutubeSearch.getFeedType();
	            this.active = this.data.items.find(function (item) {
	                return item.value === activeFeedType;
	            });
	        }
	        FeedFilterCtrl.$inject = ["YoutubeSearch"];

	        _createClass(FeedFilterCtrl, [{
	            key: 'setFeed',
	            value: function setFeed(item) {
	                this.active = item;
	                this.YoutubeSearch.setType(item.value);
	                this.YoutubeSearch.search();
	            }
	        }]);

	        return FeedFilterCtrl;
	    }()
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _feedFilterComponent = __webpack_require__(27);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('feed-filter', [_core2.default, 'LocalStorageModule']).directive('feedFilter', function () {
		return _feedFilterComponent.FeedFilterComponent;
	});

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _youtubeVideos = __webpack_require__(66);

	var _youtubeVideos2 = _interopRequireDefault(_youtubeVideos);

	var _searchPanel = __webpack_require__(47);

	var _searchPanel2 = _interopRequireDefault(_searchPanel);

	var _youtubePlayer = __webpack_require__(11);

	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);

	var _nowPlaying = __webpack_require__(32);

	var _nowPlaying2 = _interopRequireDefault(_nowPlaying);

	var _userProfile = __webpack_require__(51);

	var _userProfile2 = _interopRequireDefault(_userProfile);

	var _drawer = __webpack_require__(26);

	var _drawer2 = _interopRequireDefault(_drawer);

	var _playlistEditor = __webpack_require__(9);

	var _playlistEditor2 = _interopRequireDefault(_playlistEditor);

	var _youtubeVideo = __webpack_require__(64);

	var _youtubeVideo2 = _interopRequireDefault(_youtubeVideo);

	var _userPlaylists = __webpack_require__(49);

	var _userPlaylists2 = _interopRequireDefault(_userPlaylists);

	var _playlistViewer = __webpack_require__(43);

	var _playlistViewer2 = _interopRequireDefault(_playlistViewer);

	var _navigator = __webpack_require__(30);

	var _navigator2 = _interopRequireDefault(_navigator);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('app.components', [_youtubeVideos2.default, _searchPanel2.default, _youtubePlayer2.default, _nowPlaying2.default, _userProfile2.default, _drawer2.default, _playlistEditor2.default, _youtubeVideo2.default, _userPlaylists2.default, _playlistViewer2.default, _navigator2.default]).name;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _navigator = __webpack_require__(31);

	Object.keys(_navigator).forEach(function (key) {
		if (key === "default" || key === "__esModule") return;
		Object.defineProperty(exports, key, {
			enumerable: true,
			get: function get() {
				return _navigator[key];
			}
		});
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('navigator', []).config(config).component(_navigator.NavigatorComponent.selector, _navigator.NavigatorComponent).name;
	/* @ngInject */

	function config() {}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavigatorComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(92);

	var _navigatorTpl = __webpack_require__(123);

	var _navigatorTpl2 = _interopRequireDefault(_navigatorTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NavigatorComponent = exports.NavigatorComponent = {
	  templateUrl: _navigatorTpl2.default,
	  selector: 'navigator',
	  controller: function () {
	    /* @ngInject */
	    function NavigatorCtrl($rootScope) {
	      _classCallCheck(this, NavigatorCtrl);

	      // Object.assign(this, { });
	      this.views = [{ label: 'Explore', icon: 'music', active: true, ref: 'explore', rules: ['videos', '', 'video', 'explore'] }, { label: 'My Playlists', icon: 'heart', active: false, ref: 'myPlaylists', rules: ['myPlaylists', 'playlist'] }];
	      $rootScope.$on('$stateChangeStart', this.handleStateChange.bind(this));
	    }
	    NavigatorCtrl.$inject = ["$rootScope"];

	    _createClass(NavigatorCtrl, [{
	      key: 'handleStateChange',
	      value: function handleStateChange(event, toState, toParams, fromState, fromParams, options) {
	        var currentState = toState.name;
	        this.views.forEach(function (view) {
	          return view.active = false;
	        });
	        this.views.filter(function (view) {
	          return view.rules.some(function (route) {
	            return route === currentState;
	          });
	        }).map(function (view) {
	          return view.active = true;
	        });
	      }
	    }]);

	    return NavigatorCtrl;
	  }()
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _nowPlaying = __webpack_require__(33);

	var _nowPlaylist = __webpack_require__(36);

	var _nowPlaylist2 = _interopRequireDefault(_nowPlaylist);

	var _nowPlaylistFilter = __webpack_require__(34);

	var _nowPlaylistFilter2 = _interopRequireDefault(_nowPlaylistFilter);

	var _playlistSaver = __webpack_require__(38);

	var _playlistSaver2 = _interopRequireDefault(_playlistSaver);

	var _youtubePlayer = __webpack_require__(11);

	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('now-playing', [_core2.default, _nowPlaylist2.default.name, _nowPlaylistFilter2.default.name, _playlistSaver2.default, _youtubePlayer2.default]).config(config).component(_nowPlaying.nowPlayingComponent.selector, _nowPlaying.nowPlayingComponent).name;
	/* @ngInject */

	function config() {}

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nowPlayingComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _nowPlayingTpl = __webpack_require__(124);

	var _nowPlayingTpl2 = _interopRequireDefault(_nowPlayingTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// Usage:
	//  <now-playling></now-playling>
	// Creates:
	//  a top level (SMART/Container) component for managing now playing playlist
	var nowPlayingComponent = exports.nowPlayingComponent = {
	  templateUrl: _nowPlayingTpl2.default,
	  selector: 'nowPlaying',
	  controller: function () {
	    /* @ngInject */
	    function NowPlayingCtrl(YoutubePlayerSettings, UserPlaylists, MediaInfoService) {
	      _classCallCheck(this, NowPlayingCtrl);

	      Object.assign(this, { YoutubePlayerSettings: YoutubePlayerSettings, UserPlaylists: UserPlaylists, MediaInfoService: MediaInfoService });
	      this.playlist = YoutubePlayerSettings.nowPlaylist;
	      this.nowPlaying = YoutubePlayerSettings.nowPlaying;
	      this.playlistSearch = '';
	      this.showPlaylistSaver = false;
	    }
	    NowPlayingCtrl.$inject = ["YoutubePlayerSettings", "UserPlaylists", "MediaInfoService"];

	    _createClass(NowPlayingCtrl, [{
	      key: 'removeVideo',
	      value: function removeVideo($event, video, $index) {
	        $event.stopPropagation();
	        this.YoutubePlayerSettings.remove(video, $index);
	      }
	    }, {
	      key: 'playVideo',
	      value: function playVideo(video, index) {
	        this.nowPlaying.index = index;
	        this.YoutubePlayerSettings.playVideoId(video);
	      }
	    }, {
	      key: 'togglePlaylistSaver',
	      value: function togglePlaylistSaver() {
	        this.showPlaylistSaver = !this.showPlaylistSaver;
	      }
	    }, {
	      key: 'onPlaylistSave',
	      value: function onPlaylistSave() {
	        this.togglePlaylistSaver();
	        this.UserPlaylists.list();
	      }
	    }, {
	      key: 'updateIndex',
	      value: function updateIndex($item, $indexTo) {
	        if ($item.id === this.nowPlaying.media.id) {
	          this.nowPlaying.index = $indexTo;
	        }
	      }
	    }, {
	      key: 'clearPlaylist',
	      value: function clearPlaylist() {
	        this.YoutubePlayerSettings.clear();
	      }
	    }, {
	      key: 'onFilterChange',
	      value: function onFilterChange(filter) {
	        this.playlistSearch = filter;
	      }
	    }, {
	      key: 'isPlaylistMedia',
	      value: function isPlaylistMedia(video) {
	        var description = video.snippet.description;
	        var hasTracks = this.MediaInfoService.textHasTracks(description);
	        return hasTracks;
	      }
	    }]);

	    return NowPlayingCtrl;
	  }()
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _nowPlaylistFilterComponent = __webpack_require__(35);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('now-playlist-filter', []).component(_nowPlaylistFilterComponent.nowPlaylistFilter.selector, _nowPlaylistFilterComponent.nowPlaylistFilter);

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nowPlaylistFilter = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(93);

	var _nowPlaylistFilterTpl = __webpack_require__(125);

	var _nowPlaylistFilterTpl2 = _interopRequireDefault(_nowPlaylistFilterTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// Usage:
	//  <now-playlist-filter></now-playlist-filter>
	var nowPlaylistFilter = exports.nowPlaylistFilter = {
	  templateUrl: _nowPlaylistFilterTpl2.default,
	  selector: 'nowPlaylistFilter',
	  bindings: {
	    playlist: '=',
	    onSave: '&',
	    onClear: '&',
	    onChange: '&'
	  },
	  controller: function () {
	    /* @ngInject */
	    function NowPlaylistFilterCtrl() {
	      _classCallCheck(this, NowPlaylistFilterCtrl);

	      this.playlistSearch = '';
	      this.showPlaylistSaver = false;
	    }

	    _createClass(NowPlaylistFilterCtrl, [{
	      key: 'isSearchFilled',
	      value: function isSearchFilled() {
	        return this.playlistSearch.length === 0;
	      }

	      // more args: $event , video, $index

	    }, {
	      key: 'clearPlaylist',
	      value: function clearPlaylist($event) {
	        this.onClear && this.onClear($event);
	      }
	    }, {
	      key: 'togglePlaylistSaver',
	      value: function togglePlaylistSaver() {
	        this.showPlaylistSaver = !this.showPlaylistSaver;
	        this.onSave && this.onSave({ save: this.showPlaylistSaver });
	      }
	    }, {
	      key: 'sortVideo',
	      value: function sortVideo($item, $indexTo) {
	        this.onSort && this.onSort({ $item: $item, $indexTo: $indexTo });
	      }
	    }, {
	      key: 'handleFilterChange',
	      value: function handleFilterChange(playlistSearch) {
	        this.onChange && this.onChange({ filter: playlistSearch });
	      }
	    }, {
	      key: 'clearFilter',
	      value: function clearFilter() {
	        this.playlistSearch = '';
	        this.handleFilterChange(this.playlistSearch);
	      }
	    }]);

	    return NowPlaylistFilterCtrl;
	  }()
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularSortableView = __webpack_require__(16);

	var _angularSortableView2 = _interopRequireDefault(_angularSortableView);

	var _nowPlaylist = __webpack_require__(37);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* eslint-disable */
	exports.default = _angular2.default.module('now-playlist', ['angular-sortable-view']).config(config).component(_nowPlaylist.NowPlaylistComponent.selector, _nowPlaylist.NowPlaylistComponent);
	/* @ngInject */

	/* eslint-enable */

	function config() {}

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NowPlaylistComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(94);

	var _nowPlaylistTpl = __webpack_require__(126);

	var _nowPlaylistTpl2 = _interopRequireDefault(_nowPlaylistTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NowPlaylistComponent = exports.NowPlaylistComponent = {
	  templateUrl: _nowPlaylistTpl2.default,
	  selector: 'nowPlaylist',
	  controllerAs: 'nowPlaylist',

	  bindings: {
	    videos: '<',
	    filter: '<',
	    nowPlaying: '<',
	    onSelect: '&',
	    onRemove: '&',
	    onSort: '&',
	    showPlaylistTrack: '&'
	  },
	  controller: function () {
	    /* @ngInject */
	    function NowPlaylistCtrl() {
	      _classCallCheck(this, NowPlaylistCtrl);

	      // injected with this.videos, this.onRemove, this.onSelect
	      this.showPlaylistSaver = false;
	    }

	    _createClass(NowPlaylistCtrl, [{
	      key: 'isPlaylistMedia',
	      value: function isPlaylistMedia(video) {
	        return this.showPlaylistTrack({ video: video });
	      }
	    }, {
	      key: 'removeVideo',
	      value: function removeVideo($event, video, $index) {
	        this.onRemove && this.onRemove({ $event: $event, video: video, $index: $index });
	      }
	    }, {
	      key: 'selectVideo',
	      value: function selectVideo(video, $index) {
	        this.onSelect && this.onSelect({ video: video, $index: $index });
	      }
	    }, {
	      key: 'sortVideo',
	      value: function sortVideo($item, $indexTo) {
	        this.onSort && this.onSort({ $item: $item, $indexTo: $indexTo });
	      }
	    }]);

	    return NowPlaylistCtrl;
	  }()
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
			value: true
	});

	var _playlistSaver = __webpack_require__(40);

	Object.keys(_playlistSaver).forEach(function (key) {
			if (key === "default" || key === "__esModule") return;
			Object.defineProperty(exports, key, {
					enumerable: true,
					get: function get() {
							return _playlistSaver[key];
					}
			});
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _playlistSaverSettingsSrv = __webpack_require__(39);

	var _playlistSaverSettingsSrv2 = _interopRequireDefault(_playlistSaverSettingsSrv);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('playlist-saver', ['app.core']).service('PlaylistSaverSettings', _playlistSaverSettingsSrv2.default).component(_playlistSaver.PlaylistSaverComponent.selector, _playlistSaver.PlaylistSaverComponent).name;

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var logError = function logError(error) {
	  return console.log(error);
	};
	/* @ngInject */

	var PlaylistSaverSettings = function () {

	  /* @ngInject */
	  function PlaylistSaverSettings(UserPlaylists, ApiPlaylists, $q) {
	    _classCallCheck(this, PlaylistSaverSettings);

	    Object.assign(this, { UserPlaylists: UserPlaylists, ApiPlaylists: ApiPlaylists, $q: $q });
	    this.playlist = {
	      title: '',
	      id: '',
	      description: ''
	    };
	    this.index = 0;
	    this.totalTracks;
	    this.defer;
	    this._tracks;
	  }
	  PlaylistSaverSettings.$inject = ["UserPlaylists", "ApiPlaylists", "$q"];

	  _createClass(PlaylistSaverSettings, [{
	    key: 'save',
	    value: function save(tracks) {
	      var _this = this;

	      this._tracks = tracks;
	      var params = {
	        part: 'snippet,contentDetails',
	        resource: {
	          snippet: {
	            title: this.playlist.title,
	            description: this.playlist.description || ''
	          }
	        }
	      };
	      return this.ApiPlaylists.insert(params).then(function (response) {
	        _this.playlist.id = response.result.id;
	        return _this.addTracks(tracks).then(function () {
	          return _this.reset();
	        }, logError);
	      });
	    }
	  }, {
	    key: 'addTracks',
	    value: function addTracks(tracks) {
	      return this._addTrack(tracks[0], 0);
	    }
	  }, {
	    key: '_addTrack',
	    value: function _addTrack(media, index) {
	      var _this2 = this;

	      return this.UserPlaylists.addToPlaylist(this.playlist.id, media, index).then(function () {
	        return _this2._addNextIndex(index);
	      }, logError);
	    }
	  }, {
	    key: '_addNextIndex',
	    value: function _addNextIndex(index) {
	      var nextIndex = index + 1;
	      if (nextIndex < this._tracks.length) {
	        return this._addTrack(this._tracks[nextIndex], nextIndex);
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.playlist.id = '';
	      this.playlist.title = '';
	      this.playlist.description = '';
	    }
	  }]);

	  return PlaylistSaverSettings;
	}();

	exports.default = PlaylistSaverSettings;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlaylistSaverComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(95);

	var _playlistSaverTpl = __webpack_require__(127);

	var _playlistSaverTpl2 = _interopRequireDefault(_playlistSaverTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PlaylistSaverComponent = exports.PlaylistSaverComponent = {
	  selector: 'playlistSaver',
	  templateUrl: _playlistSaverTpl2.default,
	  bindings: {
	    onSave: '&?',
	    onCancel: '&?',
	    tracks: '='
	  },
	  controller: function () {
	    /* @ngInject */
	    function PlaylistSaverCtrl(PlaylistSaverSettings, toastr) {
	      _classCallCheck(this, PlaylistSaverCtrl);

	      Object.assign(this, { PlaylistSaverSettings: PlaylistSaverSettings, toastr: toastr });
	      this.playlist = PlaylistSaverSettings.playlist;
	      this.inSaveMode = false;
	    }
	    PlaylistSaverCtrl.$inject = ["PlaylistSaverSettings", "toastr"];

	    _createClass(PlaylistSaverCtrl, [{
	      key: 'save',
	      value: function save() {
	        this.inSaveMode = true;
	        this.PlaylistSaverSettings.save(this.tracks).then(onSuccess.bind(this), onFail.bind(this));

	        function onSuccess(playlistId) {
	          this.onSave({ playlistId: playlistId });
	          this.inSaveMode = false;
	          this.toastr.success('Tracks saved to playlist!');
	        }

	        function onFail(response) {
	          console.log('failed to save tracks to playlist', response);
	        }
	      }
	    }]);

	    return PlaylistSaverCtrl;
	  }()
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.playlistEditorComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(96);

	var _playlistEditorTpl = __webpack_require__(128);

	var _playlistEditorTpl2 = _interopRequireDefault(_playlistEditorTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var playlistEditorComponent = exports.playlistEditorComponent = {
	  templateUrl: _playlistEditorTpl2.default,
	  selector: 'playlistEditor',
	  bindings: {},
	  controller: function () {
	    /* @ngInject */
	    function PlaylistEditorCtrl(PlaylistEditorSettings, UserPlaylists, GapiLoader, YoutubeUser, $window) {
	      _classCallCheck(this, PlaylistEditorCtrl);

	      Object.assign(this, { PlaylistEditorSettings: PlaylistEditorSettings, UserPlaylists: UserPlaylists, GapiLoader: GapiLoader, YoutubeUser: YoutubeUser, $window: $window });
	      this.playlists = this.UserPlaylists.tracks;
	      this.search = '';
	      this.showCreate = false;
	    }
	    PlaylistEditorCtrl.$inject = ["PlaylistEditorSettings", "UserPlaylists", "GapiLoader", "YoutubeUser", "$window"];

	    _createClass(PlaylistEditorCtrl, [{
	      key: 'add',
	      value: function add(playlist) {
	        playlist.inProcess = true;
	        this.UserPlaylists.addToPlaylist(playlist.id, this.PlaylistEditorSettings.getMedia()).then(function (response) {
	          if (response.status === 200) {
	            playlist.contentDetails.itemCount++;
	            playlist.inProcess = false;
	          }
	        });
	      }
	    }, {
	      key: 'signIn',
	      value: function signIn() {
	        var _this = this;

	        var options = {
	          immediate: false,
	          loadClientApi: false
	        };
	        return this.GapiLoader.auth(options).then(function (res) {
	          _this.YoutubeUser.signIn(res);
	          _this.UserPlaylists.list();
	        });
	      }
	    }, {
	      key: 'create',
	      value: function create() {
	        var _this2 = this;

	        // TODO - add description
	        if (!gapi.auth.getToken()) {
	          return this.signIn().then(function () {
	            return _this2.UserPlaylists.createPlaylist(_this2.search, '');
	          });
	        }
	        this.UserPlaylists.createPlaylist(this.search, '');
	      }
	    }, {
	      key: 'remove',
	      value: function remove(playlist) {
	        playlist.inProcess = true;
	        // TODO - should check the response for errors and notify the user
	        return this.UserPlaylists.removePlaylist(playlist.id).then(function (response) {
	          return playlist.inProcess = false;
	        });
	      }
	    }, {
	      key: 'isPlaylistNameExists',
	      value: function isPlaylistNameExists() {
	        var allTitles = this.playlists.map(function (playlist) {
	          return playlist.snippet.title.toLowerCase();
	        }).join(' ');
	        this.showCreate = allTitles.indexOf(this.search) === -1;
	      }
	    }, {
	      key: 'hide',
	      value: function hide() {
	        // this.PlaylistEditorSettings.hide();
	        this.$window.history.back();
	      }
	    }]);

	    return PlaylistEditorCtrl;
	  }()
	};

/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PlaylistEditorSettings = function () {
	    /* @ngInject */
	    function PlaylistEditorSettings(UserPlaylists, $uibModal) {
	        _classCallCheck(this, PlaylistEditorSettings);

	        this.currentMedia;
	        this.modalInstance;
	        this.$modal = $uibModal;
	    }
	    PlaylistEditorSettings.$inject = ["UserPlaylists", "$uibModal"];

	    _createClass(PlaylistEditorSettings, [{
	        key: 'add',
	        value: function add(media) {
	            this.currentMedia = media;
	        }
	    }, {
	        key: 'getMedia',
	        value: function getMedia() {
	            return this.currentMedia;
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.modalInstance.dismiss('cancel');
	        }
	    }, {
	        key: 'clearMedia',
	        value: function clearMedia() {
	            this.currentMedia = false;
	        }
	    }, {
	        key: 'visibility',
	        value: function visibility() {
	            return this.isVisible;
	        }
	    }]);

	    return PlaylistEditorSettings;
	}();

	exports.default = PlaylistEditorSettings;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _playlistViewer = __webpack_require__(44);

	Object.keys(_playlistViewer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _playlistViewer[key];
	    }
	  });
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularUiRouter = __webpack_require__(5);

	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _playlistEditor = __webpack_require__(9);

	var _playlistEditor2 = _interopRequireDefault(_playlistEditor);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('playlist-viewer', [_core2.default, _angularUiRouter2.default, _playlistEditor2.default]).config(config).component(_playlistViewer.PlaylistViewerComponent.selector, _playlistViewer.PlaylistViewerComponent).name;
	/* @ngInject */

	function config($stateProvider) {
	  $stateProvider.state('playlist', {
	    url: '/playlist/:playlistId/:backState',
	    template: '<playlist-viewer videos="vm.videos" playlist="vm.playlist" back="{{:: vm.backState}}"></playlist-viewer>',
	    controller: function controller(videos, playlist, $stateParams, toastr) {
	      this.backState = $stateParams.backState;
	      this.videos = videos;
	      this.playlist = playlist[0];
	      toastr.clear(playlist._toast);
	    },
	    controllerAs: 'vm',
	    resolve: {
	      videos: getPlaylistVideos,
	      playlist: getPlaylistInfo
	    }
	  });
	}
	config.$inject = ["$stateProvider"];

	/* ngInject */
	function getPlaylistVideos($stateParams, YoutubeVideoInfo, PlaylistInfo, YoutubeUser) {
	  var playlistId = $stateParams.playlistId;
	  return YoutubeUser.isUserSignedIn() ? YoutubeVideoInfo.getPlaylist(playlistId) : PlaylistInfo.list(playlistId);
	}

	/* @ngInject */
	function getPlaylistInfo($stateParams, YoutubePlaylistInfo, toastr) {
	  var _toast = toastr.info('', '<i class="fa fa-refresh fa-spin fa-3x"></i> Loading Playlist...', {
	    iconClass: 'toast-loader'
	  });
	  return YoutubePlaylistInfo.list($stateParams.playlistId).then(function (items) {
	    items._toast = _toast;
	    return items;
	  });
	}
	getPlaylistInfo.$inject = ["$stateParams", "YoutubePlaylistInfo", "toastr"];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlaylistViewerComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(97);

	var _playlistViewerTpl = __webpack_require__(129);

	var _playlistViewerTpl2 = _interopRequireDefault(_playlistViewerTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PlaylistViewerComponent = exports.PlaylistViewerComponent = {
	  templateUrl: _playlistViewerTpl2.default,
	  selector: 'playlistViewer',
	  bindings: {
	    videos: '=',
	    playlist: '=',
	    back: '@'
	  },
	  controller: function () {
	    /* @ngInject */
	    function PlaylistViewerCtrl($state, YoutubePlayerSettings, PlaylistEditorSettings) {
	      _classCallCheck(this, PlaylistViewerCtrl);

	      Object.assign(this, { $state: $state, YoutubePlayerSettings: YoutubePlayerSettings, PlaylistEditorSettings: PlaylistEditorSettings });
	    }
	    PlaylistViewerCtrl.$inject = ["$state", "YoutubePlayerSettings", "PlaylistEditorSettings"];

	    _createClass(PlaylistViewerCtrl, [{
	      key: 'playVideo',
	      value: function playVideo(video) {
	        this.YoutubePlayerSettings.queuePlaylist(this.videos);
	        this.YoutubePlayerSettings.playVideoId(video);
	      }
	    }, {
	      key: 'playPlaylist',
	      value: function playPlaylist() {
	        this.playVideo(this.videos[0]);
	      }
	    }, {
	      key: 'queueVideo',
	      value: function queueVideo(video) {
	        this.YoutubePlayerSettings.queueVideo(video);
	      }
	    }, {
	      key: 'queuePlaylist',
	      value: function queuePlaylist(playlist) {
	        this.YoutubePlayerSettings.queuePlaylist(playlist);
	      }
	    }, {
	      key: 'addVideo',
	      value: function addVideo(video) {
	        this.PlaylistEditorSettings.add(video);
	        this.$state.go('addVideo', { id: video.id });
	      }
	    }, {
	      key: 'goBack',
	      value: function goBack() {
	        this.$state.go(this.back);
	      }
	    }]);

	    return PlaylistViewerCtrl;
	  }()
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _searchFilterPanel = __webpack_require__(46);

	Object.keys(_searchFilterPanel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _searchFilterPanel[key];
	    }
	  });
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('search-filter-panel', [_core2.default, 'LocalStorageModule']).component(_searchFilterPanel.SearchFilterPanelComponent.selector, _searchFilterPanel.SearchFilterPanelComponent).name;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchFilterPanelComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _searchFilterPanel = __webpack_require__(130);

	var _searchFilterPanel2 = _interopRequireDefault(_searchFilterPanel);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SearchFilterPanelComponent = exports.SearchFilterPanelComponent = {
	  templateUrl: _searchFilterPanel2.default,
	  selector: 'searchPanelFilter',
	  bindings: {},
	  controller: function () {
	    /* @ngInject */
	    function SearchPanelFilterCtrl(preset, YoutubeSearch) {
	      _classCallCheck(this, SearchPanelFilterCtrl);

	      // Object.assign(this, ...arguments);
	      this.YoutubeSearch = YoutubeSearch;
	      this.preset = preset;
	      // TODO: preset - should be moved to a service/reducer
	      this.data = {
	        label: 'Preset'
	      };
	      this.presets = preset.items;
	      this.selected = preset.selected().index;
	      // TODO: duration - should be moved to a service/reducer
	      this.durations = ['Any', 'Short (less then 4 minutes)', 'Medium (4-20 minutes)', 'Long (longer than 20 minutes)'];
	      this.durationsMap = ['', 'short', 'medium', 'long'];
	    }
	    SearchPanelFilterCtrl.$inject = ["preset", "YoutubeSearch"];

	    _createClass(SearchPanelFilterCtrl, [{
	      key: 'updatePreset',
	      value: function updatePreset(presetValue) {
	        this.YoutubeSearch.setPreset(presetValue);
	        this.YoutubeSearch.resetPageToken();
	        this.YoutubeSearch.search(false, false);
	      }
	    }, {
	      key: 'onDurationChange',
	      value: function onDurationChange(duration, index) {
	        this.YoutubeSearch.setType(this.YoutubeSearch.types.VIDEO);
	        this.YoutubeSearch.setDuration(this.durationsMap[index]);
	        this.YoutubeSearch.resetPageToken();
	        this.YoutubeSearch.search(false, false);
	      }
	    }]);

	    return SearchPanelFilterCtrl;
	  }()
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _searchPanelComponent = __webpack_require__(48);

	Object.keys(_searchPanelComponent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _searchPanelComponent[key];
	    }
	  });
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('search-panel', [_core2.default]).config(config).component(_searchPanelComponent.SearchPanelComponent.selector, _searchPanelComponent.SearchPanelComponent).name;
	/* @ngInject */

	function config() {}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchPanelComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(98);

	var _searchPanelTpl = __webpack_require__(131);

	var _searchPanelTpl2 = _interopRequireDefault(_searchPanelTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/* @ngInject */
	var SearchPanelComponent = exports.SearchPanelComponent = {
	  templateUrl: _searchPanelTpl2.default,
	  selector: 'searchPanel',
	  bindings: {},
	  controller: function () {
	    /* @ngInject */
	    function SearchPanelCtrl($http, $q, $window, YoutubeSearch) {
	      _classCallCheck(this, SearchPanelCtrl);

	      /*jshint validthis: true */
	      Object.assign(this, { $http: $http, $q: $q, $window: $window, YoutubeSearch: YoutubeSearch });

	      this.params = YoutubeSearch.params;
	      this.resetPageToken = YoutubeSearch.resetPageToken;
	      this.search = YoutubeSearch.search;
	    }
	    SearchPanelCtrl.$inject = ["$http", "$q", "$window", "YoutubeSearch"];

	    _createClass(SearchPanelCtrl, [{
	      key: 'updateSearch',
	      value: function updateSearch($item, $model, $label) {
	        this.YoutubeSearch.search();
	      }
	    }, {
	      key: 'complete',
	      value: function complete(val) {
	        var defered = this.$q.defer();
	        this.$window.handleEchoesSuggest = handleEchoesSuggest;

	        var config = {
	          params: {
	            hl: 'en',
	            ds: 'yt',
	            // oi: 'spell',
	            // spell: '1',
	            xhr: 't',
	            client: 'youtube',
	            q: val,
	            callback: 'handleEchoesSuggest'
	          }
	        };
	        var request = this.$http.jsonp('http://suggestqueries.google.com/complete/search', config);

	        return defered.promise;

	        function handleEchoesSuggest(res) {
	          var suggestions = res[1].map(function (result) {
	            return result[0];
	          }).sort();
	          if (suggestions.indexOf(val) === -1) {
	            suggestions.splice(1, 0, val);
	          }
	          defered.resolve(suggestions);
	        }
	      }
	    }]);

	    return SearchPanelCtrl;
	  }()
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularUiRouter = __webpack_require__(5);

	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

	var _angularAnimate = __webpack_require__(6);

	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _userPlaylists = __webpack_require__(50);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('user-playlists', [_core2.default, _angularUiRouter2.default, _angularAnimate2.default]).config(config).directive(_userPlaylists.UserPlaylistsComponent.controllerAs, function () {
		return _userPlaylists.UserPlaylistsComponent;
	}).name;
	/* @ngInject */

	function config($stateProvider) {
		$stateProvider.state('myPlaylists', {
			url: '/myPlaylists',
			template: '<user-playlists></user-playlists>'
			// templateUrl: 'app/my-playlists/my-playlists.tpl.html',
			// controller: 'MyPlaylistsController',
			// controllerAs: 'vm'
		});

		// .state('/playlist/:playlistId', {
		//     templateUrl: 'app/my-playlists/my-playlist.tpl.html',
		//     controller: 'MyPlaylistCtrl',
		//     controllerAs: 'vm',
		//     resolve: {
		//         videos: getPlaylistVideos,
		//         playlist: getPlaylistInfo
		//     }
		// });
	}
	config.$inject = ["$stateProvider"];

	/* ngInject */
	function getPlaylistVideos($route, YoutubeVideoInfo, PlaylistInfo, YoutubeUser) {
		var playlistId = $route.current.params.playlistId;
		return YoutubeUser.isSignedIn() ? YoutubeVideoInfo.getPlaylist(playlistId) : PlaylistInfo.list(playlistId);
	}

	/* @ngInject */
	function getPlaylistInfo($route, YoutubePlaylistInfo) {
		return YoutubePlaylistInfo.list($route.current.params.playlistId);
	}
	getPlaylistInfo.$inject = ["$route", "YoutubePlaylistInfo"];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserPlaylistsComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(99);

	var _userPlaylistsTpl = __webpack_require__(132);

	var _userPlaylistsTpl2 = _interopRequireDefault(_userPlaylistsTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UserPlaylistsComponent = exports.UserPlaylistsComponent = {
	  templateUrl: _userPlaylistsTpl2.default,
	  selector: 'user-playlists',
	  controllerAs: 'userPlaylists',
	  scope: {},
	  bindToController: true,
	  replace: true,
	  restrict: 'E',
	  controller: function () {
	    /* @ngInject */
	    function UserPlaylistsCtrl($http, YoutubePlayerSettings, UserPlaylists, YoutubeVideoInfo, YoutubeUser, toastr) {
	      var _this = this;

	      _classCallCheck(this, UserPlaylistsCtrl);

	      Object.assign(this, { YoutubePlayerSettings: YoutubePlayerSettings, YoutubeVideoInfo: YoutubeVideoInfo, YoutubeUser: YoutubeUser });
	      this.title = 'UserPlaylistsCtrl';
	      this.playlists = UserPlaylists.tracks;
	      this.search = '';
	      this.data = YoutubeUser.data;
	      this._toastr = toastr.info('', '<i class="fa fa-refresh fa-spin fa-3x"></i> Loading Playlists...', {
	        iconClass: 'toast-loader'
	      });
	      UserPlaylists.list().then(function () {
	        return toastr.clear(_this._toastr);
	      });
	    }
	    UserPlaylistsCtrl.$inject = ["$http", "YoutubePlayerSettings", "UserPlaylists", "YoutubeVideoInfo", "YoutubeUser", "toastr"];

	    _createClass(UserPlaylistsCtrl, [{
	      key: 'playPlaylist',
	      value: function playPlaylist(playlist) {
	        this.YoutubeVideoInfo.getPlaylist(playlist.id).then(this.YoutubePlayerSettings.playPlaylist);
	      }
	    }, {
	      key: 'isUserSignedIn',
	      value: function isUserSignedIn() {
	        return this.YoutubeUser.isUserSignedIn();
	      }
	    }]);

	    return UserPlaylistsCtrl;
	  }()
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _userProfileComponent = __webpack_require__(52);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('user-profile', ['app.core'
	// 'google.api.loader',
	// 'youtube.api',
	// 'google-signin'
	]).component(_userProfileComponent.userProfile.selector, _userProfileComponent.userProfile).name;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userProfile = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(100);

	var _userProfileTpl = __webpack_require__(133);

	var _userProfileTpl2 = _interopRequireDefault(_userProfileTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// Usage:
	//  <user-profile></user-profile>
	var userProfile = exports.userProfile = {
	  selector: 'userProfile',
	  templateUrl: _userProfileTpl2.default,
	  controllerAs: 'userProfile',
	  controller: function () {
	    /* @ngInject */
	    function UserProfileCtrl(GapiLoader, YoutubeUser, UserPlaylists, $window) {
	      _classCallCheck(this, UserProfileCtrl);

	      Object.assign(this, { GapiLoader: GapiLoader, YoutubeUser: YoutubeUser, UserPlaylists: UserPlaylists, $window: $window });
	      this.data = YoutubeUser.data;
	      if (!YoutubeUser.isUserSignedIn()) {
	        this.signIn();
	      }
	    }
	    UserProfileCtrl.$inject = ["GapiLoader", "YoutubeUser", "UserPlaylists", "$window"];

	    _createClass(UserProfileCtrl, [{
	      key: 'signIn',
	      value: function signIn(options) {
	        var _this = this;

	        this.GapiLoader.auth(options).then(function (res) {
	          // debugger
	          _this.YoutubeUser.signIn(res);
	          _this.UserPlaylists.list();
	        });
	      }
	    }, {
	      key: 'signInDialog',
	      value: function signInDialog() {
	        var options = {
	          immediate: false,
	          loadClientApi: false
	        };
	        this.signIn(options);
	      }
	    }, {
	      key: 'signOut',
	      value: function signOut() {
	        this.GapiLoader.signOut().then(this.YoutubeUser.signOut).then(this.UserPlaylists.clearPlaylists);
	      }
	    }, {
	      key: 'reload',
	      value: function reload() {
	        this.$window.location.reload();
	      }
	    }]);

	    return UserProfileCtrl;
	  }()
	};

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MediaInfoService;
	/* @ngInject */
	function MediaInfoService(YoutubeVideoInfo) {
	  var info = {
	    title: 'No Media Is Playing Yet...',
	    desc: 'More information about the played video is displayed here...',
	    thumb: '',
	    id: ''
	  };

	  var service = {
	    info: info,
	    parseTimeTracks: parseTimeTracks,
	    updateVideo: updateVideo,
	    fetchInfo: fetchInfo,
	    textHasTracks: textHasTracks
	  };

	  var hasTracksRegexp = new RegExp('(([0-9]{0,1}[0-9]):([0-9][0-9]){1,2}:{0,1}([0-9][0-9]){0,1})', 'gm');
	  return service;

	  ////////////////
	  function fetchInfo(video) {
	    YoutubeVideoInfo.list(video.id).then(updateVideo);
	  }

	  function updateVideo(items) {
	    if (items && items.length) {
	      info.id = items[0].id;
	      info.title = items[0].snippet.title;
	      info.desc = parseTimeTracks(items[0].snippet.description);
	      info.thumb = items[0].snippet.thumbnails.high.url;
	    }
	  }

	  // parse multiline tracks to single
	  // add buttons for time stops to allow playing of single tracks
	  // in full albums in one video
	  function parseTimeTracks(description) {
	    var desc = description.replace(hasTracksRegexp, '<a class="btn btn-primary btn-mini play-time" time="$1">$1</a>', 'gim');
	    return desc;
	  }

	  function textHasTracks(text) {
	    var tracks = text.match(hasTracksRegexp);
	    return Array.isArray(tracks);
	  }
	}
	MediaInfoService.$inject = ["YoutubeVideoInfo"];

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _mediaInfo = __webpack_require__(55);

	Object.keys(_mediaInfo).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mediaInfo[key];
	    }
	  });
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('media-info', []).component(_mediaInfo.MediaInfoComponent.selector, _mediaInfo.MediaInfoComponent).name;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MediaInfoComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(101);

	var _mediaInfo = __webpack_require__(134);

	var _mediaInfo2 = _interopRequireDefault(_mediaInfo);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MediaInfoComponent = exports.MediaInfoComponent = {
	  templateUrl: _mediaInfo2.default,
	  selector: 'mediaInfo',
	  bindings: {
	    video: '=',
	    onSeekChange: '&',
	    onThumbClick: '&',
	    thumbTitle: '@'
	  },
	  controller: function () {
	    /* @ngInject */
	    function MediaInfoCtrl() {
	      // Object.assign(this, ...arguments);
	      // nothing

	      _classCallCheck(this, MediaInfoCtrl);
	    }

	    _createClass(MediaInfoCtrl, [{
	      key: 'seekToSeconds',
	      value: function seekToSeconds($event) {
	        var text = $event.target.innerText;
	        var isTime = $event.target.classList.contains('play-time');

	        // isTime && this.YoutubePlayerSettings.seekToSeconds(text);
	        if (isTime) {
	          this.onSeekChange({ seconds: text });
	        }
	      }
	    }, {
	      key: 'hasContent',
	      value: function hasContent() {
	        return this.video.thumb !== '';
	      }
	    }, {
	      key: 'getUrlToVideo',
	      value: function getUrlToVideo() {
	        var prefix = '#/video/';
	        var videoId = this.video.id;
	        return videoId ? '' + prefix + videoId : undefined;
	      }
	    }]);

	    return MediaInfoCtrl;
	  }()
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _playerControls = __webpack_require__(57);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('player-controls', []).directive(_playerControls.PlayerControlsComponent.directiveSelector, function () {
		return _playerControls.PlayerControlsComponent;
	}).name;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PlayerControlsComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(102);

	var _playerControls = __webpack_require__(135);

	var _playerControls2 = _interopRequireDefault(_playerControls);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PlayerControlsComponent = exports.PlayerControlsComponent = {
		templateUrl: _playerControls2.default,
		selector: 'player-controls',
		// add ng1 directive definition
		directiveSelector: 'playerControls',
		controllerAs: '$ctrl',
		scope: {
			'onShowPlayer': '&',
			'onPlayPrevious': '&',
			'onPause': '&',
			'onPlay': '&',
			'onPlayNext': '&',
			'onAdd': '&',
			'playlist': '=',
			'playlistIndex': '='
		},
		bindToController: true,
		replace: true,
		restrict: 'E',
		controller: function () {
			/* @ngInject */
			function PlayerControlsCtrl() {
				_classCallCheck(this, PlayerControlsCtrl);

				// Object.assign(this, ...arguments);
				this.States = {
					ADD: 'add',
					PLAY: 'play',
					PAUSE: 'pause',
					PLAY_NEXT: 'play-next',
					PLAY_PREVIOUS: 'play-previous',
					SHOW_PLAYER: 'show-player'
				};
			}

			_createClass(PlayerControlsCtrl, [{
				key: 'handleOnAction',
				value: function handleOnAction(action) {
					switch (action) {
						case this.States.SHOW_PLAYER:
							return this.onShowPlayer();

						case this.States.PLAY_PREVIOUS:
							return this.onPlayPrevious();

						case this.States.PAUSE:
							return this.onPause();

						case this.States.PLAY:
							return this.onPlay();

						case this.States.PLAY_NEXT:
							return this.onPlayNext();

						case this.States.ADD:
							return this.onAdd();

						default:
							return action;
					}
				}
			}, {
				key: 'playlistHasTracks',
				value: function playlistHasTracks() {
					return this.playlistIndex > 0 && !this.playlistIsEmpty();
				}
			}, {
				key: 'playlistIsEmpty',
				value: function playlistIsEmpty() {
					return this.playlist.length === 0;
				}
			}, {
				key: 'playlistHasOneTrack',
				value: function playlistHasOneTrack() {
					return this.playlist.length === 1;
				}
			}]);

			return PlayerControlsCtrl;
		}()
	};

/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = playerResizer;
	/* @ngInject */
	function playerResizer(PlayerResizer) {
	    // Usage:
	    //	<div player-resize="fullscreen-or-css-classname"></div>
	    // Creates:
	    //
	    var directive = {
	        link: link,
	        restrict: 'A'
	    };
	    return directive;

	    /* @ngInject */
	    function link(scope, element, attrs) {
	        scope.$watch('isFullScreen()', function (newVal, oldVal) {
	            if (newVal !== oldVal) {
	                element.toggleClass(attrs.playerResizer, newVal);
	            }
	        });

	        scope.isFullScreen = function () {
	            return PlayerResizer.isFullScreen();
	        };
	    }
	    link.$inject = ["scope", "element", "attrs"];
	}
	playerResizer.$inject = ["PlayerResizer"];

/***/ },
/* 59 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PlayerResizer;
	/* @ngInject */
	function PlayerResizer($window) {
	    var defaultSizes = {
	        height: 270,
	        width: 367
	    };
	    var isFull = false;
	    var service = {
	        height: defaultSizes.height,
	        width: defaultSizes.width,
	        setFullScreen: setFullScreen,
	        isFullScreen: isFullScreen
	    };
	    return service;

	    ////////////////
	    function setFullScreen(isFullScreen) {
	        isFull = isFullScreen;
	        if (!isFullScreen) {
	            service.height = defaultSizes.height;
	            service.width = defaultSizes.width;
	            return;
	        }
	        var excludes = ['sidebar'];
	        var sidebar = excludes.indexOf('sidebar') === -1 ? $('.sidebar').outerWidth() : 0;
	        var height = $window.innerHeight; // - $('#youtube-player-container').outerHeight();
	        var width = $window.innerWidth - sidebar;
	        service.height = height;
	        service.width = width;
	    }

	    function isFullScreen() {
	        return isFull;
	    }
	}
	PlayerResizer.$inject = ["$window"];

/***/ },
/* 60 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/* @ngInject */
	var YoutubePlayerApi = function () {

	    /* @ngInject */
	    function YoutubePlayerApi($window, $q) {
	        var _this = this;

	        _classCallCheck(this, YoutubePlayerApi);

	        /*jshint validthis: true */
	        this.deferred = $q.defer();
	        // Youtube callback when API is ready
	        $window.onYouTubeIframeAPIReady = function () {
	            _this.deferred.resolve();
	        };
	    }
	    YoutubePlayerApi.$inject = ["$window", "$q"];

	    // Injects YouTube's iFrame API


	    _createClass(YoutubePlayerApi, [{
	        key: 'load',
	        value: function load() {
	            var validProtocols = ['http:', 'https:'];
	            var url = '//www.youtube.com/iframe_api';

	            // We'd prefer a protocol relative url, but let's
	            // fallback to `http:` for invalid protocols
	            if (validProtocols.indexOf(window.location.protocol) < 0) {
	                url = 'http:' + url;
	            }
	            var tag = document.createElement('script');
	            tag.src = url;
	            var firstScriptTag = document.getElementsByTagName('script')[0];
	            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	            return this.deferred.promise;
	        }
	    }]);

	    return YoutubePlayerApi;
	}();

	exports.default = YoutubePlayerApi;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YoutubePlayerComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(103);

	var _youtubePlayerTpl = __webpack_require__(136);

	var _youtubePlayerTpl2 = _interopRequireDefault(_youtubePlayerTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var YoutubePlayerComponent = exports.YoutubePlayerComponent = {
	  templateUrl: _youtubePlayerTpl2.default,
	  selector: 'youtubePlayer',
	  bindings: {
	    playerId: '@',
	    autoNext: '@',
	    onVideoStart: '&'
	  },
	  controller: function () {
	    /* @ngInject */
	    function YoutubePlayerCtrl(YoutubePlayerSettings, PlayerResizer, MediaInfoService, $state, YoutubePlayerApi, $scope) {
	      _classCallCheck(this, YoutubePlayerCtrl);

	      Object.assign(this, { YoutubePlayerSettings: YoutubePlayerSettings, PlayerResizer: PlayerResizer, MediaInfoService: MediaInfoService, $state: $state, YoutubePlayerApi: YoutubePlayerApi, $scope: $scope });
	      this.video = YoutubePlayerSettings.nowPlaying;
	      this.nowPlaylist = YoutubePlayerSettings.nowPlaylist;
	      this.size = PlayerResizer;
	      this.showPlayer = YoutubePlayerSettings.showPlayer;
	      this.isFullScreen = false;
	      this.seek = YoutubePlayerSettings.getSeek;
	      this.playNextTrack = YoutubePlayerSettings.playNextTrack;
	      this.playPreviousTrack = YoutubePlayerSettings.playPreviousTrack;
	      this.play = YoutubePlayerSettings.play;
	      this.pause = YoutubePlayerSettings.pause;
	      this.videoInfo = MediaInfoService.info;
	      this.shares = [{ title: 'Share To Google+', provider: 'google+', icon: 'fa fa-google-plus-square', color: 'danger' }, { title: 'Share To Twitter', provider: 'twitter', icon: 'fa fa-twitter-square', color: 'info' }, { title: 'Share To Facebook', provider: 'facebook', icon: 'fa fa-facebook-square', color: 'info' }];
	    }
	    YoutubePlayerCtrl.$inject = ["YoutubePlayerSettings", "PlayerResizer", "MediaInfoService", "$state", "YoutubePlayerApi", "$scope"];

	    _createClass(YoutubePlayerCtrl, [{
	      key: '$postLink',
	      value: function $postLink() {
	        var _this = this;

	        var scope = this.$scope;
	        this.YoutubePlayerApi.load().then(function () {
	          _this.YoutubePlayerSettings.createPlayer(_this.playerId, _this.size.height, _this.size.width, '', onPlayerStateChange);
	        });

	        function onPlayerStateChange() {
	          scope.$apply();
	        }
	      }
	    }, {
	      key: 'onShowPlayer',
	      value: function onShowPlayer() {
	        this.togglePlayer(!this.showPlayer());
	      }
	    }, {
	      key: 'togglePlayer',
	      value: function togglePlayer(visible) {
	        this.YoutubePlayerSettings.nowPlaying.showPlayer = visible;
	      }
	    }, {
	      key: 'toggleFullScreen',
	      value: function toggleFullScreen() {
	        this.isFullScreen = !this.isFullScreen;
	        this.PlayerResizer.setFullScreen(this.isFullScreen);
	        this.YoutubePlayerSettings.setSize(this.size.height, this.size.width);
	      }
	    }, {
	      key: 'addToPlaylist',
	      value: function addToPlaylist() {
	        if (this.video.mediaId !== '') {
	          this.$state.go('addVideo', { id: this.video.media.id });
	        }
	      }
	    }, {
	      key: 'isPlaying',
	      value: function isPlaying() {
	        // because YT is not loaded yet 1 is used - YT.PlayerState.PLAYING
	        return this.YoutubePlayerSettings.getPlayerState() === 1;
	      }
	    }, {
	      key: 'seekToSeconds',
	      value: function seekToSeconds(seconds) {
	        this.YoutubePlayerSettings.seekToSeconds(seconds);
	      }
	    }, {
	      key: 'hasContent',
	      value: function hasContent() {
	        return this.videoInfo.thumb !== '';
	      }
	    }]);

	    return YoutubePlayerCtrl;
	  }()
	};

/***/ },
/* 62 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/* @ngInject */
	var YoutubePlayerCreator = function () {
	    function YoutubePlayerCreator() {
	        _classCallCheck(this, YoutubePlayerCreator);
	    }

	    _createClass(YoutubePlayerCreator, [{
	        key: "createPlayer",
	        value: function createPlayer(elementId, height, width, videoId, callback) {
	            return new YT.Player(elementId, {
	                height: height,
	                width: width,
	                videoId: videoId,
	                // playerVars: playerVars,
	                events: {
	                    onReady: angular.noop,
	                    onStateChange: callback
	                }
	            });
	        }
	    }]);

	    return YoutubePlayerCreator;
	}();

	exports.default = YoutubePlayerCreator;

/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = YoutubePlayerSettings;

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	/* @ngInject */
	function YoutubePlayerSettings(localStorageService, YoutubePlayerCreator, MediaInfoService) {
	  var nowPlaying = {
	    mediaId: '',
	    index: 0,
	    media: {},
	    showPlayer: false
	  };
	  var seek = 0;
	  var ytplayer = {};
	  var autoNext = true;
	  var Storage = {
	    NOW_PLAYLIST: 'nowPlaylist'
	  };

	  var nowPlaylist = localStorageService.get(Storage.NOW_PLAYLIST) || [];
	  var service = {
	    getCurrentId: getCurrentId,
	    playVideoId: playVideoId,
	    playPlaylist: playPlaylist,
	    nowPlaying: nowPlaying,
	    nowPlaylist: nowPlaylist,
	    queueVideo: queueVideo,
	    queuePlaylist: queuePlaylist,
	    getSeek: getSeek,
	    seekToSeconds: seekToSeconds,
	    playNextTrack: playNextTrack,
	    playPreviousTrack: playPreviousTrack,
	    remove: remove,
	    clear: clear,
	    setYTPlayer: setYTPlayer,
	    getYTPlayer: getYTPlayer,
	    getPlayerState: getPlayerState,
	    playerState: {},
	    createPlayer: createPlayer,
	    showPlayer: showPlayer,
	    setSize: setSize,
	    play: play,
	    pause: pause
	  };
	  return service;

	  ////////////////

	  function getCurrentId() {
	    return nowPlaying.mediaId;
	  }

	  function playVideoId(video) {
	    nowPlaying.mediaId = video.id;
	    seek = 0;
	    updatePlaylistIndex(video);
	    nowPlaying.media = video;
	    MediaInfoService.fetchInfo(video);
	    nowPlaying.showPlayer = true;
	    ytplayer.loadVideoById(video.id);
	    ytplayer.playVideo();
	  }

	  function queueVideo(video) {
	    var videoIsNew = nowPlaylist.every(function (track) {
	      return track.id !== video.id;
	    });
	    if (!videoIsNew) {
	      return;
	    }
	    nowPlaylist.push(video || {});
	    localStorageService.set(Storage.NOW_PLAYLIST, nowPlaylist);
	  }

	  function queuePlaylist(videos) {
	    nowPlaylist.splice.apply(nowPlaylist, [nowPlaylist.length, 0].concat(_toConsumableArray(videos)));
	    localStorageService.set(Storage.NOW_PLAYLIST, nowPlaylist);
	  }

	  function updatePlaylistIndex(video) {
	    nowPlaylist.some(function (track, index) {
	      if (track.id === video.id) {
	        nowPlaying.index = index;
	        return true;
	      }
	    });
	  }

	  function playPlaylist(videos, index) {
	    var indexToPlay = angular.isNumber(index) ? index : 0;
	    var firstVideo = videos[indexToPlay];
	    nowPlaylist.length = 0;
	    queuePlaylist(videos);
	    playVideoId(firstVideo);
	  }

	  function getSeek() {
	    return seek;
	  }

	  // options.stopOnLast: true (optional) - won't play the next track
	  function playNextTrack(options) {
	    var nextIndex = nowPlaying.index + 1;
	    var nextTrackIsLast = nextIndex === nowPlaylist.length;
	    nextIndex = nextTrackIsLast ? 0 : nextIndex;
	    if (nextTrackIsLast && angular.isDefined(options) && options.stopOnLast) {
	      return;
	    }
	    playVideoId(nowPlaylist[nextIndex]);
	  }

	  function playPreviousTrack() {
	    var nowIndex = nowPlaying.index;
	    if (nowPlaylist.length === 1 || nowPlaylist.length === 0) {
	      return;
	    }
	    var prevIndex = nowIndex === 0 ? nowPlaylist.length - 1 : nowIndex - 1;
	    playVideoId(nowPlaylist[prevIndex]);
	  }
	  function remove(video, index) {
	    nowPlaylist.splice(index, 1);
	    updatePlaylistIndex(nowPlaying.media);
	    localStorageService.set(Storage.NOW_PLAYLIST, nowPlaylist);
	  }

	  function clear() {
	    nowPlaylist.length = 0;
	    localStorageService.set(Storage.NOW_PLAYLIST, nowPlaylist);
	  }

	  function setYTPlayer(player) {
	    ytplayer = player;
	  }

	  function getYTPlayer() {
	    return ytplayer;
	  }

	  function getPlayerState() {
	    return service.playerState;
	  }

	  function createPlayer(elementId, height, width, videoId, callback) {
	    ytplayer = YoutubePlayerCreator.createPlayer(elementId, height, width, videoId, onPlayerStateChange);
	    return ytplayer;

	    function onPlayerStateChange(event) {
	      var state = event.data;

	      // play the next song if its not the end of the playlist
	      // should add a "repeat" feature
	      if (angular.isDefined(autoNext) && state === YT.PlayerState.ENDED) {
	        service.playNextTrack({ stopOnLast: true });
	      }

	      if (state === YT.PlayerState.PAUSED) {
	        service.playerState = YT.PlayerState.PAUSED;
	      }
	      if (state === YT.PlayerState.PLAYING) {
	        service.playerState = YT.PlayerState.PLAYING;
	      }
	      callback(state);
	    }
	  }

	  function setSize(height, width) {
	    ytplayer.setSize(width, height);
	  }

	  function play() {
	    if (ytplayer) {
	      ytplayer.playVideo();
	    }
	  }

	  function pause() {
	    if (ytplayer) {
	      ytplayer.pauseVideo();
	    }
	  }

	  function seekToSeconds(seconds) {
	    seconds = hmsToSeconds(seconds);
	    if (!Number.isNaN(seconds) && angular.isNumber(seconds)) {
	      ytplayer.seekTo(seconds, true);
	    }

	    // converts time duration string to seconds as number
	    // @param {string} d - duration string - 6:05, 1:04:05
	    // @return {number}
	    function hmsToSeconds(d) {
	      d = d.split(':');
	      var hasHour = d.length === 3;
	      var h = hasHour ? parseInt(d[0], 10) * 60 * 60 : 0;
	      var m = hasHour ? d[1] : d[0];
	      var s = hasHour ? d[2] : d[1];
	      return h + parseInt(m, 10) * 60 + parseInt(s, 10);
	    }
	  }

	  function showPlayer() {
	    return nowPlaying.showPlayer;
	  }
	}
	YoutubePlayerSettings.$inject = ["localStorageService", "YoutubePlayerCreator", "MediaInfoService"];

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularUiRouter = __webpack_require__(5);

	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _youtubeVideo = __webpack_require__(65);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('youtube-video', [_core2.default, _angularUiRouter2.default]).config(config).directive(_youtubeVideo.YoutubeVideoComponent.selector, function () {
		return _youtubeVideo.YoutubeVideoComponent;
	}).name;
	/* @ngInject */

	function config($stateProvider) {
		$stateProvider.state('video', {
			url: '/video/:id',
			template: '<youtube-video video="$ctrl.video"></youtube-video>',
			/* @ngInject */
			controller: ["video", function controller(video) {
				this.video = video;
			}],
			controllerAs: '$ctrl',
			resolve: {
				/* @ngInject */
				video: ["YoutubeVideoInfo", "$stateParams", function video(YoutubeVideoInfo, $stateParams) {
					return YoutubeVideoInfo.list($stateParams.id).then(function (items) {
						return items[0];
					});
				}]
			}
		});
	}
	config.$inject = ["$stateProvider"];

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.YoutubeVideoComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(104);

	var _youtubeVideoTpl = __webpack_require__(137);

	var _youtubeVideoTpl2 = _interopRequireDefault(_youtubeVideoTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var YoutubeVideoComponent = exports.YoutubeVideoComponent = {
		templateUrl: _youtubeVideoTpl2.default,
		selector: 'youtubeVideo',
		controllerAs: '$ctrl',
		scope: {
			video: '='
		},
		bindToController: true,
		replace: true,
		restrict: 'E',
		controller: function () {
			/* @ngInject */
			function YoutubeVideoCtrl(YoutubePlayerSettings, $state) {
				_classCallCheck(this, YoutubeVideoCtrl);

				Object.assign(this, { YoutubePlayerSettings: YoutubePlayerSettings, $state: $state });
				// this.video = video;
				this.video.snippet.description = this.toHtml(this.video.snippet.description);
				this.video.time = this.getDuration(this.video.contentDetails.duration);
			}
			YoutubeVideoCtrl.$inject = ["YoutubePlayerSettings", "$state"];

			_createClass(YoutubeVideoCtrl, [{
				key: 'queueVideo',
				value: function queueVideo() {
					this.YoutubePlayerSettings.queueVideo(this.video);
				}
			}, {
				key: 'playVideo',
				value: function playVideo() {
					this.YoutubePlayerSettings.queueVideo(this.video);
					this.YoutubePlayerSettings.playVideoId(this.video);
				}
			}, {
				key: 'goBack',
				value: function goBack() {
					this.$state.go('videos');
				}
			}, {
				key: 'getDuration',
				value: function getDuration(time) {
					var t = time.split('PT')[1].replace(/(H|M)/g, ':').replace('S', '');
					var ts = t.split(':');
					ts = ts.map(function (d) {
						return d.length === 1 ? '0' + d : d;
					});
					return ts.join(':');
				}
			}, {
				key: 'toHtml',
				value: function toHtml(text) {
					var breakLineReg = /\n/gm;
					var linksReg = /(http:\/\/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))/gm;
					if (!text) return text;
					return text.replace(breakLineReg, '<br>').replace(linksReg, '<a href="$1" target="blank" title="opens in a new tab">$1</a>');
				}
			}]);

			return YoutubeVideoCtrl;
		}()
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _youtubeVideosComponent = __webpack_require__(67);

	Object.keys(_youtubeVideosComponent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _youtubeVideosComponent[key];
	    }
	  });
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularUiRouter = __webpack_require__(5);

	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

	var _core = __webpack_require__(4);

	var _core2 = _interopRequireDefault(_core);

	var _playlistEditor = __webpack_require__(9);

	var _playlistEditor2 = _interopRequireDefault(_playlistEditor);

	var _ngInfiniteScroll = __webpack_require__(120);

	var _ngInfiniteScroll2 = _interopRequireDefault(_ngInfiniteScroll);

	var _searchFilterPanel = __webpack_require__(45);

	var _searchFilterPanel2 = _interopRequireDefault(_searchFilterPanel);

	var _feedFilter = __webpack_require__(28);

	var _feedFilter2 = _interopRequireDefault(_feedFilter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('youtube-videos', [_core2.default, 'youtube.player', _angularUiRouter2.default, _playlistEditor2.default, 'infinite-scroll', _searchFilterPanel2.default, _feedFilter2.default.name]).component(_youtubeVideosComponent.YoutubeVideosComponent.selector, _youtubeVideosComponent.YoutubeVideosComponent).name;
	// .config(config);

	/* @ngInject */

	function config($stateProvider) {
	  // $stateProvider
	  //     .state('videos', {
	  //         url: '/videos',
	  //         template: '<youtube-videos></youtube-videos>'
	  //     });
	}
	config.$inject = ["$stateProvider"];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YoutubeVideosComponent = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(105);

	var _youtubeVideosTpl = __webpack_require__(138);

	var _youtubeVideosTpl2 = _interopRequireDefault(_youtubeVideosTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// Usage:
	//  <youtube-videos></youtube-videos>
	var YoutubeVideosComponent = exports.YoutubeVideosComponent = {
	  templateUrl: _youtubeVideosTpl2.default,
	  selector: 'youtubeVideos',
	  bindings: {},
	  controller: function () {
	    /* @ngInject */
	    function YoutubeVideosCtrl(YoutubePlayerSettings, YoutubeSearch, PlaylistEditorSettings, PlaylistInfo, $state) {
	      _classCallCheck(this, YoutubeVideosCtrl);

	      Object.assign(this, {
	        YoutubePlayerSettings: YoutubePlayerSettings, YoutubeSearch: YoutubeSearch, PlaylistInfo: PlaylistInfo,
	        PlaylistEditorSettings: PlaylistEditorSettings, $state: $state
	      });

	      this.getFeedType = YoutubeSearch.getFeedType;
	      this.videos = YoutubeSearch.items;
	      this.searchMore = YoutubeSearch.searchMore;
	      this.playlistBackState = 'videos';
	      this.hideFilters = true;

	      YoutubeSearch.resetPageToken();
	      if (!this.videos.length) {
	        YoutubeSearch.search();
	      }
	    }
	    YoutubeVideosCtrl.$inject = ["YoutubePlayerSettings", "YoutubeSearch", "PlaylistEditorSettings", "PlaylistInfo", "$state"];

	    _createClass(YoutubeVideosCtrl, [{
	      key: 'playVideo',
	      value: function playVideo(video) {
	        this.YoutubePlayerSettings.queueVideo(video);
	        this.YoutubePlayerSettings.playVideoId(video);
	      }
	    }, {
	      key: 'playPlaylist',
	      value: function playPlaylist(playlist) {
	        return this.PlaylistInfo.list(playlist.id).then(this.YoutubePlayerSettings.playPlaylist);
	      }
	    }, {
	      key: 'addVideo',
	      value: function addVideo(video) {
	        this.PlaylistEditorSettings.add(video);
	        this.$state.go('addVideo', {
	          id: video.id
	        });
	      }
	    }, {
	      key: 'queueVideo',
	      value: function queueVideo(video) {
	        this.YoutubePlayerSettings.queueVideo(video);
	      }
	    }, {
	      key: 'toggleFilters',
	      value: function toggleFilters() {
	        this.hideFilters = !this.hideFilters;
	      }
	    }]);

	    return YoutubeVideosCtrl;
	  }()
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_angular2.default.module(("echoes")).config(config);

	/* @ngInject */
	function config($compileProvider) {
	  $compileProvider.debugInfoEnabled(false);
	}
	config.$inject = ["$compileProvider"];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.eDropdown = undefined;

	__webpack_require__(106);

	var _eDropdownTpl = __webpack_require__(139);

	var _eDropdownTpl2 = _interopRequireDefault(_eDropdownTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Usage:
	//	<e-dropdown label="presets" items="[array]"
	// 		icon="fa-type" on-select="fun(item ,index)"
	//   	selected="index"></e-dropdown>
	// Creates:
	//
	var eDropdown = exports.eDropdown = {
	  selector: 'eDropdown',
	  replace: true,
	  templateUrl: _eDropdownTpl2.default,
	  bindings: {
	    label: '@',
	    icon: '@',
	    items: '<',
	    onSelect: '&',
	    selected: '@'
	  },
	  controllerAs: 'vm',
	  /* @ngInject */
	  controller: function controller() {
	    // var vm = this;
	    this.activeIndex = this.selected !== '' ? parseInt(this.selected) : 0;
	    this.handleClick = handleClick;
	    this.status = {
	      isOpen: false
	    };
	    this.displayLabel = this.items[this.activeIndex];

	    function handleClick(item, $index) {
	      this.activeIndex = $index;
	      this.displayLabel = this.items[this.activeIndex];
	      this.onSelect({
	        item: item,
	        index: $index
	      });
	    }
	  }
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _eDropdown = __webpack_require__(69);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('eDropdown', []).component(_eDropdown.eDropdown.selector, _eDropdown.eDropdown);

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _eDropdown = __webpack_require__(70);

	var _eDropdown2 = _interopRequireDefault(_eDropdown);

	var _youtubeComponents = __webpack_require__(72);

	var _youtubeComponents2 = _interopRequireDefault(_youtubeComponents);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('core.components', [_youtubeComponents2.default.name, _eDropdown2.default.name]);

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _youtubePlaylist = __webpack_require__(75);

	var _youtubePlaylist2 = _interopRequireDefault(_youtubePlaylist);

	var _youtubeMedia = __webpack_require__(74);

	var _youtubeList = __webpack_require__(73);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('youtube.components', [
		// 'playlist.editor'
	]).directive('youtubePlaylistItem', _youtubePlaylist2.default).component(_youtubeMedia.YoutubeMedia.selector, _youtubeMedia.YoutubeMedia).component(_youtubeList.YoutubeList.selector, _youtubeList.YoutubeList);

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.YoutubeList = undefined;

	__webpack_require__(107);

	var _youtubeListTpl = __webpack_require__(140);

	var _youtubeListTpl2 = _interopRequireDefault(_youtubeListTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Usage:
	//	<youtube-list videos on-select="func(video)" on-queue="func(video)"></youtube-list>
	// Creates:
	//
	var YoutubeList = exports.YoutubeList = {
		selector: 'youtubeList',
		templateUrl: _youtubeListTpl2.default,
		bindings: {
			videos: '<',
			onSelect: '&',
			onQueue: '&',
			onAdd: '&'
		},
		controllerAs: 'vm',
		controller: function controller() {
			var vm = this;
			vm.playSelectedVideo = playSelectedVideo;
			vm.queueSelectedVideo = queueSelectedVideo;
			vm.add = add;

			function playSelectedVideo(video) {
				vm.onSelect({
					video: video
				});
			}

			function queueSelectedVideo(video) {
				vm.onQueue({
					video: video
				});
			}

			function add(video) {
				vm.onAdd({
					video: video
				});
			}
		}
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YoutubeMedia = undefined;

	__webpack_require__(108);

	var _youtubeMedia = __webpack_require__(141);

	var _youtubeMedia2 = _interopRequireDefault(_youtubeMedia);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var YoutubeMedia = exports.YoutubeMedia = {
	  selector: 'youtubeMedia',
	  templateUrl: _youtubeMedia2.default,
	  bindings: {
	    onPlay: '&',
	    onQueue: '&',
	    onAdd: '&',
	    video: '<'
	  },
	  controllerAs: 'vm',
	  /* @ngInject */
	  controller: function controller() {
	    var vm = this;
	    vm.playVideo = playVideo;
	    vm.queueVideo = queueVideo;
	    vm.add = add;
	    vm.showDesc = false;
	    vm.toggle = toggle;
	    vm.isPlaying = false;

	    function playVideo(video) {
	      vm.onPlay({
	        video: video
	      });
	    }

	    function queueVideo(video) {
	      vm.onQueue({
	        video: video
	      });
	    }

	    function add(video) {
	      vm.onAdd({
	        video: video
	      });
	    }

	    function toggle(showDesc) {
	      vm.showDesc = !showDesc;
	    }
	  }
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = YoutubePlaylistItem;

	__webpack_require__(109);

	var _youtubePlaylistTpl = __webpack_require__(142);

	var _youtubePlaylistTpl2 = _interopRequireDefault(_youtubePlaylistTpl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function YoutubePlaylistItem() {
		var directive = {
			restrict: 'E',
			templateUrl: _youtubePlaylistTpl2.default,
			replace: true,
			scope: {
				onPlay: '&',
				video: '=',
				back: '@'
			},
			bindToController: true,
			controller: controller,
			controllerAs: 'vm'
		};

		return directive;

		function controller() {
			var vm = this;
			vm.isVideoItem = isVideoItem;
			vm.isChannelItem = isChannelItem;
			vm.playVideo = playVideo;
			vm.loading = false;

			function isVideoItem(video) {
				return vm.video.id.kind === 'youtube#video';
			};

			function isChannelItem(video) {
				return vm.video.id.kind === 'youtube#channel';
			};

			function playVideo(video) {
				vm.loading = true;
				this.onPlay({
					video: vm.video
				}).then(function (res) {
					vm.loading = false;
				});
			};
		}
	}

/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var YOUTUBE_API_KEY = 'AIzaSyBke2rzMLME-I6POOGYgGFzQZR2U6pYmjc';
	exports.default = YOUTUBE_API_KEY;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _angularLocalStorage = __webpack_require__(7);

	var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

	var _youtubeVideoInfoSrv = __webpack_require__(89);

	var _youtubeVideoInfoSrv2 = _interopRequireDefault(_youtubeVideoInfoSrv);

	var _playlistInfoSrv = __webpack_require__(78);

	var _playlistInfoSrv2 = _interopRequireDefault(_playlistInfoSrv);

	var _youtubeSearchSrv = __webpack_require__(87);

	var _youtubeSearchSrv2 = _interopRequireDefault(_youtubeSearchSrv);

	var _youtubePlaylistsInfoSrv = __webpack_require__(86);

	var _youtubePlaylistsInfoSrv2 = _interopRequireDefault(_youtubePlaylistsInfoSrv);

	var _youtubeApi = __webpack_require__(84);

	var _youtubeApi2 = _interopRequireDefault(_youtubeApi);

	var _youtubeUserSrv = __webpack_require__(88);

	var _youtubeUserSrv2 = _interopRequireDefault(_youtubeUserSrv);

	var _constants = __webpack_require__(76);

	var _constants2 = _interopRequireDefault(_constants);

	var _presetService = __webpack_require__(79);

	var _presetService2 = _interopRequireDefault(_presetService);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('core.services', [_youtubeApi2.default.name, 'LocalStorageModule']).factory('YoutubeVideoInfo', _youtubeVideoInfoSrv2.default).factory('PlaylistInfo', _playlistInfoSrv2.default).factory('YoutubePlaylistInfo', _youtubePlaylistsInfoSrv2.default).factory('YoutubeSearch', _youtubeSearchSrv2.default).factory('YoutubeUser', _youtubeUserSrv2.default).factory('preset', _presetService2.default).constant('YOUTUBE_API_KEY', _constants2.default);

/***/ },
/* 78 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PlaylistInfo;
	/* @ngInject */
	function PlaylistInfo($q, $http, YOUTUBE_API_KEY, YoutubeVideoInfo) {
	    var url = 'https://www.googleapis.com/youtube/v3/playlistItems';
	    var config = {
	        params: {
	            part: 'snippet,contentDetails',
	            key: YOUTUBE_API_KEY,
	            playlistId: '',
	            maxResults: 50
	        }
	    };
	    var service = {
	        list: list
	    };
	    return service;

	    ////////////////

	    function list(playlistId) {
	        var defer = $q.defer();
	        config.params.playlistId = playlistId;
	        playlist(url, config).then(function (items) {
	            defer.resolve(items);
	        });

	        return defer.promise;
	    }

	    function playlist(url, config) {
	        var items = [];
	        var token;
	        var _defer = $q.defer();

	        getItems();

	        return _defer.promise;

	        function getItems() {
	            return $http.get(url, config).then(function (response) {
	                token = response.data.nextPageToken;
	                return response;
	            }).then(YoutubeVideoInfo.enrichItems).then(function (videos) {
	                Array.prototype.push.apply(items, videos);
	                if (token) {
	                    config.params.pageToken = token;
	                    return getItems();
	                }
	                _defer.resolve(items);
	            });
	        }
	    }
	}
	PlaylistInfo.$inject = ["$q", "$http", "YOUTUBE_API_KEY", "YoutubeVideoInfo"];

/***/ },
/* 79 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = preset;
	/* @ngInject */
	function preset(localStorageService) {
	    var Storage = {
	        PRESET: 'preset'
	    };
	    var items = ['all', 'full album', 'live'];
	    var query;
	    var selectedPreset = localStorageService.get(Storage.PRESET);
	    var selectedIndex = 0;
	    var service = {
	        selected: selected,
	        update: update,
	        items: items,
	        getQuery: getQuery
	    };
	    activate();

	    return service;

	    function activate() {
	        if (!selectedPreset) {
	            selectedPreset = '';
	        }
	        updateSelectedIndex(selectedPreset);
	    }

	    function update(currentQuery, newPreset) {
	        // query = currentQuery;
	        var query = currentQuery.replace(selectedPreset, '').trim();
	        selectedPreset = newPreset.toLowerCase();
	        if (selectedPreset === 'all') {
	            selectedPreset = '';
	        }
	        query += ' ' + selectedPreset.toLowerCase();
	        localStorageService.set(Storage.PRESET, selectedPreset);
	        updateSelectedIndex(selectedPreset);
	        return query;
	    }

	    function updateSelectedIndex(preset) {
	        var indexOfSelectedPreset = items.indexOf(preset);
	        selectedIndex = indexOfSelectedPreset === -1 ? 0 : indexOfSelectedPreset;
	    }

	    function selected() {
	        return {
	            label: selectedPreset,
	            index: selectedIndex
	        };
	    }

	    function getQuery() {
	        return query;
	    }
	}
	preset.$inject = ["localStorageService"];

/***/ },
/* 80 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = GapiApiSetter;
	/* @ngInject */
	function GapiApiSetter() {
	  var scope = '';
	  var api = {
	    client: '',
	    version: ''
	  };
	  var clientId = '';

	  var service = {
	    config: config,
	    $get: $get
	  };

	  return service;

	  function $get() {
	    return {
	      scope: scope,
	      api: api,
	      clientId: clientId
	    };
	  }

	  function config(options) {
	    setScope(options.scope);
	    setApi(options.api.client, options.api.version);
	    setClientId(options.clientId);
	  }

	  function setScope(scopes) {
	    var scopePrefix = 'https://www.googleapis.com/auth/';
	    // check if scopes has multiple endpoints
	    scope = scopes.replace(/ /gm, '').split(',').map(function (s) {
	      return scopePrefix + s;
	    });
	  }

	  function setApi(client, version) {
	    api.client = client;
	    api.version = version;
	  }

	  function setClientId(id) {
	    clientId = id;
	  }
	}

/***/ },
/* 81 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = GapiLoader;
	/* @ngInject */
	function GapiLoader($window, $rootScope, $q, GoogleClientApi, $http, GapiApiSetter) {
	  var defered = $q.defer();
	  var scope = GapiApiSetter.scope;
	  var clientId = GapiApiSetter.clientId;
	  var loadClientApi = true;

	  var service = {
	    load: load,
	    auth: auth,
	    authorize: authorize,
	    signOut: signOut
	  };

	  activate();

	  return service;

	  function activate() {
	    // Youtube callback when API is ready
	    $window.onGapiLoad = function () {
	      $rootScope.$applyAsync(function () {
	        defered.resolve();
	      });
	    };

	    // Inject YouTube's client API
	    (function () {
	      var validProtocols = ['http:', 'https:'];
	      var url = '//apis.google.com/js/client.js?onload=onGapiLoad';

	      // We'd prefer a protocol relative url, but let's
	      // fallback to `http:` for invalid protocols
	      if (validProtocols.indexOf(window.location.protocol) < 0) {
	        url = 'http:' + url;
	      }
	      var tag = document.createElement('script');
	      tag.src = url;
	      var firstScriptTag = document.getElementsByTagName('script')[0];
	      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	    })();
	  }

	  function load() {
	    return defered.promise;
	  }

	  function auth(options) {
	    var isImmediate = options && options.hasOwnProperty('immediate') ? options.immediate : true;
	    var authDefered = $q.defer();
	    var handleAuthResult = function handleAuthResult(authResult) {
	      authHasError(authResult);
	      if (loadClientApi) {
	        GoogleClientApi.load().then(function (res) {
	          loadClientApi = false;
	          authDefered.resolve(authResult);
	        });
	      } else {
	        authDefered.resolve(authResult);
	      }
	    };

	    load().then(function () {
	      return authorize({ immediate: isImmediate }).then(handleAuthResult);
	    });

	    return authDefered.promise;
	  }

	  // options {
	  //  immediate: false (show pop up) / true {default} - silent login
	  function authorize(options) {
	    var authDefered = $q.defer();
	    gapi.auth.authorize({
	      client_id: clientId,
	      scope: scope,
	      // false - is for showing pop up
	      immediate: options && options.immediate || true
	    }, function (ev) {
	      $rootScope.$applyAsync(function () {
	        return authDefered.resolve(ev);
	      });
	    });
	    return authDefered.promise;
	  }

	  function authHasError(auth) {
	    return auth.error && auth.error.indexOf('fail') > -1;
	  }

	  function signOut() {
	    var revokeUrl = 'https://accounts.google.com/o/oauth2/revoke?token=';
	    var token = gapi.auth.getToken();
	    var accessToken = token ? token.access_token : '';
	    var url = revokeUrl + accessToken;
	    return $http.get(url).then(signOutSuccess, singOutFailed);

	    function signOutSuccess(ev) {
	      console.log('signout success', ev);
	      return ev;
	    }

	    function singOutFailed(response) {
	      if ('' === response.statusText) {
	        return signOutSuccess(response);
	      }
	      console.log('singout failed');
	    }
	  }
	}
	GapiLoader.$inject = ["$window", "$rootScope", "$q", "GoogleClientApi", "$http", "GapiApiSetter"];

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	        value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _gapiLoader = __webpack_require__(81);

	var _gapiLoader2 = _interopRequireDefault(_gapiLoader);

	var _googleClientApi = __webpack_require__(83);

	var _googleClientApi2 = _interopRequireDefault(_googleClientApi);

	var _gapiApiSetter = __webpack_require__(80);

	var _gapiApiSetter2 = _interopRequireDefault(_gapiApiSetter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('google.api.loader', []).factory('GapiLoader', _gapiLoader2.default).factory('GoogleClientApi', _googleClientApi2.default).provider('GapiApiSetter', _gapiApiSetter2.default);

/***/ },
/* 83 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = GoogleClientApi;
	/* @ngInject */
	function GoogleClientApi($q, GapiApiSetter) {
	    var defered = $q.defer();
	    var service = {
	        load: load,
	        getClientApi: getClientApi
	    };
	    var ClientApis = {};

	    return service;

	    // optional: client, version
	    function load(client, version) {
	        // gapi.client.setApiKey(DeveloperApiKey);
	        //  load the gapi api
	        client = GapiApiSetter.api.client;
	        version = GapiApiSetter.api.version;
	        if (ClientApis[client] && ClientApis[client].isLoading) {
	            return defered.promise;
	        } else {
	            addApi(client);
	        }
	        if (gapi.client[client]) {
	            defered.resolve();
	        } else if (!ClientApis[client].isLoading) {
	            ClientApis[client].isLoading = true;
	            gapi.client.load(client, version, handleResponse);
	        }
	        return defered.promise;
	    }

	    function handleResponse(res) {
	        if (gapi && gapi.client) {
	            console.log('client load success:', res);
	            defered.resolve(gapi.client);
	            return gapi.client;
	        }
	        console.log('gapi not loaded yet...', result);
	    }

	    function addApi(api) {
	        ClientApis[api] = {
	            isLoading: false,
	            hasBeenLoaded: false
	        };
	    }
	    function getClientApi() {
	        return defered.promise;
	    }
	}
	GoogleClientApi.$inject = ["$q", "GapiApiSetter"];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	var _googleApiLoaderMdl = __webpack_require__(82);

	var _googleApiLoaderMdl2 = _interopRequireDefault(_googleApiLoaderMdl);

	var _userPlaylistsService = __webpack_require__(85);

	var _userPlaylistsService2 = _interopRequireDefault(_userPlaylistsService);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _angular2.default.module('youtube.api', [_googleApiLoaderMdl2.default.name]).factory('uGapi', uGapi).factory('UserPlaylists', _userPlaylistsService2.default.UserPlaylists).factory('ApiPlaylists', _userPlaylistsService2.default.ApiPlaylists);

	/* @ngInject */

	function uGapi($q, $rootScope, GapiLoader) {
	  GapiApi.authorize = GapiLoader.authorize;
	  return GapiApi;

	  // config:
	  //  resourceName - api to use, i.e, "playlists"
	  //  pages - number of next pages to fetch
	  function GapiApi(config) {
	    var resourceName = config.resourceName;
	    var pages = config.pages || 0;
	    var pagesCounter = 0;

	    var defer;
	    var params = {
	      part: 'snippet,contentDetails',
	      maxResults: 50,
	      mine: true
	    };

	    var service = {
	      list: list,
	      params: params,
	      insert: insert,
	      remove: remove
	    };
	    return service;

	    function list(args, transformFunc) {
	      defer = $q.defer();
	      args = args || {};
	      gapiList(_angular2.default.copy(params, args), transformFunc);
	      return defer.promise;
	    }

	    function gapiList(args, transformFunc) {
	      GapiLoader.auth().then(function () {
	        getAllItems(args, transformFunc).then(function (res) {
	          defer.resolve(res.result);
	        });
	      });
	    }

	    function getNextPage(response) {
	      var pageToken = response.result.nextPageToken;
	      var _params = _angular2.default.copy(params);
	      var allowNextPage = pageToken && pages === 'all' || pagesCounter < parseInt(pages);
	      _params.pageToken = pageToken;
	      if (allowNextPage) {
	        defer.notify(response.result);
	        pagesCounter++;
	        gapiList(_params);
	        return;
	      }
	      endPromise(response);
	    }

	    function endPromise(response) {
	      defer.resolve(response.result);
	      $rootScope.$apply();
	    }

	    function getAllItems(params, transformFunc) {
	      var items = [];
	      var token = void 0;
	      return getItems();

	      function getItems() {
	        return $q.when(gapi.client.youtube[resourceName].list(params)).then(function (response) {
	          token = response.result.nextPageToken;
	          return response;
	        }).then(transformFunc).then(function (response) {
	          var returnValue = response;
	          Array.prototype.push.apply(items, response.length ? response : response.result.items);
	          if (token) {
	            params.pageToken = token;
	            return getItems();
	          }
	          if (response.result) {
	            response.result.items = items;
	          }
	          if (response.length) {
	            returnValue = { items: items };
	          }
	          return returnValue;
	        });
	      }
	    }

	    function insert(params) {
	      return $q.when(gapi.client.youtube[resourceName].insert(params));
	    }

	    function remove(playlistId) {
	      var params = {
	        id: playlistId
	      };
	      return $q.when(gapi.client.youtube[resourceName].delete(params));
	    }
	  }
	}
	uGapi.$inject = ["$q", "$rootScope", "GapiLoader"];

/***/ },
/* 85 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Apis = {
	  UserPlaylists: UserPlaylists,
	  ApiPlaylists: ApiPlaylists
	};

	exports.default = Apis;

	/* @ngInject */

	function UserPlaylists($rootScope, uGapi, ApiPlaylists, $q) {
	  // var api = uGapi({
	  //        resourceName: 'playlists',
	  //        pages: 'all'
	  //    });
	  var api = ApiPlaylists;
	  var playlists = uGapi({
	    resourceName: 'playlistItems',
	    pages: 'all'
	  });
	  var tracks = [];
	  var service = {
	    tracks: tracks,
	    list: list,
	    getPlaylist: getPlaylist,
	    addToPlaylist: addToPlaylist,
	    removePlaylist: removePlaylist,
	    createPlaylist: createPlaylist,
	    clearPlaylists: clearPlaylists
	  };

	  return service;

	  ////////////////
	  function list(user) {
	    tracks.length = 0;
	    return api.list().then(updateItems, onError, updateItems);
	  }

	  function updateItems(resource) {
	    Array.prototype.push.apply(tracks, resource.items);
	  }

	  function onError(err) {
	    console.log(err);
	  }

	  function getPlaylist(playlistId, transformFunc) {
	    delete playlists.params.mine;
	    playlists.params.playlistId = playlistId;
	    return playlists.list({}, transformFunc);
	  }

	  function addToPlaylist(playlistId, media, position) {
	    var params = {
	      part: 'snippet',
	      resource: {
	        snippet: {
	          playlistId: playlistId,
	          resourceId: {
	            videoId: media.id,
	            playlistId: playlistId,
	            kind: 'youtube#video'
	          }
	        }
	      }
	    };
	    if (position) {
	      params.resource.snippet.position = position;
	    }
	    return uGapi.authorize().then(function () {
	      return playlists.insert(params);
	    });
	  }

	  function removePlaylist(playlistId) {
	    return api.remove(playlistId).then(function (response) {
	      tracks.some(function (playlist, index) {
	        if (playlist.id === playlistId) {
	          tracks.splice(index, 1);
	        }
	      });
	      return response;
	    });
	  }

	  function createPlaylist(title, description) {
	    var params = {
	      part: 'snippet,contentDetails',
	      resource: {
	        snippet: {
	          title: title,
	          description: description || ''
	        }
	      }
	    };
	    return uGapi.authorize().then(function () {
	      return api.insert(params).then(list);
	    });
	  }

	  function clearPlaylists() {
	    tracks.length = 0;
	  }
	}
	UserPlaylists.$inject = ["$rootScope", "uGapi", "ApiPlaylists", "$q"];
	/* @ngInject */
	function ApiPlaylists(uGapi) {
	  return uGapi({
	    resourceName: 'playlists',
	    pages: 'all'
	  });
	}
	ApiPlaylists.$inject = ["uGapi"];

/***/ },
/* 86 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = YoutubePlaylistInfo;
	/* @ngInject */
	function YoutubePlaylistInfo($http, YOUTUBE_API_KEY) {
	  var url = 'https://www.googleapis.com/youtube/v3/playlists';
	  var config = {
	    params: {
	      part: 'snippet,contentDetails',
	      key: YOUTUBE_API_KEY,
	      id: '',
	      maxResults: 50
	      // mine: false
	    }
	  };
	  var service = {
	    list: list
	  };
	  return service;

	  ////////////////

	  function list(id) {
	    config.params.id = id;
	    return $http.get(url, config).then(function (res) {
	      return res.data.items;
	    });
	  }
	}
	YoutubePlaylistInfo.$inject = ["$http", "YOUTUBE_API_KEY"];

/***/ },
/* 87 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = YoutubeSearch;
	/* @ngInject */
	function YoutubeSearch($http, YOUTUBE_API_KEY, YoutubeVideoInfo, YoutubePlaylistInfo, localStorageService, preset, toastr) {
	  var url = 'https://www.googleapis.com/youtube/v3/search';
	  var Storage = {
	    QUERY: 'query'
	  };
	  var types = {
	    VIDEO: 'video',
	    PLAYLIST: 'playlist'
	  };
	  var idPropertyName = {
	    video: 'videoId',
	    playlist: 'playlistId'
	  };
	  var config = {
	    params: {
	      part: 'snippet,id',
	      key: YOUTUBE_API_KEY,
	      q: localStorageService.get(Storage.QUERY),
	      maxResults: 50,
	      type: types.VIDEO
	    }
	  };
	  var infoService = {
	    video: YoutubeVideoInfo,
	    playlist: YoutubePlaylistInfo
	  };

	  var items = [];
	  var isSearching = false;
	  var nextPageToken;
	  var _toast;

	  var exports = {
	    search: search,
	    setType: setType,
	    setDuration: setDuration,
	    setPreset: setPreset,
	    items: items,
	    types: types,
	    params: config.params,
	    getFeedType: getFeedType,
	    getIsSearching: getIsSearching,
	    searchMore: searchMore,
	    resetPageToken: resetPageToken
	  };

	  return exports;

	  ///////////////

	  function search(query, dontReset) {
	    var _config = { params: {} };
	    if (!dontReset) {
	      resetList();
	    }
	    isSearching = true;
	    if (query && query !== config.params.q) {
	      config.params.pageToken = '';
	    }
	    // remove properties not relevant to playlist search
	    sanitize();
	    config.params.q = query || config.params.q || '';
	    localStorageService.set(Storage.QUERY, config.params.q);
	    angular.extend(_config.params, config.params);
	    _config.params.q += " " + preset.selected().label;

	    // update toast
	    if (_toast) {
	      toastr.clear(_toast);
	    }
	    _toast = toastr.info('', '<i class="fa fa-refresh fa-spin fa-3x"></i> Loading More...', {
	      iconClass: 'toast-loader'
	    });

	    return $http.get(url, _config).then(fetchContentDetails).then(addDuration).then(finalize);

	    function fetchContentDetails(response) {
	      var activeType = config.params.type;
	      nextPageToken = response.data.nextPageToken;
	      var videoIds = response.data.items.map(function (video) {
	        return video.id[idPropertyName[activeType]];
	      }).join(',');

	      var _items = infoService[activeType].list(videoIds);
	      return _items;
	    }

	    function addDuration(_items) {
	      if (getFeedType() === types.VIDEO) {
	        _items.forEach(function (item) {
	          item.time = YoutubeVideoInfo.toFriendlyDuration(item.contentDetails.duration);
	        });
	      }
	      Array.prototype.push.apply(items, _items);
	    }

	    function finalize() {
	      toastr.clear(_toast);
	      isSearching = false;
	    }
	  }

	  function searchMore() {
	    if (!isSearching && items.length) {
	      config.params.pageToken = nextPageToken;
	      exports.search(config.params.q, true);
	    }
	  }
	  function resetList() {
	    items.length = 0;
	  }

	  function resetPageToken() {
	    config.params.pageToken = '';
	  }

	  function setType(type) {
	    config.params.type = type;
	    resetPageToken();
	    items.length = 0;
	  }

	  function setDuration(duration) {
	    if ('' === duration || undefined === duration) {
	      delete config.params.videoDuration;
	      return;
	    }
	    config.params.videoDuration = duration;
	  }

	  function getDuration() {
	    return config.params.videoDuration || '';
	  }

	  function setPreset(presetValue) {
	    var query = preset.update(config.params.q, presetValue);
	  }

	  function getFeedType() {
	    return config.params.type;
	  }

	  function getQuery() {
	    return config.params.q;
	  }

	  function getIsSearching() {
	    return isSearching;
	  }

	  function sanitize() {
	    if (config.params.type === types.PLAYLIST) {
	      delete config.params.videoDuration;
	    }
	  }
	}
	YoutubeSearch.$inject = ["$http", "YOUTUBE_API_KEY", "YoutubeVideoInfo", "YoutubePlaylistInfo", "localStorageService", "preset", "toastr"];

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _angular = __webpack_require__(1);

	var _angular2 = _interopRequireDefault(_angular);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = YoutubeUser;

	/* @ngInject */

	function YoutubeUser($http, $q, GapiLoader) {
	    var data = {
	        status: {
	            signed_in: false
	        },
	        user: {},
	        auth: {}
	    };
	    var revokeUrl = 'https://accounts.google.com/o/oauth2/revoke?token=';
	    var service = {
	        update: update,
	        data: data,
	        signOut: signOut,
	        signIn: signIn,
	        isUserSignedIn: isUserSignedIn
	    };
	    GapiLoader.auth().then(function (authResult) {
	        _angular2.default.extend(data.status, authResult.status);
	        _angular2.default.merge(data.auth, authResult);
	    });

	    return service;

	    ////////////////

	    function update(user) {
	        _angular2.default.copy(user, data);
	    }

	    function signOut() {
	        data.status.signed_in = false;
	        data.user = {};
	        return gapi.auth.signOut();
	    }

	    function isUserSignedIn() {
	        return data.status && data.status.signed_in === true;
	    }

	    function signIn(userAuth) {
	        var status = userAuth.status;
	        _angular2.default.copy(userAuth.status, data.status);
	        if (!status.google_logged_in && !status.signed_in) {
	            return;
	        }
	        return $q.all([gapi.client.youtube.channels.list({
	            part: 'snippet,contentDetails',
	            mine: true
	        })]).then(saveUser, function (res) {
	            return console.log('not authorized', res);
	        });
	    }

	    function saveUser(result) {
	        // console.log('results user', result);
	        _angular2.default.copy(result[0].result.items[0], data.user);
	        // $rootScope.$broadcast('user-signed-in', data);
	        return result;
	    }
	}
	YoutubeUser.$inject = ["$http", "$q", "GapiLoader"];

/***/ },
/* 89 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = YoutubeVideoInfo;
	/* @ngInject */
	function YoutubeVideoInfo($q, $http, YOUTUBE_API_KEY, UserPlaylists) {
		var url = 'https://www.googleapis.com/youtube/v3/videos';
		var config = {
			params: {
				part: 'snippet,contentDetails,statistics',
				key: YOUTUBE_API_KEY,
				id: '',
				maxResults: 50
			}
		};

		var service = {
			list: list,
			setId: setId,
			toFriendlyDuration: toFriendlyDuration,
			getPlaylist: getPlaylist,
			enrichItems: enrichItems,
			enrichItemsInBulk: enrichItemsInBulk
		};

		return service;

		////////////////////////

		function list(id) {
			setId(id);
			var _config = {
				params: Object.assign({}, config.params)
			};
			return $http.get(url, _config).then(function (res) {
				return res.data.items;
			});
		}

		function setId(id) {
			config.params.id = id;
		}

		function toFriendlyDuration(time) {
			var t = time.split("PT")[1];
			var ts = '';
			if (t) {
				t = t.replace(/(H|M)/g, ":").replace("S", "");
				ts = t.split(":");
				ts = ts.map(function (d) {
					return d.length === 1 ? "0" + d : d;
				});
			} else {
				t = time.split("P")[1];
				t = t.replace("D", "");
				ts = [parseInt(t) * 24, ':00:00'];
			}
			return ts.join(":");
		}

		function getPlaylist(playlistId) {
			var defer = $q.defer();
			UserPlaylists.getPlaylist(playlistId).then(function (res) {
				return enrichItemsInBulk(res.items).then(function (res) {
					var videos = [];
					res[0].forEach(function (items) {
						videos = videos.concat(items);
					});
					defer.resolve(videos);
				});
			});
			return defer.promise;
			// .then(fetchContentDetails)
			// .then(addDuration);
		}

		function enrichItemsInBulk(items) {
			var amount = items.length;
			var pages = Math.ceil(amount / 50);
			var _items = [];
			var promises = [];
			for (var i = 0; i < pages; i++) {
				promises.push(createPromise(items, i));
			}
			return $q.all(promises);

			function createPromise(items, i) {
				var start = i * 50;
				var end = (i + 1) * 50;
				return fetchContentDetails({
					items: items.slice(start, end)
				}).then(addDuration).then(function (videos) {
					_items[i] = videos;
					return _items;
				});
			}
		}
		function fetchContentDetails(data) {
			var videoIds = data.items.map(function (video) {
				return video.snippet.resourceId.videoId;
			}).join(',');

			return list(videoIds);
		}

		function addDuration(items) {
			items.forEach(function (item) {
				item.time = toFriendlyDuration(item.contentDetails.duration);
			});
			return items;
		}

		function enrichItems(response) {
			return fetchContentDetails(response.result || response.data).then(addDuration);
		}
	}
	YoutubeVideoInfo.$inject = ["$q", "$http", "YOUTUBE_API_KEY", "UserPlaylists"];

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, process) { /*!
	  * https://github.com/paulmillr/es6-shim
	  * @license es6-shim Copyright 2013-2016 by Paul Miller (http://paulmillr.com)
	  *   and contributors,  MIT License
	  * es6-shim: v0.35.1
	  * see https://github.com/paulmillr/es6-shim/blob/0.35.1/LICENSE
	  * Details and documentation:
	  * https://github.com/paulmillr/es6-shim/
	  */

	// UMD (Universal Module Definition)
	// see https://github.com/umdjs/umd/blob/master/returnExports.js
	(function (root, factory) {
	  /*global define, module, exports */
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.returnExports = factory();
	  }
	}(this, function () {
	  'use strict';

	  var _apply = Function.call.bind(Function.apply);
	  var _call = Function.call.bind(Function.call);
	  var isArray = Array.isArray;
	  var keys = Object.keys;

	  var not = function notThunker(func) {
	    return function notThunk() {
	      return !_apply(func, this, arguments);
	    };
	  };
	  var throwsError = function (func) {
	    try {
	      func();
	      return false;
	    } catch (e) {
	      return true;
	    }
	  };
	  var valueOrFalseIfThrows = function valueOrFalseIfThrows(func) {
	    try {
	      return func();
	    } catch (e) {
	      return false;
	    }
	  };

	  var isCallableWithoutNew = not(throwsError);
	  var arePropertyDescriptorsSupported = function () {
	    // if Object.defineProperty exists but throws, it's IE 8
	    return !throwsError(function () {
	      Object.defineProperty({}, 'x', { get: function () {} });
	    });
	  };
	  var supportsDescriptors = !!Object.defineProperty && arePropertyDescriptorsSupported();
	  var functionsHaveNames = (function foo() {}).name === 'foo'; // eslint-disable-line no-extra-parens

	  var _forEach = Function.call.bind(Array.prototype.forEach);
	  var _reduce = Function.call.bind(Array.prototype.reduce);
	  var _filter = Function.call.bind(Array.prototype.filter);
	  var _some = Function.call.bind(Array.prototype.some);

	  var defineProperty = function (object, name, value, force) {
	    if (!force && name in object) { return; }
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };

	  // Define configurable, writable and non-enumerable props
	  // if they don’t exist.
	  var defineProperties = function (object, map, forceOverride) {
	    _forEach(keys(map), function (name) {
	      var method = map[name];
	      defineProperty(object, name, method, !!forceOverride);
	    });
	  };

	  var _toString = Function.call.bind(Object.prototype.toString);
	  var isCallable =  false ? function IsCallableSlow(x) {
	    // Some old browsers (IE, FF) say that typeof /abc/ === 'function'
	    return typeof x === 'function' && _toString(x) === '[object Function]';
	  } : function IsCallableFast(x) { return typeof x === 'function'; };

	  var Value = {
	    getter: function (object, name, getter) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        get: getter
	      });
	    },
	    proxy: function (originalObject, key, targetObject) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      var originalDescriptor = Object.getOwnPropertyDescriptor(originalObject, key);
	      Object.defineProperty(targetObject, key, {
	        configurable: originalDescriptor.configurable,
	        enumerable: originalDescriptor.enumerable,
	        get: function getKey() { return originalObject[key]; },
	        set: function setKey(value) { originalObject[key] = value; }
	      });
	    },
	    redefine: function (object, property, newValue) {
	      if (supportsDescriptors) {
	        var descriptor = Object.getOwnPropertyDescriptor(object, property);
	        descriptor.value = newValue;
	        Object.defineProperty(object, property, descriptor);
	      } else {
	        object[property] = newValue;
	      }
	    },
	    defineByDescriptor: function (object, property, descriptor) {
	      if (supportsDescriptors) {
	        Object.defineProperty(object, property, descriptor);
	      } else if ('value' in descriptor) {
	        object[property] = descriptor.value;
	      }
	    },
	    preserveToString: function (target, source) {
	      if (source && isCallable(source.toString)) {
	        defineProperty(target, 'toString', source.toString.bind(source), true);
	      }
	    }
	  };

	  // Simple shim for Object.create on ES3 browsers
	  // (unlike real shim, no attempt to support `prototype === null`)
	  var create = Object.create || function (prototype, properties) {
	    var Prototype = function Prototype() {};
	    Prototype.prototype = prototype;
	    var object = new Prototype();
	    if (typeof properties !== 'undefined') {
	      keys(properties).forEach(function (key) {
	        Value.defineByDescriptor(object, key, properties[key]);
	      });
	    }
	    return object;
	  };

	  var supportsSubclassing = function (C, f) {
	    if (!Object.setPrototypeOf) { return false; /* skip test on IE < 11 */ }
	    return valueOrFalseIfThrows(function () {
	      var Sub = function Subclass(arg) {
	        var o = new C(arg);
	        Object.setPrototypeOf(o, Subclass.prototype);
	        return o;
	      };
	      Object.setPrototypeOf(Sub, C);
	      Sub.prototype = create(C.prototype, {
	        constructor: { value: Sub }
	      });
	      return f(Sub);
	    });
	  };

	  var getGlobal = function () {
	    /* global self, window, global */
	    // the only reliable means to get the global object is
	    // `Function('return this')()`
	    // However, this causes CSP violations in Chrome apps.
	    if (typeof self !== 'undefined') { return self; }
	    if (typeof window !== 'undefined') { return window; }
	    if (typeof global !== 'undefined') { return global; }
	    throw new Error('unable to locate global object');
	  };

	  var globals = getGlobal();
	  var globalIsFinite = globals.isFinite;
	  var _indexOf = Function.call.bind(String.prototype.indexOf);
	  var _arrayIndexOfApply = Function.apply.bind(Array.prototype.indexOf);
	  var _concat = Function.call.bind(Array.prototype.concat);
	  // var _sort = Function.call.bind(Array.prototype.sort);
	  var _strSlice = Function.call.bind(String.prototype.slice);
	  var _push = Function.call.bind(Array.prototype.push);
	  var _pushApply = Function.apply.bind(Array.prototype.push);
	  var _shift = Function.call.bind(Array.prototype.shift);
	  var _max = Math.max;
	  var _min = Math.min;
	  var _floor = Math.floor;
	  var _abs = Math.abs;
	  var _exp = Math.exp;
	  var _log = Math.log;
	  var _sqrt = Math.sqrt;
	  var _hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
	  var ArrayIterator; // make our implementation private
	  var noop = function () {};

	  var Symbol = globals.Symbol || {};
	  var symbolSpecies = Symbol.species || '@@species';

	  var numberIsNaN = Number.isNaN || function isNaN(value) {
	    // NaN !== NaN, but they are identical.
	    // NaNs are the only non-reflexive value, i.e., if x !== x,
	    // then x is NaN.
	    // isNaN is broken: it converts its argument to number, so
	    // isNaN('foo') => true
	    return value !== value;
	  };
	  var numberIsFinite = Number.isFinite || function isFinite(value) {
	    return typeof value === 'number' && globalIsFinite(value);
	  };
	  var _sign = isCallable(Math.sign) ? Math.sign : function sign(value) {
	    var number = Number(value);
	    if (number === 0) { return number; }
	    if (numberIsNaN(number)) { return number; }
	    return number < 0 ? -1 : 1;
	  };

	  // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
	  // can be replaced with require('is-arguments') if we ever use a build process instead
	  var isStandardArguments = function isArguments(value) {
	    return _toString(value) === '[object Arguments]';
	  };
	  var isLegacyArguments = function isArguments(value) {
	    return value !== null &&
	      typeof value === 'object' &&
	      typeof value.length === 'number' &&
	      value.length >= 0 &&
	      _toString(value) !== '[object Array]' &&
	      _toString(value.callee) === '[object Function]';
	  };
	  var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;

	  var Type = {
	    primitive: function (x) { return x === null || (typeof x !== 'function' && typeof x !== 'object'); },
	    string: function (x) { return _toString(x) === '[object String]'; },
	    regex: function (x) { return _toString(x) === '[object RegExp]'; },
	    symbol: function (x) {
	      return typeof globals.Symbol === 'function' && typeof x === 'symbol';
	    }
	  };

	  var overrideNative = function overrideNative(object, property, replacement) {
	    var original = object[property];
	    defineProperty(object, property, replacement, true);
	    Value.preserveToString(object[property], original);
	  };

	  var hasSymbols = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' && Type.symbol(Symbol());

	  // This is a private name in the es6 spec, equal to '[Symbol.iterator]'
	  // we're going to use an arbitrary _-prefixed name to make our shims
	  // work properly with each other, even though we don't have full Iterator
	  // support.  That is, `Array.from(map.keys())` will work, but we don't
	  // pretend to export a "real" Iterator interface.
	  var $iterator$ = Type.symbol(Symbol.iterator) ? Symbol.iterator : '_es6-shim iterator_';
	  // Firefox ships a partial implementation using the name @@iterator.
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=907077#c14
	  // So use that name if we detect it.
	  if (globals.Set && typeof new globals.Set()['@@iterator'] === 'function') {
	    $iterator$ = '@@iterator';
	  }

	  // Reflect
	  if (!globals.Reflect) {
	    defineProperty(globals, 'Reflect', {}, true);
	  }
	  var Reflect = globals.Reflect;

	  var $String = String;

	  var ES = {
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-call
	    Call: function Call(F, V) {
	      var args = arguments.length > 2 ? arguments[2] : [];
	      if (!ES.IsCallable(F)) {
	        throw new TypeError(F + ' is not a function');
	      }
	      return _apply(F, V, args);
	    },

	    RequireObjectCoercible: function (x, optMessage) {
	      /* jshint eqnull:true */
	      if (x == null) {
	        throw new TypeError(optMessage || 'Cannot call method on ' + x);
	      }
	      return x;
	    },

	    // This might miss the "(non-standard exotic and does not implement
	    // [[Call]])" case from
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-typeof-operator-runtime-semantics-evaluation
	    // but we can't find any evidence these objects exist in practice.
	    // If we find some in the future, you could test `Object(x) === x`,
	    // which is reliable according to
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toobject
	    // but is not well optimized by runtimes and creates an object
	    // whenever it returns false, and thus is very slow.
	    TypeIsObject: function (x) {
	      if (x === void 0 || x === null || x === true || x === false) {
	        return false;
	      }
	      return typeof x === 'function' || typeof x === 'object';
	    },

	    ToObject: function (o, optMessage) {
	      return Object(ES.RequireObjectCoercible(o, optMessage));
	    },

	    IsCallable: isCallable,

	    IsConstructor: function (x) {
	      // We can't tell callables from constructors in ES5
	      return ES.IsCallable(x);
	    },

	    ToInt32: function (x) {
	      return ES.ToNumber(x) >> 0;
	    },

	    ToUint32: function (x) {
	      return ES.ToNumber(x) >>> 0;
	    },

	    ToNumber: function (value) {
	      if (_toString(value) === '[object Symbol]') {
	        throw new TypeError('Cannot convert a Symbol value to a number');
	      }
	      return +value;
	    },

	    ToInteger: function (value) {
	      var number = ES.ToNumber(value);
	      if (numberIsNaN(number)) { return 0; }
	      if (number === 0 || !numberIsFinite(number)) { return number; }
	      return (number > 0 ? 1 : -1) * _floor(_abs(number));
	    },

	    ToLength: function (value) {
	      var len = ES.ToInteger(value);
	      if (len <= 0) { return 0; } // includes converting -0 to +0
	      if (len > Number.MAX_SAFE_INTEGER) { return Number.MAX_SAFE_INTEGER; }
	      return len;
	    },

	    SameValue: function (a, b) {
	      if (a === b) {
	        // 0 === -0, but they are not identical.
	        if (a === 0) { return 1 / a === 1 / b; }
	        return true;
	      }
	      return numberIsNaN(a) && numberIsNaN(b);
	    },

	    SameValueZero: function (a, b) {
	      // same as SameValue except for SameValueZero(+0, -0) == true
	      return (a === b) || (numberIsNaN(a) && numberIsNaN(b));
	    },

	    IsIterable: function (o) {
	      return ES.TypeIsObject(o) && (typeof o[$iterator$] !== 'undefined' || isArguments(o));
	    },

	    GetIterator: function (o) {
	      if (isArguments(o)) {
	        // special case support for `arguments`
	        return new ArrayIterator(o, 'value');
	      }
	      var itFn = ES.GetMethod(o, $iterator$);
	      if (!ES.IsCallable(itFn)) {
	        // Better diagnostics if itFn is null or undefined
	        throw new TypeError('value is not an iterable');
	      }
	      var it = ES.Call(itFn, o);
	      if (!ES.TypeIsObject(it)) {
	        throw new TypeError('bad iterator');
	      }
	      return it;
	    },

	    GetMethod: function (o, p) {
	      var func = ES.ToObject(o)[p];
	      if (func === void 0 || func === null) {
	        return void 0;
	      }
	      if (!ES.IsCallable(func)) {
	        throw new TypeError('Method not callable: ' + p);
	      }
	      return func;
	    },

	    IteratorComplete: function (iterResult) {
	      return !!iterResult.done;
	    },

	    IteratorClose: function (iterator, completionIsThrow) {
	      var returnMethod = ES.GetMethod(iterator, 'return');
	      if (returnMethod === void 0) {
	        return;
	      }
	      var innerResult, innerException;
	      try {
	        innerResult = ES.Call(returnMethod, iterator);
	      } catch (e) {
	        innerException = e;
	      }
	      if (completionIsThrow) {
	        return;
	      }
	      if (innerException) {
	        throw innerException;
	      }
	      if (!ES.TypeIsObject(innerResult)) {
	        throw new TypeError("Iterator's return method returned a non-object.");
	      }
	    },

	    IteratorNext: function (it) {
	      var result = arguments.length > 1 ? it.next(arguments[1]) : it.next();
	      if (!ES.TypeIsObject(result)) {
	        throw new TypeError('bad iterator');
	      }
	      return result;
	    },

	    IteratorStep: function (it) {
	      var result = ES.IteratorNext(it);
	      var done = ES.IteratorComplete(result);
	      return done ? false : result;
	    },

	    Construct: function (C, args, newTarget, isES6internal) {
	      var target = typeof newTarget === 'undefined' ? C : newTarget;

	      if (!isES6internal && Reflect.construct) {
	        // Try to use Reflect.construct if available
	        return Reflect.construct(C, args, target);
	      }
	      // OK, we have to fake it.  This will only work if the
	      // C.[[ConstructorKind]] == "base" -- but that's the only
	      // kind we can make in ES5 code anyway.

	      // OrdinaryCreateFromConstructor(target, "%ObjectPrototype%")
	      var proto = target.prototype;
	      if (!ES.TypeIsObject(proto)) {
	        proto = Object.prototype;
	      }
	      var obj = create(proto);
	      // Call the constructor.
	      var result = ES.Call(C, obj, args);
	      return ES.TypeIsObject(result) ? result : obj;
	    },

	    SpeciesConstructor: function (O, defaultConstructor) {
	      var C = O.constructor;
	      if (C === void 0) {
	        return defaultConstructor;
	      }
	      if (!ES.TypeIsObject(C)) {
	        throw new TypeError('Bad constructor');
	      }
	      var S = C[symbolSpecies];
	      if (S === void 0 || S === null) {
	        return defaultConstructor;
	      }
	      if (!ES.IsConstructor(S)) {
	        throw new TypeError('Bad @@species');
	      }
	      return S;
	    },

	    CreateHTML: function (string, tag, attribute, value) {
	      var S = ES.ToString(string);
	      var p1 = '<' + tag;
	      if (attribute !== '') {
	        var V = ES.ToString(value);
	        var escapedV = V.replace(/"/g, '&quot;');
	        p1 += ' ' + attribute + '="' + escapedV + '"';
	      }
	      var p2 = p1 + '>';
	      var p3 = p2 + S;
	      return p3 + '</' + tag + '>';
	    },

	    IsRegExp: function IsRegExp(argument) {
	      if (!ES.TypeIsObject(argument)) {
	        return false;
	      }
	      var isRegExp = argument[Symbol.match];
	      if (typeof isRegExp !== 'undefined') {
	        return !!isRegExp;
	      }
	      return Type.regex(argument);
	    },

	    ToString: function ToString(string) {
	      return $String(string);
	    }
	  };

	  // Well-known Symbol shims
	  if (supportsDescriptors && hasSymbols) {
	    var defineWellKnownSymbol = function defineWellKnownSymbol(name) {
	      if (Type.symbol(Symbol[name])) {
	        return Symbol[name];
	      }
	      var sym = Symbol['for']('Symbol.' + name);
	      Object.defineProperty(Symbol, name, {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: sym
	      });
	      return sym;
	    };
	    if (!Type.symbol(Symbol.search)) {
	      var symbolSearch = defineWellKnownSymbol('search');
	      var originalSearch = String.prototype.search;
	      defineProperty(RegExp.prototype, symbolSearch, function search(string) {
	        return ES.Call(originalSearch, string, [this]);
	      });
	      var searchShim = function search(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (regexp !== null && typeof regexp !== 'undefined') {
	          var searcher = ES.GetMethod(regexp, symbolSearch);
	          if (typeof searcher !== 'undefined') {
	            return ES.Call(searcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalSearch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'search', searchShim);
	    }
	    if (!Type.symbol(Symbol.replace)) {
	      var symbolReplace = defineWellKnownSymbol('replace');
	      var originalReplace = String.prototype.replace;
	      defineProperty(RegExp.prototype, symbolReplace, function replace(string, replaceValue) {
	        return ES.Call(originalReplace, string, [this, replaceValue]);
	      });
	      var replaceShim = function replace(searchValue, replaceValue) {
	        var O = ES.RequireObjectCoercible(this);
	        if (searchValue !== null && typeof searchValue !== 'undefined') {
	          var replacer = ES.GetMethod(searchValue, symbolReplace);
	          if (typeof replacer !== 'undefined') {
	            return ES.Call(replacer, searchValue, [O, replaceValue]);
	          }
	        }
	        return ES.Call(originalReplace, O, [ES.ToString(searchValue), replaceValue]);
	      };
	      overrideNative(String.prototype, 'replace', replaceShim);
	    }
	    if (!Type.symbol(Symbol.split)) {
	      var symbolSplit = defineWellKnownSymbol('split');
	      var originalSplit = String.prototype.split;
	      defineProperty(RegExp.prototype, symbolSplit, function split(string, limit) {
	        return ES.Call(originalSplit, string, [this, limit]);
	      });
	      var splitShim = function split(separator, limit) {
	        var O = ES.RequireObjectCoercible(this);
	        if (separator !== null && typeof separator !== 'undefined') {
	          var splitter = ES.GetMethod(separator, symbolSplit);
	          if (typeof splitter !== 'undefined') {
	            return ES.Call(splitter, separator, [O, limit]);
	          }
	        }
	        return ES.Call(originalSplit, O, [ES.ToString(separator), limit]);
	      };
	      overrideNative(String.prototype, 'split', splitShim);
	    }
	    var symbolMatchExists = Type.symbol(Symbol.match);
	    var stringMatchIgnoresSymbolMatch = symbolMatchExists && (function () {
	      // Firefox 41, through Nightly 45 has Symbol.match, but String#match ignores it.
	      // Firefox 40 and below have Symbol.match but String#match works fine.
	      var o = {};
	      o[Symbol.match] = function () { return 42; };
	      return 'a'.match(o) !== 42;
	    }());
	    if (!symbolMatchExists || stringMatchIgnoresSymbolMatch) {
	      var symbolMatch = defineWellKnownSymbol('match');

	      var originalMatch = String.prototype.match;
	      defineProperty(RegExp.prototype, symbolMatch, function match(string) {
	        return ES.Call(originalMatch, string, [this]);
	      });

	      var matchShim = function match(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (regexp !== null && typeof regexp !== 'undefined') {
	          var matcher = ES.GetMethod(regexp, symbolMatch);
	          if (typeof matcher !== 'undefined') {
	            return ES.Call(matcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalMatch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'match', matchShim);
	    }
	  }

	  var wrapConstructor = function wrapConstructor(original, replacement, keysToSkip) {
	    Value.preserveToString(replacement, original);
	    if (Object.setPrototypeOf) {
	      // sets up proper prototype chain where possible
	      Object.setPrototypeOf(original, replacement);
	    }
	    if (supportsDescriptors) {
	      _forEach(Object.getOwnPropertyNames(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        Value.proxy(original, key, replacement);
	      });
	    } else {
	      _forEach(Object.keys(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        replacement[key] = original[key];
	      });
	    }
	    replacement.prototype = original.prototype;
	    Value.redefine(original.prototype, 'constructor', replacement);
	  };

	  var defaultSpeciesGetter = function () { return this; };
	  var addDefaultSpecies = function (C) {
	    if (supportsDescriptors && !_hasOwnProperty(C, symbolSpecies)) {
	      Value.getter(C, symbolSpecies, defaultSpeciesGetter);
	    }
	  };

	  var addIterator = function (prototype, impl) {
	    var implementation = impl || function iterator() { return this; };
	    defineProperty(prototype, $iterator$, implementation);
	    if (!prototype[$iterator$] && Type.symbol($iterator$)) {
	      // implementations are buggy when $iterator$ is a Symbol
	      prototype[$iterator$] = implementation;
	    }
	  };

	  var createDataProperty = function createDataProperty(object, name, value) {
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: true,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };
	  var createDataPropertyOrThrow = function createDataPropertyOrThrow(object, name, value) {
	    createDataProperty(object, name, value);
	    if (!ES.SameValue(object[name], value)) {
	      throw new TypeError('property is nonconfigurable');
	    }
	  };

	  var emulateES6construct = function (o, defaultNewTarget, defaultProto, slots) {
	    // This is an es5 approximation to es6 construct semantics.  in es6,
	    // 'new Foo' invokes Foo.[[Construct]] which (for almost all objects)
	    // just sets the internal variable NewTarget (in es6 syntax `new.target`)
	    // to Foo and then returns Foo().

	    // Many ES6 object then have constructors of the form:
	    // 1. If NewTarget is undefined, throw a TypeError exception
	    // 2. Let xxx by OrdinaryCreateFromConstructor(NewTarget, yyy, zzz)

	    // So we're going to emulate those first two steps.
	    if (!ES.TypeIsObject(o)) {
	      throw new TypeError('Constructor requires `new`: ' + defaultNewTarget.name);
	    }
	    var proto = defaultNewTarget.prototype;
	    if (!ES.TypeIsObject(proto)) {
	      proto = defaultProto;
	    }
	    var obj = create(proto);
	    for (var name in slots) {
	      if (_hasOwnProperty(slots, name)) {
	        var value = slots[name];
	        defineProperty(obj, name, value, true);
	      }
	    }
	    return obj;
	  };

	  // Firefox 31 reports this function's length as 0
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1062484
	  if (String.fromCodePoint && String.fromCodePoint.length !== 1) {
	    var originalFromCodePoint = String.fromCodePoint;
	    overrideNative(String, 'fromCodePoint', function fromCodePoint(codePoints) {
	      return ES.Call(originalFromCodePoint, this, arguments);
	    });
	  }

	  var StringShims = {
	    fromCodePoint: function fromCodePoint(codePoints) {
	      var result = [];
	      var next;
	      for (var i = 0, length = arguments.length; i < length; i++) {
	        next = Number(arguments[i]);
	        if (!ES.SameValue(next, ES.ToInteger(next)) || next < 0 || next > 0x10FFFF) {
	          throw new RangeError('Invalid code point ' + next);
	        }

	        if (next < 0x10000) {
	          _push(result, String.fromCharCode(next));
	        } else {
	          next -= 0x10000;
	          _push(result, String.fromCharCode((next >> 10) + 0xD800));
	          _push(result, String.fromCharCode((next % 0x400) + 0xDC00));
	        }
	      }
	      return result.join('');
	    },

	    raw: function raw(callSite) {
	      var cooked = ES.ToObject(callSite, 'bad callSite');
	      var rawString = ES.ToObject(cooked.raw, 'bad raw value');
	      var len = rawString.length;
	      var literalsegments = ES.ToLength(len);
	      if (literalsegments <= 0) {
	        return '';
	      }

	      var stringElements = [];
	      var nextIndex = 0;
	      var nextKey, next, nextSeg, nextSub;
	      while (nextIndex < literalsegments) {
	        nextKey = ES.ToString(nextIndex);
	        nextSeg = ES.ToString(rawString[nextKey]);
	        _push(stringElements, nextSeg);
	        if (nextIndex + 1 >= literalsegments) {
	          break;
	        }
	        next = nextIndex + 1 < arguments.length ? arguments[nextIndex + 1] : '';
	        nextSub = ES.ToString(next);
	        _push(stringElements, nextSub);
	        nextIndex += 1;
	      }
	      return stringElements.join('');
	    }
	  };
	  if (String.raw && String.raw({ raw: { 0: 'x', 1: 'y', length: 2 } }) !== 'xy') {
	    // IE 11 TP has a broken String.raw implementation
	    overrideNative(String, 'raw', StringShims.raw);
	  }
	  defineProperties(String, StringShims);

	  // Fast repeat, uses the `Exponentiation by squaring` algorithm.
	  // Perf: http://jsperf.com/string-repeat2/2
	  var stringRepeat = function repeat(s, times) {
	    if (times < 1) { return ''; }
	    if (times % 2) { return repeat(s, times - 1) + s; }
	    var half = repeat(s, times / 2);
	    return half + half;
	  };
	  var stringMaxLength = Infinity;

	  var StringPrototypeShims = {
	    repeat: function repeat(times) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var numTimes = ES.ToInteger(times);
	      if (numTimes < 0 || numTimes >= stringMaxLength) {
	        throw new RangeError('repeat count must be less than infinity and not overflow maximum string size');
	      }
	      return stringRepeat(thisStr, numTimes);
	    },

	    startsWith: function startsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "startsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      var start = _max(ES.ToInteger(position), 0);
	      return _strSlice(S, start, start + searchStr.length) === searchStr;
	    },

	    endsWith: function endsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "endsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var len = S.length;
	      var endPosition;
	      if (arguments.length > 1) {
	        endPosition = arguments[1];
	      }
	      var pos = typeof endPosition === 'undefined' ? len : ES.ToInteger(endPosition);
	      var end = _min(_max(pos, 0), len);
	      return _strSlice(S, end - searchStr.length, end) === searchStr;
	    },

	    includes: function includes(searchString) {
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('"includes" does not accept a RegExp');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      // Somehow this trick makes method 100% compat with the spec.
	      return _indexOf(this, searchStr, position) !== -1;
	    },

	    codePointAt: function codePointAt(pos) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var position = ES.ToInteger(pos);
	      var length = thisStr.length;
	      if (position >= 0 && position < length) {
	        var first = thisStr.charCodeAt(position);
	        var isEnd = position + 1 === length;
	        if (first < 0xD800 || first > 0xDBFF || isEnd) { return first; }
	        var second = thisStr.charCodeAt(position + 1);
	        if (second < 0xDC00 || second > 0xDFFF) { return first; }
	        return ((first - 0xD800) * 1024) + (second - 0xDC00) + 0x10000;
	      }
	    }
	  };
	  if (String.prototype.includes && 'a'.includes('a', Infinity) !== false) {
	    overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	  }

	  if (String.prototype.startsWith && String.prototype.endsWith) {
	    var startsWithRejectsRegex = throwsError(function () {
	      /* throws if spec-compliant */
	      '/a/'.startsWith(/a/);
	    });
	    var startsWithHandlesInfinity = valueOrFalseIfThrows(function () {
	      return 'abc'.startsWith('a', Infinity) === false;
	    });
	    if (!startsWithRejectsRegex || !startsWithHandlesInfinity) {
	      // Firefox (< 37?) and IE 11 TP have a noncompliant startsWith implementation
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	  }
	  if (hasSymbols) {
	    var startsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.startsWith(re);
	    });
	    if (!startsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	    }
	    var endsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.endsWith(re);
	    });
	    if (!endsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	    var includesSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.includes(re);
	    });
	    if (!includesSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	    }
	  }

	  defineProperties(String.prototype, StringPrototypeShims);

	  // whitespace from: http://es5.github.io/#x15.5.4.20
	  // implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	  var ws = [
	    '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	    '\u2029\uFEFF'
	  ].join('');
	  var trimRegexp = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	  var trimShim = function trim() {
	    return ES.ToString(ES.RequireObjectCoercible(this)).replace(trimRegexp, '');
	  };
	  var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	  var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	  var isBadHexRegex = /^[\-+]0x[0-9a-f]+$/i;
	  var hasStringTrimBug = nonWS.trim().length !== nonWS.length;
	  defineProperty(String.prototype, 'trim', trimShim, hasStringTrimBug);

	  // Given an argument x, it will return an IteratorResult object,
	  // with value set to x and done to false.
	  // Given no arguments, it will return an iterator completion object.
	  var iteratorResult = function (x) {
	    return { value: x, done: arguments.length === 0 };
	  };

	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-string.prototype-@@iterator
	  var StringIterator = function (s) {
	    ES.RequireObjectCoercible(s);
	    this._s = ES.ToString(s);
	    this._i = 0;
	  };
	  StringIterator.prototype.next = function () {
	    var s = this._s;
	    var i = this._i;
	    if (typeof s === 'undefined' || i >= s.length) {
	      this._s = void 0;
	      return iteratorResult();
	    }
	    var first = s.charCodeAt(i);
	    var second, len;
	    if (first < 0xD800 || first > 0xDBFF || (i + 1) === s.length) {
	      len = 1;
	    } else {
	      second = s.charCodeAt(i + 1);
	      len = (second < 0xDC00 || second > 0xDFFF) ? 1 : 2;
	    }
	    this._i = i + len;
	    return iteratorResult(s.substr(i, len));
	  };
	  addIterator(StringIterator.prototype);
	  addIterator(String.prototype, function () {
	    return new StringIterator(this);
	  });

	  var ArrayShims = {
	    from: function from(items) {
	      var C = this;
	      var mapFn;
	      if (arguments.length > 1) {
	        mapFn = arguments[1];
	      }
	      var mapping, T;
	      if (typeof mapFn === 'undefined') {
	        mapping = false;
	      } else {
	        if (!ES.IsCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	        mapping = true;
	      }

	      // Note that that Arrays will use ArrayIterator:
	      // https://bugs.ecmascript.org/show_bug.cgi?id=2416
	      var usingIterator = typeof (isArguments(items) || ES.GetMethod(items, $iterator$)) !== 'undefined';

	      var length, result, i;
	      if (usingIterator) {
	        result = ES.IsConstructor(C) ? Object(new C()) : [];
	        var iterator = ES.GetIterator(items);
	        var next, nextValue;

	        i = 0;
	        while (true) {
	          next = ES.IteratorStep(iterator);
	          if (next === false) {
	            break;
	          }
	          nextValue = next.value;
	          try {
	            if (mapping) {
	              nextValue = typeof T === 'undefined' ? mapFn(nextValue, i) : _call(mapFn, T, nextValue, i);
	            }
	            result[i] = nextValue;
	          } catch (e) {
	            ES.IteratorClose(iterator, true);
	            throw e;
	          }
	          i += 1;
	        }
	        length = i;
	      } else {
	        var arrayLike = ES.ToObject(items);
	        length = ES.ToLength(arrayLike.length);
	        result = ES.IsConstructor(C) ? Object(new C(length)) : new Array(length);
	        var value;
	        for (i = 0; i < length; ++i) {
	          value = arrayLike[i];
	          if (mapping) {
	            value = typeof T === 'undefined' ? mapFn(value, i) : _call(mapFn, T, value, i);
	          }
	          createDataPropertyOrThrow(result, i, value);
	        }
	      }

	      result.length = length;
	      return result;
	    },

	    of: function of() {
	      var len = arguments.length;
	      var C = this;
	      var A = isArray(C) || !ES.IsCallable(C) ? new Array(len) : ES.Construct(C, [len]);
	      for (var k = 0; k < len; ++k) {
	        createDataPropertyOrThrow(A, k, arguments[k]);
	      }
	      A.length = len;
	      return A;
	    }
	  };
	  defineProperties(Array, ArrayShims);
	  addDefaultSpecies(Array);

	  // Our ArrayIterator is private; see
	  // https://github.com/paulmillr/es6-shim/issues/252
	  ArrayIterator = function (array, kind) {
	    this.i = 0;
	    this.array = array;
	    this.kind = kind;
	  };

	  defineProperties(ArrayIterator.prototype, {
	    next: function () {
	      var i = this.i;
	      var array = this.array;
	      if (!(this instanceof ArrayIterator)) {
	        throw new TypeError('Not an ArrayIterator');
	      }
	      if (typeof array !== 'undefined') {
	        var len = ES.ToLength(array.length);
	        for (; i < len; i++) {
	          var kind = this.kind;
	          var retval;
	          if (kind === 'key') {
	            retval = i;
	          } else if (kind === 'value') {
	            retval = array[i];
	          } else if (kind === 'entry') {
	            retval = [i, array[i]];
	          }
	          this.i = i + 1;
	          return iteratorResult(retval);
	        }
	      }
	      this.array = void 0;
	      return iteratorResult();
	    }
	  });
	  addIterator(ArrayIterator.prototype);

	/*
	  var orderKeys = function orderKeys(a, b) {
	    var aNumeric = String(ES.ToInteger(a)) === a;
	    var bNumeric = String(ES.ToInteger(b)) === b;
	    if (aNumeric && bNumeric) {
	      return b - a;
	    } else if (aNumeric && !bNumeric) {
	      return -1;
	    } else if (!aNumeric && bNumeric) {
	      return 1;
	    } else {
	      return a.localeCompare(b);
	    }
	  };

	  var getAllKeys = function getAllKeys(object) {
	    var ownKeys = [];
	    var keys = [];

	    for (var key in object) {
	      _push(_hasOwnProperty(object, key) ? ownKeys : keys, key);
	    }
	    _sort(ownKeys, orderKeys);
	    _sort(keys, orderKeys);

	    return _concat(ownKeys, keys);
	  };
	  */

	  // note: this is positioned here because it depends on ArrayIterator
	  var arrayOfSupportsSubclassing = Array.of === ArrayShims.of || (function () {
	    // Detects a bug in Webkit nightly r181886
	    var Foo = function Foo(len) { this.length = len; };
	    Foo.prototype = [];
	    var fooArr = Array.of.apply(Foo, [1, 2]);
	    return fooArr instanceof Foo && fooArr.length === 2;
	  }());
	  if (!arrayOfSupportsSubclassing) {
	    overrideNative(Array, 'of', ArrayShims.of);
	  }

	  var ArrayPrototypeShims = {
	    copyWithin: function copyWithin(target, start) {
	      var o = ES.ToObject(this);
	      var len = ES.ToLength(o.length);
	      var relativeTarget = ES.ToInteger(target);
	      var relativeStart = ES.ToInteger(start);
	      var to = relativeTarget < 0 ? _max(len + relativeTarget, 0) : _min(relativeTarget, len);
	      var from = relativeStart < 0 ? _max(len + relativeStart, 0) : _min(relativeStart, len);
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var relativeEnd = typeof end === 'undefined' ? len : ES.ToInteger(end);
	      var finalItem = relativeEnd < 0 ? _max(len + relativeEnd, 0) : _min(relativeEnd, len);
	      var count = _min(finalItem - from, len - to);
	      var direction = 1;
	      if (from < to && to < (from + count)) {
	        direction = -1;
	        from += count - 1;
	        to += count - 1;
	      }
	      while (count > 0) {
	        if (from in o) {
	          o[to] = o[from];
	        } else {
	          delete o[to];
	        }
	        from += direction;
	        to += direction;
	        count -= 1;
	      }
	      return o;
	    },

	    fill: function fill(value) {
	      var start;
	      if (arguments.length > 1) {
	        start = arguments[1];
	      }
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var O = ES.ToObject(this);
	      var len = ES.ToLength(O.length);
	      start = ES.ToInteger(typeof start === 'undefined' ? 0 : start);
	      end = ES.ToInteger(typeof end === 'undefined' ? len : end);

	      var relativeStart = start < 0 ? _max(len + start, 0) : _min(start, len);
	      var relativeEnd = end < 0 ? len + end : end;

	      for (var i = relativeStart; i < len && i < relativeEnd; ++i) {
	        O[i] = value;
	      }
	      return O;
	    },

	    find: function find(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#find: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0, value; i < length; i++) {
	        value = list[i];
	        if (thisArg) {
	          if (_call(predicate, thisArg, value, i, list)) {
	            return value;
	          }
	        } else if (predicate(value, i, list)) {
	          return value;
	        }
	      }
	    },

	    findIndex: function findIndex(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#findIndex: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0; i < length; i++) {
	        if (thisArg) {
	          if (_call(predicate, thisArg, list[i], i, list)) {
	            return i;
	          }
	        } else if (predicate(list[i], i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    },

	    keys: function keys() {
	      return new ArrayIterator(this, 'key');
	    },

	    values: function values() {
	      return new ArrayIterator(this, 'value');
	    },

	    entries: function entries() {
	      return new ArrayIterator(this, 'entry');
	    }
	  };
	  // Safari 7.1 defines Array#keys and Array#entries natively,
	  // but the resulting ArrayIterator objects don't have a "next" method.
	  if (Array.prototype.keys && !ES.IsCallable([1].keys().next)) {
	    delete Array.prototype.keys;
	  }
	  if (Array.prototype.entries && !ES.IsCallable([1].entries().next)) {
	    delete Array.prototype.entries;
	  }

	  // Chrome 38 defines Array#keys and Array#entries, and Array#@@iterator, but not Array#values
	  if (Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[$iterator$]) {
	    defineProperties(Array.prototype, {
	      values: Array.prototype[$iterator$]
	    });
	    if (Type.symbol(Symbol.unscopables)) {
	      Array.prototype[Symbol.unscopables].values = true;
	    }
	  }
	  // Chrome 40 defines Array#values with the incorrect name, although Array#{keys,entries} have the correct name
	  if (functionsHaveNames && Array.prototype.values && Array.prototype.values.name !== 'values') {
	    var originalArrayPrototypeValues = Array.prototype.values;
	    overrideNative(Array.prototype, 'values', function values() { return ES.Call(originalArrayPrototypeValues, this, arguments); });
	    defineProperty(Array.prototype, $iterator$, Array.prototype.values, true);
	  }
	  defineProperties(Array.prototype, ArrayPrototypeShims);

	  if (1 / [true].indexOf(true, -0) < 0) {
	    // indexOf when given a position arg of -0 should return +0.
	    // https://github.com/tc39/ecma262/pull/316
	    defineProperty(Array.prototype, 'indexOf', function indexOf(searchElement) {
	      var value = _arrayIndexOfApply(this, arguments);
	      if (value === 0 && (1 / value) < 0) {
	        return 0;
	      }
	      return value;
	    }, true);
	  }

	  addIterator(Array.prototype, function () { return this.values(); });
	  // Chrome defines keys/values/entries on Array, but doesn't give us
	  // any way to identify its iterator.  So add our own shimmed field.
	  if (Object.getPrototypeOf) {
	    addIterator(Object.getPrototypeOf([].values()));
	  }

	  // note: this is positioned here because it relies on Array#entries
	  var arrayFromSwallowsNegativeLengths = (function () {
	    // Detects a Firefox bug in v32
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=1063993
	    return valueOrFalseIfThrows(function () {
	      return Array.from({ length: -1 }).length === 0;
	    });
	  }());
	  var arrayFromHandlesIterables = (function () {
	    // Detects a bug in Webkit nightly r181886
	    var arr = Array.from([0].entries());
	    return arr.length === 1 && isArray(arr[0]) && arr[0][0] === 0 && arr[0][1] === 0;
	  }());
	  if (!arrayFromSwallowsNegativeLengths || !arrayFromHandlesIterables) {
	    overrideNative(Array, 'from', ArrayShims.from);
	  }
	  var arrayFromHandlesUndefinedMapFunction = (function () {
	    // Microsoft Edge v0.11 throws if the mapFn argument is *provided* but undefined,
	    // but the spec doesn't care if it's provided or not - undefined doesn't throw.
	    return valueOrFalseIfThrows(function () {
	      return Array.from([0], void 0);
	    });
	  }());
	  if (!arrayFromHandlesUndefinedMapFunction) {
	    var origArrayFrom = Array.from;
	    overrideNative(Array, 'from', function from(items) {
	      if (arguments.length > 1 && typeof arguments[1] !== 'undefined') {
	        return ES.Call(origArrayFrom, this, arguments);
	      } else {
	        return _call(origArrayFrom, this, items);
	      }
	    });
	  }

	  var int32sAsOne = -(Math.pow(2, 32) - 1);
	  var toLengthsCorrectly = function (method, reversed) {
	    var obj = { length: int32sAsOne };
	    obj[reversed ? (obj.length >>> 0) - 1 : 0] = true;
	    return valueOrFalseIfThrows(function () {
	      _call(method, obj, function () {
	        // note: in nonconforming browsers, this will be called
	        // -1 >>> 0 times, which is 4294967295, so the throw matters.
	        throw new RangeError('should not reach here');
	      }, []);
	      return true;
	    });
	  };
	  if (!toLengthsCorrectly(Array.prototype.forEach)) {
	    var originalForEach = Array.prototype.forEach;
	    overrideNative(Array.prototype, 'forEach', function forEach(callbackFn) {
	      return ES.Call(originalForEach, this.length >= 0 ? this : [], arguments);
	    }, true);
	  }
	  if (!toLengthsCorrectly(Array.prototype.map)) {
	    var originalMap = Array.prototype.map;
	    overrideNative(Array.prototype, 'map', function map(callbackFn) {
	      return ES.Call(originalMap, this.length >= 0 ? this : [], arguments);
	    }, true);
	  }
	  if (!toLengthsCorrectly(Array.prototype.filter)) {
	    var originalFilter = Array.prototype.filter;
	    overrideNative(Array.prototype, 'filter', function filter(callbackFn) {
	      return ES.Call(originalFilter, this.length >= 0 ? this : [], arguments);
	    }, true);
	  }
	  if (!toLengthsCorrectly(Array.prototype.some)) {
	    var originalSome = Array.prototype.some;
	    overrideNative(Array.prototype, 'some', function some(callbackFn) {
	      return ES.Call(originalSome, this.length >= 0 ? this : [], arguments);
	    }, true);
	  }
	  if (!toLengthsCorrectly(Array.prototype.every)) {
	    var originalEvery = Array.prototype.every;
	    overrideNative(Array.prototype, 'every', function every(callbackFn) {
	      return ES.Call(originalEvery, this.length >= 0 ? this : [], arguments);
	    }, true);
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduce)) {
	    var originalReduce = Array.prototype.reduce;
	    overrideNative(Array.prototype, 'reduce', function reduce(callbackFn) {
	      return ES.Call(originalReduce, this.length >= 0 ? this : [], arguments);
	    }, true);
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduceRight, true)) {
	    var originalReduceRight = Array.prototype.reduceRight;
	    overrideNative(Array.prototype, 'reduceRight', function reduceRight(callbackFn) {
	      return ES.Call(originalReduceRight, this.length >= 0 ? this : [], arguments);
	    }, true);
	  }

	  var lacksOctalSupport = Number('0o10') !== 8;
	  var lacksBinarySupport = Number('0b10') !== 2;
	  var trimsNonWhitespace = _some(nonWS, function (c) {
	    return Number(c + 0 + c) === 0;
	  });
	  if (lacksOctalSupport || lacksBinarySupport || trimsNonWhitespace) {
	    var OrigNumber = Number;
	    var binaryRegex = /^0b[01]+$/i;
	    var octalRegex = /^0o[0-7]+$/i;
	    // Note that in IE 8, RegExp.prototype.test doesn't seem to exist: ie, "test" is an own property of regexes. wtf.
	    var isBinary = binaryRegex.test.bind(binaryRegex);
	    var isOctal = octalRegex.test.bind(octalRegex);
	    var toPrimitive = function (O) { // need to replace this with `es-to-primitive/es6`
	      var result;
	      if (typeof O.valueOf === 'function') {
	        result = O.valueOf();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      if (typeof O.toString === 'function') {
	        result = O.toString();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      throw new TypeError('No default value');
	    };
	    var hasNonWS = nonWSregex.test.bind(nonWSregex);
	    var isBadHex = isBadHexRegex.test.bind(isBadHexRegex);
	    var NumberShim = (function () {
	      // this is wrapped in an IIFE because of IE 6-8's wacky scoping issues with named function expressions.
	      var NumberShim = function Number(value) {
	        var primValue;
	        if (arguments.length > 0) {
	          primValue = Type.primitive(value) ? value : toPrimitive(value, 'number');
	        } else {
	          primValue = 0;
	        }
	        if (typeof primValue === 'string') {
	          primValue = ES.Call(trimShim, primValue);
	          if (isBinary(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 2);
	          } else if (isOctal(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 8);
	          } else if (hasNonWS(primValue) || isBadHex(primValue)) {
	            primValue = NaN;
	          }
	        }
	        var receiver = this;
	        var valueOfSucceeds = valueOrFalseIfThrows(function () {
	          OrigNumber.prototype.valueOf.call(receiver);
	          return true;
	        });
	        if (receiver instanceof NumberShim && !valueOfSucceeds) {
	          return new OrigNumber(primValue);
	        }
	        /* jshint newcap: false */
	        return OrigNumber(primValue);
	        /* jshint newcap: true */
	      };
	      return NumberShim;
	    }());
	    wrapConstructor(OrigNumber, NumberShim, {});
	    // this is necessary for ES3 browsers, where these properties are non-enumerable.
	    defineProperties(NumberShim, {
	      NaN: OrigNumber.NaN,
	      MAX_VALUE: OrigNumber.MAX_VALUE,
	      MIN_VALUE: OrigNumber.MIN_VALUE,
	      NEGATIVE_INFINITY: OrigNumber.NEGATIVE_INFINITY,
	      POSITIVE_INFINITY: OrigNumber.POSITIVE_INFINITY
	    });
	    /* globals Number: true */
	    /* eslint-disable no-undef */
	    /* jshint -W020 */
	    Number = NumberShim;
	    Value.redefine(globals, 'Number', NumberShim);
	    /* jshint +W020 */
	    /* eslint-enable no-undef */
	    /* globals Number: false */
	  }

	  var maxSafeInteger = Math.pow(2, 53) - 1;
	  defineProperties(Number, {
	    MAX_SAFE_INTEGER: maxSafeInteger,
	    MIN_SAFE_INTEGER: -maxSafeInteger,
	    EPSILON: 2.220446049250313e-16,

	    parseInt: globals.parseInt,
	    parseFloat: globals.parseFloat,

	    isFinite: numberIsFinite,

	    isInteger: function isInteger(value) {
	      return numberIsFinite(value) && ES.ToInteger(value) === value;
	    },

	    isSafeInteger: function isSafeInteger(value) {
	      return Number.isInteger(value) && _abs(value) <= Number.MAX_SAFE_INTEGER;
	    },

	    isNaN: numberIsNaN
	  });
	  // Firefox 37 has a conforming Number.parseInt, but it's not === to the global parseInt (fixed in v40)
	  defineProperty(Number, 'parseInt', globals.parseInt, Number.parseInt !== globals.parseInt);

	  // Work around bugs in Array#find and Array#findIndex -- early
	  // implementations skipped holes in sparse arrays. (Note that the
	  // implementations of find/findIndex indirectly use shimmed
	  // methods of Number, so this test has to happen down here.)
	  /*jshint elision: true */
	  /* eslint-disable no-sparse-arrays */
	  if (![, 1].find(function (item, idx) { return idx === 0; })) {
	    overrideNative(Array.prototype, 'find', ArrayPrototypeShims.find);
	  }
	  if ([, 1].findIndex(function (item, idx) { return idx === 0; }) !== 0) {
	    overrideNative(Array.prototype, 'findIndex', ArrayPrototypeShims.findIndex);
	  }
	  /* eslint-enable no-sparse-arrays */
	  /*jshint elision: false */

	  var isEnumerableOn = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable);
	  var ensureEnumerable = function ensureEnumerable(obj, prop) {
	    if (supportsDescriptors && isEnumerableOn(obj, prop)) {
	      Object.defineProperty(obj, prop, { enumerable: false });
	    }
	  };
	  var sliceArgs = function sliceArgs() {
	    // per https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	    // and https://gist.github.com/WebReflection/4327762cb87a8c634a29
	    var initial = Number(this);
	    var len = arguments.length;
	    var desiredArgCount = len - initial;
	    var args = new Array(desiredArgCount < 0 ? 0 : desiredArgCount);
	    for (var i = initial; i < len; ++i) {
	      args[i - initial] = arguments[i];
	    }
	    return args;
	  };
	  var assignTo = function assignTo(source) {
	    return function assignToSource(target, key) {
	      target[key] = source[key];
	      return target;
	    };
	  };
	  var assignReducer = function (target, source) {
	    var sourceKeys = keys(Object(source));
	    var symbols;
	    if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	      symbols = _filter(Object.getOwnPropertySymbols(Object(source)), isEnumerableOn(source));
	    }
	    return _reduce(_concat(sourceKeys, symbols || []), assignTo(source), target);
	  };

	  var ObjectShims = {
	    // 19.1.3.1
	    assign: function (target, source) {
	      var to = ES.ToObject(target, 'Cannot convert undefined or null to object');
	      return _reduce(ES.Call(sliceArgs, 1, arguments), assignReducer, to);
	    },

	    // Added in WebKit in https://bugs.webkit.org/show_bug.cgi?id=143865
	    is: function is(a, b) {
	      return ES.SameValue(a, b);
	    }
	  };
	  var assignHasPendingExceptions = Object.assign && Object.preventExtensions && (function () {
	    // Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	    // which is 72% slower than our shim, and Firefox 40's native implementation.
	    var thrower = Object.preventExtensions({ 1: 2 });
	    try {
	      Object.assign(thrower, 'xy');
	    } catch (e) {
	      return thrower[1] === 'y';
	    }
	  }());
	  if (assignHasPendingExceptions) {
	    overrideNative(Object, 'assign', ObjectShims.assign);
	  }
	  defineProperties(Object, ObjectShims);

	  if (supportsDescriptors) {
	    var ES5ObjectShims = {
	      // 19.1.3.9
	      // shim from https://gist.github.com/WebReflection/5593554
	      setPrototypeOf: (function (Object, magic) {
	        var set;

	        var checkArgs = function (O, proto) {
	          if (!ES.TypeIsObject(O)) {
	            throw new TypeError('cannot set prototype on a non-object');
	          }
	          if (!(proto === null || ES.TypeIsObject(proto))) {
	            throw new TypeError('can only set prototype to an object or null' + proto);
	          }
	        };

	        var setPrototypeOf = function (O, proto) {
	          checkArgs(O, proto);
	          _call(set, O, proto);
	          return O;
	        };

	        try {
	          // this works already in Firefox and Safari
	          set = Object.getOwnPropertyDescriptor(Object.prototype, magic).set;
	          _call(set, {}, null);
	        } catch (e) {
	          if (Object.prototype !== {}[magic]) {
	            // IE < 11 cannot be shimmed
	            return;
	          }
	          // probably Chrome or some old Mobile stock browser
	          set = function (proto) {
	            this[magic] = proto;
	          };
	          // please note that this will **not** work
	          // in those browsers that do not inherit
	          // __proto__ by mistake from Object.prototype
	          // in these cases we should probably throw an error
	          // or at least be informed about the issue
	          setPrototypeOf.polyfill = setPrototypeOf(
	            setPrototypeOf({}, null),
	            Object.prototype
	          ) instanceof Object;
	          // setPrototypeOf.polyfill === true means it works as meant
	          // setPrototypeOf.polyfill === false means it's not 100% reliable
	          // setPrototypeOf.polyfill === undefined
	          // or
	          // setPrototypeOf.polyfill ==  null means it's not a polyfill
	          // which means it works as expected
	          // we can even delete Object.prototype.__proto__;
	        }
	        return setPrototypeOf;
	      }(Object, '__proto__'))
	    };

	    defineProperties(Object, ES5ObjectShims);
	  }

	  // Workaround bug in Opera 12 where setPrototypeOf(x, null) doesn't work,
	  // but Object.create(null) does.
	  if (Object.setPrototypeOf && Object.getPrototypeOf &&
	      Object.getPrototypeOf(Object.setPrototypeOf({}, null)) !== null &&
	      Object.getPrototypeOf(Object.create(null)) === null) {
	    (function () {
	      var FAKENULL = Object.create(null);
	      var gpo = Object.getPrototypeOf;
	      var spo = Object.setPrototypeOf;
	      Object.getPrototypeOf = function (o) {
	        var result = gpo(o);
	        return result === FAKENULL ? null : result;
	      };
	      Object.setPrototypeOf = function (o, p) {
	        var proto = p === null ? FAKENULL : p;
	        return spo(o, proto);
	      };
	      Object.setPrototypeOf.polyfill = false;
	    }());
	  }

	  var objectKeysAcceptsPrimitives = !throwsError(function () { Object.keys('foo'); });
	  if (!objectKeysAcceptsPrimitives) {
	    var originalObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      return originalObjectKeys(ES.ToObject(value));
	    });
	    keys = Object.keys;
	  }
	  var objectKeysRejectsRegex = throwsError(function () { Object.keys(/a/g); });
	  if (objectKeysRejectsRegex) {
	    var regexRejectingObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      if (Type.regex(value)) {
	        var regexKeys = [];
	        for (var k in value) {
	          if (_hasOwnProperty(value, k)) {
	            _push(regexKeys, k);
	          }
	        }
	        return regexKeys;
	      }
	      return regexRejectingObjectKeys(value);
	    });
	    keys = Object.keys;
	  }

	  if (Object.getOwnPropertyNames) {
	    var objectGOPNAcceptsPrimitives = !throwsError(function () { Object.getOwnPropertyNames('foo'); });
	    if (!objectGOPNAcceptsPrimitives) {
	      var cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [];
	      var originalObjectGetOwnPropertyNames = Object.getOwnPropertyNames;
	      overrideNative(Object, 'getOwnPropertyNames', function getOwnPropertyNames(value) {
	        var val = ES.ToObject(value);
	        if (_toString(val) === '[object Window]') {
	          try {
	            return originalObjectGetOwnPropertyNames(val);
	          } catch (e) {
	            // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
	            return _concat([], cachedWindowNames);
	          }
	        }
	        return originalObjectGetOwnPropertyNames(val);
	      });
	    }
	  }
	  if (Object.getOwnPropertyDescriptor) {
	    var objectGOPDAcceptsPrimitives = !throwsError(function () { Object.getOwnPropertyDescriptor('foo', 'bar'); });
	    if (!objectGOPDAcceptsPrimitives) {
	      var originalObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	      overrideNative(Object, 'getOwnPropertyDescriptor', function getOwnPropertyDescriptor(value, property) {
	        return originalObjectGetOwnPropertyDescriptor(ES.ToObject(value), property);
	      });
	    }
	  }
	  if (Object.seal) {
	    var objectSealAcceptsPrimitives = !throwsError(function () { Object.seal('foo'); });
	    if (!objectSealAcceptsPrimitives) {
	      var originalObjectSeal = Object.seal;
	      overrideNative(Object, 'seal', function seal(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectSeal(value);
	      });
	    }
	  }
	  if (Object.isSealed) {
	    var objectIsSealedAcceptsPrimitives = !throwsError(function () { Object.isSealed('foo'); });
	    if (!objectIsSealedAcceptsPrimitives) {
	      var originalObjectIsSealed = Object.isSealed;
	      overrideNative(Object, 'isSealed', function isSealed(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsSealed(value);
	      });
	    }
	  }
	  if (Object.freeze) {
	    var objectFreezeAcceptsPrimitives = !throwsError(function () { Object.freeze('foo'); });
	    if (!objectFreezeAcceptsPrimitives) {
	      var originalObjectFreeze = Object.freeze;
	      overrideNative(Object, 'freeze', function freeze(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectFreeze(value);
	      });
	    }
	  }
	  if (Object.isFrozen) {
	    var objectIsFrozenAcceptsPrimitives = !throwsError(function () { Object.isFrozen('foo'); });
	    if (!objectIsFrozenAcceptsPrimitives) {
	      var originalObjectIsFrozen = Object.isFrozen;
	      overrideNative(Object, 'isFrozen', function isFrozen(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsFrozen(value);
	      });
	    }
	  }
	  if (Object.preventExtensions) {
	    var objectPreventExtensionsAcceptsPrimitives = !throwsError(function () { Object.preventExtensions('foo'); });
	    if (!objectPreventExtensionsAcceptsPrimitives) {
	      var originalObjectPreventExtensions = Object.preventExtensions;
	      overrideNative(Object, 'preventExtensions', function preventExtensions(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectPreventExtensions(value);
	      });
	    }
	  }
	  if (Object.isExtensible) {
	    var objectIsExtensibleAcceptsPrimitives = !throwsError(function () { Object.isExtensible('foo'); });
	    if (!objectIsExtensibleAcceptsPrimitives) {
	      var originalObjectIsExtensible = Object.isExtensible;
	      overrideNative(Object, 'isExtensible', function isExtensible(value) {
	        if (!ES.TypeIsObject(value)) { return false; }
	        return originalObjectIsExtensible(value);
	      });
	    }
	  }
	  if (Object.getPrototypeOf) {
	    var objectGetProtoAcceptsPrimitives = !throwsError(function () { Object.getPrototypeOf('foo'); });
	    if (!objectGetProtoAcceptsPrimitives) {
	      var originalGetProto = Object.getPrototypeOf;
	      overrideNative(Object, 'getPrototypeOf', function getPrototypeOf(value) {
	        return originalGetProto(ES.ToObject(value));
	      });
	    }
	  }

	  var hasFlags = supportsDescriptors && (function () {
	    var desc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags');
	    return desc && ES.IsCallable(desc.get);
	  }());
	  if (supportsDescriptors && !hasFlags) {
	    var regExpFlagsGetter = function flags() {
	      if (!ES.TypeIsObject(this)) {
	        throw new TypeError('Method called on incompatible type: must be an object.');
	      }
	      var result = '';
	      if (this.global) {
	        result += 'g';
	      }
	      if (this.ignoreCase) {
	        result += 'i';
	      }
	      if (this.multiline) {
	        result += 'm';
	      }
	      if (this.unicode) {
	        result += 'u';
	      }
	      if (this.sticky) {
	        result += 'y';
	      }
	      return result;
	    };

	    Value.getter(RegExp.prototype, 'flags', regExpFlagsGetter);
	  }

	  var regExpSupportsFlagsWithRegex = supportsDescriptors && valueOrFalseIfThrows(function () {
	    return String(new RegExp(/a/g, 'i')) === '/a/i';
	  });
	  var regExpNeedsToSupportSymbolMatch = hasSymbols && supportsDescriptors && (function () {
	    // Edge 0.12 supports flags fully, but does not support Symbol.match
	    var regex = /./;
	    regex[Symbol.match] = false;
	    return RegExp(regex) === regex;
	  }());

	  var regexToStringIsGeneric = valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'abc' }) === '/abc/';
	  });
	  var regexToStringSupportsGenericFlags = regexToStringIsGeneric && valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'a', flags: 'b' }) === '/a/b';
	  });
	  if (!regexToStringIsGeneric || !regexToStringSupportsGenericFlags) {
	    var origRegExpToString = RegExp.prototype.toString;
	    defineProperty(RegExp.prototype, 'toString', function toString() {
	      var R = ES.RequireObjectCoercible(this);
	      if (Type.regex(R)) {
	        return _call(origRegExpToString, R);
	      }
	      var pattern = $String(R.source);
	      var flags = $String(R.flags);
	      return '/' + pattern + '/' + flags;
	    }, true);
	    Value.preserveToString(RegExp.prototype.toString, origRegExpToString);
	  }

	  if (supportsDescriptors && (!regExpSupportsFlagsWithRegex || regExpNeedsToSupportSymbolMatch)) {
	    var flagsGetter = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get;
	    var sourceDesc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'source') || {};
	    var legacySourceGetter = function () { return this.source; }; // prior to it being a getter, it's own + nonconfigurable
	    var sourceGetter = ES.IsCallable(sourceDesc.get) ? sourceDesc.get : legacySourceGetter;

	    var OrigRegExp = RegExp;
	    var RegExpShim = (function () {
	      return function RegExp(pattern, flags) {
	        var patternIsRegExp = ES.IsRegExp(pattern);
	        var calledWithNew = this instanceof RegExp;
	        if (!calledWithNew && patternIsRegExp && typeof flags === 'undefined' && pattern.constructor === RegExp) {
	          return pattern;
	        }

	        var P = pattern;
	        var F = flags;
	        if (Type.regex(pattern)) {
	          P = ES.Call(sourceGetter, pattern);
	          F = typeof flags === 'undefined' ? ES.Call(flagsGetter, pattern) : flags;
	          return new RegExp(P, F);
	        } else if (patternIsRegExp) {
	          P = pattern.source;
	          F = typeof flags === 'undefined' ? pattern.flags : flags;
	        }
	        return new OrigRegExp(pattern, flags);
	      };
	    }());
	    wrapConstructor(OrigRegExp, RegExpShim, {
	      $input: true // Chrome < v39 & Opera < 26 have a nonstandard "$input" property
	    });
	    /* globals RegExp: true */
	    /* eslint-disable no-undef */
	    /* jshint -W020 */
	    RegExp = RegExpShim;
	    Value.redefine(globals, 'RegExp', RegExpShim);
	    /* jshint +W020 */
	    /* eslint-enable no-undef */
	    /* globals RegExp: false */
	  }

	  if (supportsDescriptors) {
	    var regexGlobals = {
	      input: '$_',
	      lastMatch: '$&',
	      lastParen: '$+',
	      leftContext: '$`',
	      rightContext: '$\''
	    };
	    _forEach(keys(regexGlobals), function (prop) {
	      if (prop in RegExp && !(regexGlobals[prop] in RegExp)) {
	        Value.getter(RegExp, regexGlobals[prop], function get() {
	          return RegExp[prop];
	        });
	      }
	    });
	  }
	  addDefaultSpecies(RegExp);

	  var inverseEpsilon = 1 / Number.EPSILON;
	  var roundTiesToEven = function roundTiesToEven(n) {
	    // Even though this reduces down to `return n`, it takes advantage of built-in rounding.
	    return (n + inverseEpsilon) - inverseEpsilon;
	  };
	  var BINARY_32_EPSILON = Math.pow(2, -23);
	  var BINARY_32_MAX_VALUE = Math.pow(2, 127) * (2 - BINARY_32_EPSILON);
	  var BINARY_32_MIN_VALUE = Math.pow(2, -126);
	  var E = Math.E;
	  var LOG2E = Math.LOG2E;
	  var LOG10E = Math.LOG10E;
	  var numberCLZ = Number.prototype.clz;
	  delete Number.prototype.clz; // Safari 8 has Number#clz

	  var MathShims = {
	    acosh: function acosh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || value < 1) { return NaN; }
	      if (x === 1) { return 0; }
	      if (x === Infinity) { return x; }
	      return _log(x / E + _sqrt(x + 1) * _sqrt(x - 1) / E) + 1;
	    },

	    asinh: function asinh(value) {
	      var x = Number(value);
	      if (x === 0 || !globalIsFinite(x)) {
	        return x;
	      }
	      return x < 0 ? -asinh(-x) : _log(x + _sqrt(x * x + 1));
	    },

	    atanh: function atanh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || x < -1 || x > 1) {
	        return NaN;
	      }
	      if (x === -1) { return -Infinity; }
	      if (x === 1) { return Infinity; }
	      if (x === 0) { return x; }
	      return 0.5 * _log((1 + x) / (1 - x));
	    },

	    cbrt: function cbrt(value) {
	      var x = Number(value);
	      if (x === 0) { return x; }
	      var negate = x < 0;
	      var result;
	      if (negate) { x = -x; }
	      if (x === Infinity) {
	        result = Infinity;
	      } else {
	        result = _exp(_log(x) / 3);
	        // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
	        result = (x / (result * result) + (2 * result)) / 3;
	      }
	      return negate ? -result : result;
	    },

	    clz32: function clz32(value) {
	      // See https://bugs.ecmascript.org/show_bug.cgi?id=2465
	      var x = Number(value);
	      var number = ES.ToUint32(x);
	      if (number === 0) {
	        return 32;
	      }
	      return numberCLZ ? ES.Call(numberCLZ, number) : 31 - _floor(_log(number + 0.5) * LOG2E);
	    },

	    cosh: function cosh(value) {
	      var x = Number(value);
	      if (x === 0) { return 1; } // +0 or -0
	      if (numberIsNaN(x)) { return NaN; }
	      if (!globalIsFinite(x)) { return Infinity; }
	      if (x < 0) { x = -x; }
	      if (x > 21) { return _exp(x) / 2; }
	      return (_exp(x) + _exp(-x)) / 2;
	    },

	    expm1: function expm1(value) {
	      var x = Number(value);
	      if (x === -Infinity) { return -1; }
	      if (!globalIsFinite(x) || x === 0) { return x; }
	      if (_abs(x) > 0.5) {
	        return _exp(x) - 1;
	      }
	      // A more precise approximation using Taylor series expansion
	      // from https://github.com/paulmillr/es6-shim/issues/314#issuecomment-70293986
	      var t = x;
	      var sum = 0;
	      var n = 1;
	      while (sum + t !== sum) {
	        sum += t;
	        n += 1;
	        t *= x / n;
	      }
	      return sum;
	    },

	    hypot: function hypot(x, y) {
	      var result = 0;
	      var largest = 0;
	      for (var i = 0; i < arguments.length; ++i) {
	        var value = _abs(Number(arguments[i]));
	        if (largest < value) {
	          result *= (largest / value) * (largest / value);
	          result += 1;
	          largest = value;
	        } else {
	          result += value > 0 ? (value / largest) * (value / largest) : value;
	        }
	      }
	      return largest === Infinity ? Infinity : largest * _sqrt(result);
	    },

	    log2: function log2(value) {
	      return _log(value) * LOG2E;
	    },

	    log10: function log10(value) {
	      return _log(value) * LOG10E;
	    },

	    log1p: function log1p(value) {
	      var x = Number(value);
	      if (x < -1 || numberIsNaN(x)) { return NaN; }
	      if (x === 0 || x === Infinity) { return x; }
	      if (x === -1) { return -Infinity; }

	      return (1 + x) - 1 === 0 ? x : x * (_log(1 + x) / ((1 + x) - 1));
	    },

	    sign: _sign,

	    sinh: function sinh(value) {
	      var x = Number(value);
	      if (!globalIsFinite(x) || x === 0) { return x; }

	      if (_abs(x) < 1) {
	        return (Math.expm1(x) - Math.expm1(-x)) / 2;
	      }
	      return (_exp(x - 1) - _exp(-x - 1)) * E / 2;
	    },

	    tanh: function tanh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || x === 0) { return x; }
	      // can exit early at +-20 as JS loses precision for true value at this integer
	      if (x >= 20) { return 1; }
	      if (x <= -20) { return -1; }

	      return (Math.expm1(x) - Math.expm1(-x)) / (_exp(x) + _exp(-x));
	    },

	    trunc: function trunc(value) {
	      var x = Number(value);
	      return x < 0 ? -_floor(-x) : _floor(x);
	    },

	    imul: function imul(x, y) {
	      // taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
	      var a = ES.ToUint32(x);
	      var b = ES.ToUint32(y);
	      var ah = (a >>> 16) & 0xffff;
	      var al = a & 0xffff;
	      var bh = (b >>> 16) & 0xffff;
	      var bl = b & 0xffff;
	      // the shift by 0 fixes the sign on the high part
	      // the final |0 converts the unsigned value into a signed value
	      return (al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0;
	    },

	    fround: function fround(x) {
	      var v = Number(x);
	      if (v === 0 || v === Infinity || v === -Infinity || numberIsNaN(v)) {
	        return v;
	      }
	      var sign = _sign(v);
	      var abs = _abs(v);
	      if (abs < BINARY_32_MIN_VALUE) {
	        return sign * roundTiesToEven(abs / BINARY_32_MIN_VALUE / BINARY_32_EPSILON) * BINARY_32_MIN_VALUE * BINARY_32_EPSILON;
	      }
	      // Veltkamp's splitting (?)
	      var a = (1 + BINARY_32_EPSILON / Number.EPSILON) * abs;
	      var result = a - (a - abs);
	      if (result > BINARY_32_MAX_VALUE || numberIsNaN(result)) {
	        return sign * Infinity;
	      }
	      return sign * result;
	    }
	  };
	  defineProperties(Math, MathShims);
	  // IE 11 TP has an imprecise log1p: reports Math.log1p(-1e-17) as 0
	  defineProperty(Math, 'log1p', MathShims.log1p, Math.log1p(-1e-17) !== -1e-17);
	  // IE 11 TP has an imprecise asinh: reports Math.asinh(-1e7) as not exactly equal to -Math.asinh(1e7)
	  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7));
	  // Chrome 40 has an imprecise Math.tanh with very small numbers
	  defineProperty(Math, 'tanh', MathShims.tanh, Math.tanh(-2e-17) !== -2e-17);
	  // Chrome 40 loses Math.acosh precision with high numbers
	  defineProperty(Math, 'acosh', MathShims.acosh, Math.acosh(Number.MAX_VALUE) === Infinity);
	  // Firefox 38 on Windows
	  defineProperty(Math, 'cbrt', MathShims.cbrt, Math.abs(1 - Math.cbrt(1e-300) / 1e-100) / Number.EPSILON > 8);
	  // node 0.11 has an imprecise Math.sinh with very small numbers
	  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(-2e-17) !== -2e-17);
	  // FF 35 on Linux reports 22025.465794806725 for Math.expm1(10)
	  var expm1OfTen = Math.expm1(10);
	  defineProperty(Math, 'expm1', MathShims.expm1, expm1OfTen > 22025.465794806719 || expm1OfTen < 22025.4657948067165168);

	  var origMathRound = Math.round;
	  // breaks in e.g. Safari 8, Internet Explorer 11, Opera 12
	  var roundHandlesBoundaryConditions = Math.round(0.5 - Number.EPSILON / 4) === 0 && Math.round(-0.5 + Number.EPSILON / 3.99) === 1;

	  // When engines use Math.floor(x + 0.5) internally, Math.round can be buggy for large integers.
	  // This behavior should be governed by "round to nearest, ties to even mode"
	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-terms-and-definitions-number-type
	  // These are the boundary cases where it breaks.
	  var smallestPositiveNumberWhereRoundBreaks = inverseEpsilon + 1;
	  var largestPositiveNumberWhereRoundBreaks = 2 * inverseEpsilon - 1;
	  var roundDoesNotIncreaseIntegers = [smallestPositiveNumberWhereRoundBreaks, largestPositiveNumberWhereRoundBreaks].every(function (num) {
	    return Math.round(num) === num;
	  });
	  defineProperty(Math, 'round', function round(x) {
	    var floor = _floor(x);
	    var ceil = floor === -1 ? -0 : floor + 1;
	    return x - floor < 0.5 ? floor : ceil;
	  }, !roundHandlesBoundaryConditions || !roundDoesNotIncreaseIntegers);
	  Value.preserveToString(Math.round, origMathRound);

	  var origImul = Math.imul;
	  if (Math.imul(0xffffffff, 5) !== -5) {
	    // Safari 6.1, at least, reports "0" for this value
	    Math.imul = MathShims.imul;
	    Value.preserveToString(Math.imul, origImul);
	  }
	  if (Math.imul.length !== 2) {
	    // Safari 8.0.4 has a length of 1
	    // fixed in https://bugs.webkit.org/show_bug.cgi?id=143658
	    overrideNative(Math, 'imul', function imul(x, y) {
	      return ES.Call(origImul, Math, arguments);
	    });
	  }

	  // Promises
	  // Simplest possible implementation; use a 3rd-party library if you
	  // want the best possible speed and/or long stack traces.
	  var PromiseShim = (function () {
	    var setTimeout = globals.setTimeout;
	    // some environments don't have setTimeout - no way to shim here.
	    if (typeof setTimeout !== 'function' && typeof setTimeout !== 'object') { return; }

	    ES.IsPromise = function (promise) {
	      if (!ES.TypeIsObject(promise)) {
	        return false;
	      }
	      if (typeof promise._promise === 'undefined') {
	        return false; // uninitialized, or missing our hidden field.
	      }
	      return true;
	    };

	    // "PromiseCapability" in the spec is what most promise implementations
	    // call a "deferred".
	    var PromiseCapability = function (C) {
	      if (!ES.IsConstructor(C)) {
	        throw new TypeError('Bad promise constructor');
	      }
	      var capability = this;
	      var resolver = function (resolve, reject) {
	        if (capability.resolve !== void 0 || capability.reject !== void 0) {
	          throw new TypeError('Bad Promise implementation!');
	        }
	        capability.resolve = resolve;
	        capability.reject = reject;
	      };
	      // Initialize fields to inform optimizers about the object shape.
	      capability.resolve = void 0;
	      capability.reject = void 0;
	      capability.promise = new C(resolver);
	      if (!(ES.IsCallable(capability.resolve) && ES.IsCallable(capability.reject))) {
	        throw new TypeError('Bad promise constructor');
	      }
	    };

	    // find an appropriate setImmediate-alike
	    var makeZeroTimeout;
	    /*global window */
	    if (typeof window !== 'undefined' && ES.IsCallable(window.postMessage)) {
	      makeZeroTimeout = function () {
	        // from http://dbaron.org/log/20100309-faster-timeouts
	        var timeouts = [];
	        var messageName = 'zero-timeout-message';
	        var setZeroTimeout = function (fn) {
	          _push(timeouts, fn);
	          window.postMessage(messageName, '*');
	        };
	        var handleMessage = function (event) {
	          if (event.source === window && event.data === messageName) {
	            event.stopPropagation();
	            if (timeouts.length === 0) { return; }
	            var fn = _shift(timeouts);
	            fn();
	          }
	        };
	        window.addEventListener('message', handleMessage, true);
	        return setZeroTimeout;
	      };
	    }
	    var makePromiseAsap = function () {
	      // An efficient task-scheduler based on a pre-existing Promise
	      // implementation, which we can use even if we override the
	      // global Promise below (in order to workaround bugs)
	      // https://github.com/Raynos/observ-hash/issues/2#issuecomment-35857671
	      var P = globals.Promise;
	      var pr = P && P.resolve && P.resolve();
	      return pr && function (task) {
	        return pr.then(task);
	      };
	    };
	    /*global process */
	    /* jscs:disable disallowMultiLineTernary */
	    var enqueue = ES.IsCallable(globals.setImmediate) ?
	      globals.setImmediate :
	      typeof process === 'object' && process.nextTick ? process.nextTick :
	      makePromiseAsap() ||
	      (ES.IsCallable(makeZeroTimeout) ? makeZeroTimeout() :
	      function (task) { setTimeout(task, 0); }); // fallback
	    /* jscs:enable disallowMultiLineTernary */

	    // Constants for Promise implementation
	    var PROMISE_IDENTITY = function (x) { return x; };
	    var PROMISE_THROWER = function (e) { throw e; };
	    var PROMISE_PENDING = 0;
	    var PROMISE_FULFILLED = 1;
	    var PROMISE_REJECTED = 2;
	    // We store fulfill/reject handlers and capabilities in a single array.
	    var PROMISE_FULFILL_OFFSET = 0;
	    var PROMISE_REJECT_OFFSET = 1;
	    var PROMISE_CAPABILITY_OFFSET = 2;
	    // This is used in an optimization for chaining promises via then.
	    var PROMISE_FAKE_CAPABILITY = {};

	    var enqueuePromiseReactionJob = function (handler, capability, argument) {
	      enqueue(function () {
	        promiseReactionJob(handler, capability, argument);
	      });
	    };

	    var promiseReactionJob = function (handler, promiseCapability, argument) {
	      var handlerResult, f;
	      if (promiseCapability === PROMISE_FAKE_CAPABILITY) {
	        // Fast case, when we don't actually need to chain through to a
	        // (real) promiseCapability.
	        return handler(argument);
	      }
	      try {
	        handlerResult = handler(argument);
	        f = promiseCapability.resolve;
	      } catch (e) {
	        handlerResult = e;
	        f = promiseCapability.reject;
	      }
	      f(handlerResult);
	    };

	    var fulfillPromise = function (promise, value) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.fulfillReactionHandler0,
	          _promise.reactionCapability0,
	          value
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_FULFILL_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              value
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = value;
	      _promise.state = PROMISE_FULFILLED;
	      _promise.reactionLength = 0;
	    };

	    var rejectPromise = function (promise, reason) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.rejectReactionHandler0,
	          _promise.reactionCapability0,
	          reason
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_REJECT_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              reason
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = reason;
	      _promise.state = PROMISE_REJECTED;
	      _promise.reactionLength = 0;
	    };

	    var createResolvingFunctions = function (promise) {
	      var alreadyResolved = false;
	      var resolve = function (resolution) {
	        var then;
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        if (resolution === promise) {
	          return rejectPromise(promise, new TypeError('Self resolution'));
	        }
	        if (!ES.TypeIsObject(resolution)) {
	          return fulfillPromise(promise, resolution);
	        }
	        try {
	          then = resolution.then;
	        } catch (e) {
	          return rejectPromise(promise, e);
	        }
	        if (!ES.IsCallable(then)) {
	          return fulfillPromise(promise, resolution);
	        }
	        enqueue(function () {
	          promiseResolveThenableJob(promise, resolution, then);
	        });
	      };
	      var reject = function (reason) {
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        return rejectPromise(promise, reason);
	      };
	      return { resolve: resolve, reject: reject };
	    };

	    var optimizedThen = function (then, thenable, resolve, reject) {
	      // Optimization: since we discard the result, we can pass our
	      // own then implementation a special hint to let it know it
	      // doesn't have to create it.  (The PROMISE_FAKE_CAPABILITY
	      // object is local to this implementation and unforgeable outside.)
	      if (then === Promise$prototype$then) {
	        _call(then, thenable, resolve, reject, PROMISE_FAKE_CAPABILITY);
	      } else {
	        _call(then, thenable, resolve, reject);
	      }
	    };
	    var promiseResolveThenableJob = function (promise, thenable, then) {
	      var resolvingFunctions = createResolvingFunctions(promise);
	      var resolve = resolvingFunctions.resolve;
	      var reject = resolvingFunctions.reject;
	      try {
	        optimizedThen(then, thenable, resolve, reject);
	      } catch (e) {
	        reject(e);
	      }
	    };

	    var Promise$prototype, Promise$prototype$then;
	    var Promise = (function () {
	      var PromiseShim = function Promise(resolver) {
	        if (!(this instanceof PromiseShim)) {
	          throw new TypeError('Constructor Promise requires "new"');
	        }
	        if (this && this._promise) {
	          throw new TypeError('Bad construction');
	        }
	        // see https://bugs.ecmascript.org/show_bug.cgi?id=2482
	        if (!ES.IsCallable(resolver)) {
	          throw new TypeError('not a valid resolver');
	        }
	        var promise = emulateES6construct(this, PromiseShim, Promise$prototype, {
	          _promise: {
	            result: void 0,
	            state: PROMISE_PENDING,
	            // The first member of the "reactions" array is inlined here,
	            // since most promises only have one reaction.
	            // We've also exploded the 'reaction' object to inline the
	            // "handler" and "capability" fields, since both fulfill and
	            // reject reactions share the same capability.
	            reactionLength: 0,
	            fulfillReactionHandler0: void 0,
	            rejectReactionHandler0: void 0,
	            reactionCapability0: void 0
	          }
	        });
	        var resolvingFunctions = createResolvingFunctions(promise);
	        var reject = resolvingFunctions.reject;
	        try {
	          resolver(resolvingFunctions.resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        return promise;
	      };
	      return PromiseShim;
	    }());
	    Promise$prototype = Promise.prototype;

	    var _promiseAllResolver = function (index, values, capability, remaining) {
	      var alreadyCalled = false;
	      return function (x) {
	        if (alreadyCalled) { return; }
	        alreadyCalled = true;
	        values[index] = x;
	        if ((--remaining.count) === 0) {
	          var resolve = capability.resolve;
	          resolve(values); // call w/ this===undefined
	        }
	      };
	    };

	    var performPromiseAll = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var values = [];
	      var remaining = { count: 1 };
	      var next, nextValue;
	      var index = 0;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        values[index] = void 0;
	        var nextPromise = C.resolve(nextValue);
	        var resolveElement = _promiseAllResolver(
	          index, values, resultCapability, remaining
	        );
	        remaining.count += 1;
	        optimizedThen(nextPromise.then, nextPromise, resolveElement, resultCapability.reject);
	        index += 1;
	      }
	      if ((--remaining.count) === 0) {
	        var resolve = resultCapability.resolve;
	        resolve(values); // call w/ this===undefined
	      }
	      return resultCapability.promise;
	    };

	    var performPromiseRace = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var next, nextValue, nextPromise;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            // NOTE: If iterable has no items, resulting promise will never
	            // resolve; see:
	            // https://github.com/domenic/promises-unwrapping/issues/75
	            // https://bugs.ecmascript.org/show_bug.cgi?id=2515
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        nextPromise = C.resolve(nextValue);
	        optimizedThen(nextPromise.then, nextPromise, resultCapability.resolve, resultCapability.reject);
	      }
	      return resultCapability.promise;
	    };

	    defineProperties(Promise, {
	      all: function all(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseAll(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },

	      race: function race(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseRace(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },

	      reject: function reject(reason) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        var capability = new PromiseCapability(C);
	        var rejectFunc = capability.reject;
	        rejectFunc(reason); // call with this===undefined
	        return capability.promise;
	      },

	      resolve: function resolve(v) {
	        // See https://esdiscuss.org/topic/fixing-promise-resolve for spec
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        if (ES.IsPromise(v)) {
	          var constructor = v.constructor;
	          if (constructor === C) {
	            return v;
	          }
	        }
	        var capability = new PromiseCapability(C);
	        var resolveFunc = capability.resolve;
	        resolveFunc(v); // call with this===undefined
	        return capability.promise;
	      }
	    });

	    defineProperties(Promise$prototype, {
	      'catch': function (onRejected) {
	        return this.then(null, onRejected);
	      },

	      then: function then(onFulfilled, onRejected) {
	        var promise = this;
	        if (!ES.IsPromise(promise)) { throw new TypeError('not a promise'); }
	        var C = ES.SpeciesConstructor(promise, Promise);
	        var resultCapability;
	        var returnValueIsIgnored = arguments.length > 2 && arguments[2] === PROMISE_FAKE_CAPABILITY;
	        if (returnValueIsIgnored && C === Promise) {
	          resultCapability = PROMISE_FAKE_CAPABILITY;
	        } else {
	          resultCapability = new PromiseCapability(C);
	        }
	        // PerformPromiseThen(promise, onFulfilled, onRejected, resultCapability)
	        // Note that we've split the 'reaction' object into its two
	        // components, "capabilities" and "handler"
	        // "capabilities" is always equal to `resultCapability`
	        var fulfillReactionHandler = ES.IsCallable(onFulfilled) ? onFulfilled : PROMISE_IDENTITY;
	        var rejectReactionHandler = ES.IsCallable(onRejected) ? onRejected : PROMISE_THROWER;
	        var _promise = promise._promise;
	        var value;
	        if (_promise.state === PROMISE_PENDING) {
	          if (_promise.reactionLength === 0) {
	            _promise.fulfillReactionHandler0 = fulfillReactionHandler;
	            _promise.rejectReactionHandler0 = rejectReactionHandler;
	            _promise.reactionCapability0 = resultCapability;
	          } else {
	            var idx = 3 * (_promise.reactionLength - 1);
	            _promise[idx + PROMISE_FULFILL_OFFSET] = fulfillReactionHandler;
	            _promise[idx + PROMISE_REJECT_OFFSET] = rejectReactionHandler;
	            _promise[idx + PROMISE_CAPABILITY_OFFSET] = resultCapability;
	          }
	          _promise.reactionLength += 1;
	        } else if (_promise.state === PROMISE_FULFILLED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            fulfillReactionHandler, resultCapability, value
	          );
	        } else if (_promise.state === PROMISE_REJECTED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            rejectReactionHandler, resultCapability, value
	          );
	        } else {
	          throw new TypeError('unexpected Promise state');
	        }
	        return resultCapability.promise;
	      }
	    });
	    // This helps the optimizer by ensuring that methods which take
	    // capabilities aren't polymorphic.
	    PROMISE_FAKE_CAPABILITY = new PromiseCapability(Promise);
	    Promise$prototype$then = Promise$prototype.then;

	    return Promise;
	  }());

	  // Chrome's native Promise has extra methods that it shouldn't have. Let's remove them.
	  if (globals.Promise) {
	    delete globals.Promise.accept;
	    delete globals.Promise.defer;
	    delete globals.Promise.prototype.chain;
	  }

	  if (typeof PromiseShim === 'function') {
	    // export the Promise constructor.
	    defineProperties(globals, { Promise: PromiseShim });
	    // In Chrome 33 (and thereabouts) Promise is defined, but the
	    // implementation is buggy in a number of ways.  Let's check subclassing
	    // support to see if we have a buggy implementation.
	    var promiseSupportsSubclassing = supportsSubclassing(globals.Promise, function (S) {
	      return S.resolve(42).then(function () {}) instanceof S;
	    });
	    var promiseIgnoresNonFunctionThenCallbacks = !throwsError(function () { globals.Promise.reject(42).then(null, 5).then(null, noop); });
	    var promiseRequiresObjectContext = throwsError(function () { globals.Promise.call(3, noop); });
	    // Promise.resolve() was errata'ed late in the ES6 process.
	    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1170742
	    //      https://code.google.com/p/v8/issues/detail?id=4161
	    // It serves as a proxy for a number of other bugs in early Promise
	    // implementations.
	    var promiseResolveBroken = (function (Promise) {
	      var p = Promise.resolve(5);
	      p.constructor = {};
	      var p2 = Promise.resolve(p);
	      try {
	        p2.then(null, noop).then(null, noop); // avoid "uncaught rejection" warnings in console
	      } catch (e) {
	        return true; // v8 native Promises break here https://code.google.com/p/chromium/issues/detail?id=575314
	      }
	      return p === p2; // This *should* be false!
	    }(globals.Promise));

	    // Chrome 46 (probably older too) does not retrieve a thenable's .then synchronously
	    var getsThenSynchronously = supportsDescriptors && (function () {
	      var count = 0;
	      var thenable = Object.defineProperty({}, 'then', { get: function () { count += 1; } });
	      Promise.resolve(thenable);
	      return count === 1;
	    }());

	    var BadResolverPromise = function BadResolverPromise(executor) {
	      var p = new Promise(executor);
	      executor(3, function () {});
	      this.then = p.then;
	      this.constructor = BadResolverPromise;
	    };
	    BadResolverPromise.prototype = Promise.prototype;
	    BadResolverPromise.all = Promise.all;
	    // Chrome Canary 49 (probably older too) has some implementation bugs
	    var hasBadResolverPromise = valueOrFalseIfThrows(function () {
	      return !!BadResolverPromise.all([1, 2]);
	    });

	    if (!promiseSupportsSubclassing || !promiseIgnoresNonFunctionThenCallbacks ||
	        !promiseRequiresObjectContext || promiseResolveBroken ||
	        !getsThenSynchronously || hasBadResolverPromise) {
	      /* globals Promise: true */
	      /* eslint-disable no-undef */
	      /* jshint -W020 */
	      Promise = PromiseShim;
	      /* jshint +W020 */
	      /* eslint-enable no-undef */
	      /* globals Promise: false */
	      overrideNative(globals, 'Promise', PromiseShim);
	    }
	    if (Promise.all.length !== 1) {
	      var origAll = Promise.all;
	      overrideNative(Promise, 'all', function all(iterable) {
	        return ES.Call(origAll, this, arguments);
	      });
	    }
	    if (Promise.race.length !== 1) {
	      var origRace = Promise.race;
	      overrideNative(Promise, 'race', function race(iterable) {
	        return ES.Call(origRace, this, arguments);
	      });
	    }
	    if (Promise.resolve.length !== 1) {
	      var origResolve = Promise.resolve;
	      overrideNative(Promise, 'resolve', function resolve(x) {
	        return ES.Call(origResolve, this, arguments);
	      });
	    }
	    if (Promise.reject.length !== 1) {
	      var origReject = Promise.reject;
	      overrideNative(Promise, 'reject', function reject(r) {
	        return ES.Call(origReject, this, arguments);
	      });
	    }
	    ensureEnumerable(Promise, 'all');
	    ensureEnumerable(Promise, 'race');
	    ensureEnumerable(Promise, 'resolve');
	    ensureEnumerable(Promise, 'reject');
	    addDefaultSpecies(Promise);
	  }

	  // Map and Set require a true ES5 environment
	  // Their fast path also requires that the environment preserve
	  // property insertion order, which is not guaranteed by the spec.
	  var testOrder = function (a) {
	    var b = keys(_reduce(a, function (o, k) {
	      o[k] = true;
	      return o;
	    }, {}));
	    return a.join(':') === b.join(':');
	  };
	  var preservesInsertionOrder = testOrder(['z', 'a', 'bb']);
	  // some engines (eg, Chrome) only preserve insertion order for string keys
	  var preservesNumericInsertionOrder = testOrder(['z', 1, 'a', '3', 2]);

	  if (supportsDescriptors) {

	    var fastkey = function fastkey(key) {
	      if (!preservesInsertionOrder) {
	        return null;
	      }
	      if (typeof key === 'undefined' || key === null) {
	        return '^' + ES.ToString(key);
	      } else if (typeof key === 'string') {
	        return '$' + key;
	      } else if (typeof key === 'number') {
	        // note that -0 will get coerced to "0" when used as a property key
	        if (!preservesNumericInsertionOrder) {
	          return 'n' + key;
	        }
	        return key;
	      } else if (typeof key === 'boolean') {
	        return 'b' + key;
	      }
	      return null;
	    };

	    var emptyObject = function emptyObject() {
	      // accomodate some older not-quite-ES5 browsers
	      return Object.create ? Object.create(null) : {};
	    };

	    var addIterableToMap = function addIterableToMap(MapConstructor, map, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (entry) {
	          if (!ES.TypeIsObject(entry)) {
	            throw new TypeError('Iterator value ' + entry + ' is not an entry object');
	          }
	          map.set(entry[0], entry[1]);
	        });
	      } else if (iterable instanceof MapConstructor) {
	        _call(MapConstructor.prototype.forEach, iterable, function (value, key) {
	          map.set(key, value);
	        });
	      } else {
	        var iter, adder;
	        if (iterable !== null && typeof iterable !== 'undefined') {
	          adder = map.set;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad map'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextItem = next.value;
	            try {
	              if (!ES.TypeIsObject(nextItem)) {
	                throw new TypeError('Iterator value ' + nextItem + ' is not an entry object');
	              }
	              _call(adder, map, nextItem[0], nextItem[1]);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };
	    var addIterableToSet = function addIterableToSet(SetConstructor, set, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (value) {
	          set.add(value);
	        });
	      } else if (iterable instanceof SetConstructor) {
	        _call(SetConstructor.prototype.forEach, iterable, function (value) {
	          set.add(value);
	        });
	      } else {
	        var iter, adder;
	        if (iterable !== null && typeof iterable !== 'undefined') {
	          adder = set.add;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad set'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextValue = next.value;
	            try {
	              _call(adder, set, nextValue);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };

	    var collectionShims = {
	      Map: (function () {

	        var empty = {};

	        var MapEntry = function MapEntry(key, value) {
	          this.key = key;
	          this.value = value;
	          this.next = null;
	          this.prev = null;
	        };

	        MapEntry.prototype.isRemoved = function isRemoved() {
	          return this.key === empty;
	        };

	        var isMap = function isMap(map) {
	          return !!map._es6map;
	        };

	        var requireMapSlot = function requireMapSlot(map, method) {
	          if (!ES.TypeIsObject(map) || !isMap(map)) {
	            throw new TypeError('Method Map.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(map));
	          }
	        };

	        var MapIterator = function MapIterator(map, kind) {
	          requireMapSlot(map, '[[MapIterator]]');
	          this.head = map._head;
	          this.i = this.head;
	          this.kind = kind;
	        };

	        MapIterator.prototype = {
	          next: function next() {
	            var i = this.i;
	            var kind = this.kind;
	            var head = this.head;
	            if (typeof this.i === 'undefined') {
	              return iteratorResult();
	            }
	            while (i.isRemoved() && i !== head) {
	              // back up off of removed entries
	              i = i.prev;
	            }
	            // advance to next unreturned element.
	            var result;
	            while (i.next !== head) {
	              i = i.next;
	              if (!i.isRemoved()) {
	                if (kind === 'key') {
	                  result = i.key;
	                } else if (kind === 'value') {
	                  result = i.value;
	                } else {
	                  result = [i.key, i.value];
	                }
	                this.i = i;
	                return iteratorResult(result);
	              }
	            }
	            // once the iterator is done, it is done forever.
	            this.i = void 0;
	            return iteratorResult();
	          }
	        };
	        addIterator(MapIterator.prototype);

	        var Map$prototype;
	        var MapShim = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          if (this && this._es6map) {
	            throw new TypeError('Bad construction');
	          }
	          var map = emulateES6construct(this, Map, Map$prototype, {
	            _es6map: true,
	            _head: null,
	            _storage: emptyObject(),
	            _size: 0
	          });

	          var head = new MapEntry(null, null);
	          // circular doubly-linked list.
	          head.next = head.prev = head;
	          map._head = head;

	          // Optionally initialize map from iterable
	          if (arguments.length > 0) {
	            addIterableToMap(Map, map, arguments[0]);
	          }
	          return map;
	        };
	        Map$prototype = MapShim.prototype;

	        Value.getter(Map$prototype, 'size', function () {
	          if (typeof this._size === 'undefined') {
	            throw new TypeError('size method called on incompatible Map');
	          }
	          return this._size;
	        });

	        defineProperties(Map$prototype, {
	          get: function get(key) {
	            requireMapSlot(this, 'get');
	            var fkey = fastkey(key);
	            if (fkey !== null) {
	              // fast O(1) path
	              var entry = this._storage[fkey];
	              if (entry) {
	                return entry.value;
	              } else {
	                return;
	              }
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return i.value;
	              }
	            }
	          },

	          has: function has(key) {
	            requireMapSlot(this, 'has');
	            var fkey = fastkey(key);
	            if (fkey !== null) {
	              // fast O(1) path
	              return typeof this._storage[fkey] !== 'undefined';
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return true;
	              }
	            }
	            return false;
	          },

	          set: function set(key, value) {
	            requireMapSlot(this, 'set');
	            var head = this._head;
	            var i = head;
	            var entry;
	            var fkey = fastkey(key);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] !== 'undefined') {
	                this._storage[fkey].value = value;
	                return this;
	              } else {
	                entry = this._storage[fkey] = new MapEntry(key, value);
	                i = head.prev;
	                // fall through
	              }
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.value = value;
	                return this;
	              }
	            }
	            entry = entry || new MapEntry(key, value);
	            if (ES.SameValue(-0, key)) {
	              entry.key = +0; // coerce -0 to +0 in entry
	            }
	            entry.next = this._head;
	            entry.prev = this._head.prev;
	            entry.prev.next = entry;
	            entry.next.prev = entry;
	            this._size += 1;
	            return this;
	          },

	          'delete': function (key) {
	            requireMapSlot(this, 'delete');
	            var head = this._head;
	            var i = head;
	            var fkey = fastkey(key);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] === 'undefined') {
	                return false;
	              }
	              i = this._storage[fkey].prev;
	              delete this._storage[fkey];
	              // fall through
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.key = i.value = empty;
	                i.prev.next = i.next;
	                i.next.prev = i.prev;
	                this._size -= 1;
	                return true;
	              }
	            }
	            return false;
	          },

	          clear: function clear() {
	            requireMapSlot(this, 'clear');
	            this._size = 0;
	            this._storage = emptyObject();
	            var head = this._head;
	            var i = head;
	            var p = i.next;
	            while ((i = p) !== head) {
	              i.key = i.value = empty;
	              p = i.next;
	              i.next = i.prev = head;
	            }
	            head.next = head.prev = head;
	          },

	          keys: function keys() {
	            requireMapSlot(this, 'keys');
	            return new MapIterator(this, 'key');
	          },

	          values: function values() {
	            requireMapSlot(this, 'values');
	            return new MapIterator(this, 'value');
	          },

	          entries: function entries() {
	            requireMapSlot(this, 'entries');
	            return new MapIterator(this, 'key+value');
	          },

	          forEach: function forEach(callback) {
	            requireMapSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var it = this.entries();
	            for (var entry = it.next(); !entry.done; entry = it.next()) {
	              if (context) {
	                _call(callback, context, entry.value[1], entry.value[0], this);
	              } else {
	                callback(entry.value[1], entry.value[0], this);
	              }
	            }
	          }
	        });
	        addIterator(Map$prototype, Map$prototype.entries);

	        return MapShim;
	      }()),

	      Set: (function () {
	        var isSet = function isSet(set) {
	          return set._es6set && typeof set._storage !== 'undefined';
	        };
	        var requireSetSlot = function requireSetSlot(set, method) {
	          if (!ES.TypeIsObject(set) || !isSet(set)) {
	            // https://github.com/paulmillr/es6-shim/issues/176
	            throw new TypeError('Set.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(set));
	          }
	        };

	        // Creating a Map is expensive.  To speed up the common case of
	        // Sets containing only string or numeric keys, we use an object
	        // as backing storage and lazily create a full Map only when
	        // required.
	        var Set$prototype;
	        var SetShim = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          if (this && this._es6set) {
	            throw new TypeError('Bad construction');
	          }
	          var set = emulateES6construct(this, Set, Set$prototype, {
	            _es6set: true,
	            '[[SetData]]': null,
	            _storage: emptyObject()
	          });
	          if (!set._es6set) {
	            throw new TypeError('bad set');
	          }

	          // Optionally initialize Set from iterable
	          if (arguments.length > 0) {
	            addIterableToSet(Set, set, arguments[0]);
	          }
	          return set;
	        };
	        Set$prototype = SetShim.prototype;

	        var decodeKey = function (key) {
	          var k = key;
	          if (k === '^null') {
	            return null;
	          } else if (k === '^undefined') {
	            return void 0;
	          } else {
	            var first = k.charAt(0);
	            if (first === '$') {
	              return _strSlice(k, 1);
	            } else if (first === 'n') {
	              return +_strSlice(k, 1);
	            } else if (first === 'b') {
	              return k === 'btrue';
	            }
	          }
	          return +k;
	        };
	        // Switch from the object backing storage to a full Map.
	        var ensureMap = function ensureMap(set) {
	          if (!set['[[SetData]]']) {
	            var m = set['[[SetData]]'] = new collectionShims.Map();
	            _forEach(keys(set._storage), function (key) {
	              var k = decodeKey(key);
	              m.set(k, k);
	            });
	            set['[[SetData]]'] = m;
	          }
	          set._storage = null; // free old backing storage
	        };

	        Value.getter(SetShim.prototype, 'size', function () {
	          requireSetSlot(this, 'size');
	          if (this._storage) {
	            return keys(this._storage).length;
	          }
	          ensureMap(this);
	          return this['[[SetData]]'].size;
	        });

	        defineProperties(SetShim.prototype, {
	          has: function has(key) {
	            requireSetSlot(this, 'has');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              return !!this._storage[fkey];
	            }
	            ensureMap(this);
	            return this['[[SetData]]'].has(key);
	          },

	          add: function add(key) {
	            requireSetSlot(this, 'add');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              this._storage[fkey] = true;
	              return this;
	            }
	            ensureMap(this);
	            this['[[SetData]]'].set(key, key);
	            return this;
	          },

	          'delete': function (key) {
	            requireSetSlot(this, 'delete');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              var hasFKey = _hasOwnProperty(this._storage, fkey);
	              return (delete this._storage[fkey]) && hasFKey;
	            }
	            ensureMap(this);
	            return this['[[SetData]]']['delete'](key);
	          },

	          clear: function clear() {
	            requireSetSlot(this, 'clear');
	            if (this._storage) {
	              this._storage = emptyObject();
	            }
	            if (this['[[SetData]]']) {
	              this['[[SetData]]'].clear();
	            }
	          },

	          values: function values() {
	            requireSetSlot(this, 'values');
	            ensureMap(this);
	            return this['[[SetData]]'].values();
	          },

	          entries: function entries() {
	            requireSetSlot(this, 'entries');
	            ensureMap(this);
	            return this['[[SetData]]'].entries();
	          },

	          forEach: function forEach(callback) {
	            requireSetSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var entireSet = this;
	            ensureMap(entireSet);
	            this['[[SetData]]'].forEach(function (value, key) {
	              if (context) {
	                _call(callback, context, key, key, entireSet);
	              } else {
	                callback(key, key, entireSet);
	              }
	            });
	          }
	        });
	        defineProperty(SetShim.prototype, 'keys', SetShim.prototype.values, true);
	        addIterator(SetShim.prototype, SetShim.prototype.values);

	        return SetShim;
	      }())
	    };

	    if (globals.Map || globals.Set) {
	      // Safari 8, for example, doesn't accept an iterable.
	      var mapAcceptsArguments = valueOrFalseIfThrows(function () { return new Map([[1, 2]]).get(1) === 2; });
	      if (!mapAcceptsArguments) {
	        var OrigMapNoArgs = globals.Map;
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMapNoArgs();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, globals.Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = create(OrigMapNoArgs.prototype);
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMapNoArgs);
	      }
	      var testMap = new Map();
	      var mapUsesSameValueZero = (function () {
	        // Chrome 38-42, node 0.11/0.12, iojs 1/2 also have a bug when the Map has a size > 4
	        var m = new Map([[1, 0], [2, 0], [3, 0], [4, 0]]);
	        m.set(-0, m);
	        return m.get(0) === m && m.get(-0) === m && m.has(0) && m.has(-0);
	      }());
	      var mapSupportsChaining = testMap.set(1, 2) === testMap;
	      if (!mapUsesSameValueZero || !mapSupportsChaining) {
	        var origMapSet = Map.prototype.set;
	        overrideNative(Map.prototype, 'set', function set(k, v) {
	          _call(origMapSet, this, k === 0 ? 0 : k, v);
	          return this;
	        });
	      }
	      if (!mapUsesSameValueZero) {
	        var origMapGet = Map.prototype.get;
	        var origMapHas = Map.prototype.has;
	        defineProperties(Map.prototype, {
	          get: function get(k) {
	            return _call(origMapGet, this, k === 0 ? 0 : k);
	          },
	          has: function has(k) {
	            return _call(origMapHas, this, k === 0 ? 0 : k);
	          }
	        }, true);
	        Value.preserveToString(Map.prototype.get, origMapGet);
	        Value.preserveToString(Map.prototype.has, origMapHas);
	      }
	      var testSet = new Set();
	      var setUsesSameValueZero = (function (s) {
	        s['delete'](0);
	        s.add(-0);
	        return !s.has(0);
	      }(testSet));
	      var setSupportsChaining = testSet.add(1) === testSet;
	      if (!setUsesSameValueZero || !setSupportsChaining) {
	        var origSetAdd = Set.prototype.add;
	        Set.prototype.add = function add(v) {
	          _call(origSetAdd, this, v === 0 ? 0 : v);
	          return this;
	        };
	        Value.preserveToString(Set.prototype.add, origSetAdd);
	      }
	      if (!setUsesSameValueZero) {
	        var origSetHas = Set.prototype.has;
	        Set.prototype.has = function has(v) {
	          return _call(origSetHas, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype.has, origSetHas);
	        var origSetDel = Set.prototype['delete'];
	        Set.prototype['delete'] = function SetDelete(v) {
	          return _call(origSetDel, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype['delete'], origSetDel);
	      }
	      var mapSupportsSubclassing = supportsSubclassing(globals.Map, function (M) {
	        var m = new M([]);
	        // Firefox 32 is ok with the instantiating the subclass but will
	        // throw when the map is used.
	        m.set(42, 42);
	        return m instanceof M;
	      });
	      var mapFailsToSupportSubclassing = Object.setPrototypeOf && !mapSupportsSubclassing; // without Object.setPrototypeOf, subclassing is not possible
	      var mapRequiresNew = (function () {
	        try {
	          return !(globals.Map() instanceof globals.Map);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Map.length !== 0 || mapFailsToSupportSubclassing || !mapRequiresNew) {
	        var OrigMap = globals.Map;
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMap();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = OrigMap.prototype;
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMap);
	      }
	      var setSupportsSubclassing = supportsSubclassing(globals.Set, function (S) {
	        var s = new S([]);
	        s.add(42, 42);
	        return s instanceof S;
	      });
	      var setFailsToSupportSubclassing = Object.setPrototypeOf && !setSupportsSubclassing; // without Object.setPrototypeOf, subclassing is not possible
	      var setRequiresNew = (function () {
	        try {
	          return !(globals.Set() instanceof globals.Set);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Set.length !== 0 || setFailsToSupportSubclassing || !setRequiresNew) {
	        var OrigSet = globals.Set;
	        globals.Set = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          var s = new OrigSet();
	          if (arguments.length > 0) {
	            addIterableToSet(Set, s, arguments[0]);
	          }
	          delete s.constructor;
	          Object.setPrototypeOf(s, Set.prototype);
	          return s;
	        };
	        globals.Set.prototype = OrigSet.prototype;
	        defineProperty(globals.Set.prototype, 'constructor', globals.Set, true);
	        Value.preserveToString(globals.Set, OrigSet);
	      }
	      var newMap = new globals.Map();
	      var mapIterationThrowsStopIterator = !valueOrFalseIfThrows(function () {
	        return newMap.keys().next().done;
	      });
	      /*
	        - In Firefox < 23, Map#size is a function.
	        - In all current Firefox, Set#entries/keys/values & Map#clear do not exist
	        - https://bugzilla.mozilla.org/show_bug.cgi?id=869996
	        - In Firefox 24, Map and Set do not implement forEach
	        - In Firefox 25 at least, Map and Set are callable without "new"
	      */
	      if (
	        typeof globals.Map.prototype.clear !== 'function' ||
	        new globals.Set().size !== 0 ||
	        newMap.size !== 0 ||
	        typeof globals.Map.prototype.keys !== 'function' ||
	        typeof globals.Set.prototype.keys !== 'function' ||
	        typeof globals.Map.prototype.forEach !== 'function' ||
	        typeof globals.Set.prototype.forEach !== 'function' ||
	        isCallableWithoutNew(globals.Map) ||
	        isCallableWithoutNew(globals.Set) ||
	        typeof newMap.keys().next !== 'function' || // Safari 8
	        mapIterationThrowsStopIterator || // Firefox 25
	        !mapSupportsSubclassing
	      ) {
	        defineProperties(globals, {
	          Map: collectionShims.Map,
	          Set: collectionShims.Set
	        }, true);
	      }

	      if (globals.Set.prototype.keys !== globals.Set.prototype.values) {
	        // Fixed in WebKit with https://bugs.webkit.org/show_bug.cgi?id=144190
	        defineProperty(globals.Set.prototype, 'keys', globals.Set.prototype.values, true);
	      }

	      // Shim incomplete iterator implementations.
	      addIterator(Object.getPrototypeOf((new globals.Map()).keys()));
	      addIterator(Object.getPrototypeOf((new globals.Set()).keys()));

	      if (functionsHaveNames && globals.Set.prototype.has.name !== 'has') {
	        // Microsoft Edge v0.11.10074.0 is missing a name on Set#has
	        var anonymousSetHas = globals.Set.prototype.has;
	        overrideNative(globals.Set.prototype, 'has', function has(key) {
	          return _call(anonymousSetHas, this, key);
	        });
	      }
	    }
	    defineProperties(globals, collectionShims);
	    addDefaultSpecies(globals.Map);
	    addDefaultSpecies(globals.Set);
	  }

	  var throwUnlessTargetIsObject = function throwUnlessTargetIsObject(target) {
	    if (!ES.TypeIsObject(target)) {
	      throw new TypeError('target must be an object');
	    }
	  };

	  // Some Reflect methods are basically the same as
	  // those on the Object global, except that a TypeError is thrown if
	  // target isn't an object. As well as returning a boolean indicating
	  // the success of the operation.
	  var ReflectShims = {
	    // Apply method in a functional form.
	    apply: function apply() {
	      return ES.Call(ES.Call, null, arguments);
	    },

	    // New operator in a functional form.
	    construct: function construct(constructor, args) {
	      if (!ES.IsConstructor(constructor)) {
	        throw new TypeError('First argument must be a constructor.');
	      }
	      var newTarget = arguments.length > 2 ? arguments[2] : constructor;
	      if (!ES.IsConstructor(newTarget)) {
	        throw new TypeError('new.target must be a constructor.');
	      }
	      return ES.Construct(constructor, args, newTarget, 'internal');
	    },

	    // When deleting a non-existent or configurable property,
	    // true is returned.
	    // When attempting to delete a non-configurable property,
	    // it will return false.
	    deleteProperty: function deleteProperty(target, key) {
	      throwUnlessTargetIsObject(target);
	      if (supportsDescriptors) {
	        var desc = Object.getOwnPropertyDescriptor(target, key);

	        if (desc && !desc.configurable) {
	          return false;
	        }
	      }

	      // Will return true.
	      return delete target[key];
	    },

	    has: function has(target, key) {
	      throwUnlessTargetIsObject(target);
	      return key in target;
	    }
	  };

	  if (Object.getOwnPropertyNames) {
	    Object.assign(ReflectShims, {
	      // Basically the result of calling the internal [[OwnPropertyKeys]].
	      // Concatenating propertyNames and propertySymbols should do the trick.
	      // This should continue to work together with a Symbol shim
	      // which overrides Object.getOwnPropertyNames and implements
	      // Object.getOwnPropertySymbols.
	      ownKeys: function ownKeys(target) {
	        throwUnlessTargetIsObject(target);
	        var keys = Object.getOwnPropertyNames(target);

	        if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	          _pushApply(keys, Object.getOwnPropertySymbols(target));
	        }

	        return keys;
	      }
	    });
	  }

	  var callAndCatchException = function ConvertExceptionToBoolean(func) {
	    return !throwsError(func);
	  };

	  if (Object.preventExtensions) {
	    Object.assign(ReflectShims, {
	      isExtensible: function isExtensible(target) {
	        throwUnlessTargetIsObject(target);
	        return Object.isExtensible(target);
	      },
	      preventExtensions: function preventExtensions(target) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          Object.preventExtensions(target);
	        });
	      }
	    });
	  }

	  if (supportsDescriptors) {
	    var internalGet = function get(target, key, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);

	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);

	        if (parent === null) {
	          return void 0;
	        }

	        return internalGet(parent, key, receiver);
	      }

	      if ('value' in desc) {
	        return desc.value;
	      }

	      if (desc.get) {
	        return ES.Call(desc.get, receiver);
	      }

	      return void 0;
	    };

	    var internalSet = function set(target, key, value, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);

	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);

	        if (parent !== null) {
	          return internalSet(parent, key, value, receiver);
	        }

	        desc = {
	          value: void 0,
	          writable: true,
	          enumerable: true,
	          configurable: true
	        };
	      }

	      if ('value' in desc) {
	        if (!desc.writable) {
	          return false;
	        }

	        if (!ES.TypeIsObject(receiver)) {
	          return false;
	        }

	        var existingDesc = Object.getOwnPropertyDescriptor(receiver, key);

	        if (existingDesc) {
	          return Reflect.defineProperty(receiver, key, {
	            value: value
	          });
	        } else {
	          return Reflect.defineProperty(receiver, key, {
	            value: value,
	            writable: true,
	            enumerable: true,
	            configurable: true
	          });
	        }
	      }

	      if (desc.set) {
	        _call(desc.set, receiver, value);
	        return true;
	      }

	      return false;
	    };

	    Object.assign(ReflectShims, {
	      defineProperty: function defineProperty(target, propertyKey, attributes) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          Object.defineProperty(target, propertyKey, attributes);
	        });
	      },

	      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	        throwUnlessTargetIsObject(target);
	        return Object.getOwnPropertyDescriptor(target, propertyKey);
	      },

	      // Syntax in a functional form.
	      get: function get(target, key) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 2 ? arguments[2] : target;

	        return internalGet(target, key, receiver);
	      },

	      set: function set(target, key, value) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 3 ? arguments[3] : target;

	        return internalSet(target, key, value, receiver);
	      }
	    });
	  }

	  if (Object.getPrototypeOf) {
	    var objectDotGetPrototypeOf = Object.getPrototypeOf;
	    ReflectShims.getPrototypeOf = function getPrototypeOf(target) {
	      throwUnlessTargetIsObject(target);
	      return objectDotGetPrototypeOf(target);
	    };
	  }

	  if (Object.setPrototypeOf && ReflectShims.getPrototypeOf) {
	    var willCreateCircularPrototype = function (object, lastProto) {
	      var proto = lastProto;
	      while (proto) {
	        if (object === proto) {
	          return true;
	        }
	        proto = ReflectShims.getPrototypeOf(proto);
	      }
	      return false;
	    };

	    Object.assign(ReflectShims, {
	      // Sets the prototype of the given object.
	      // Returns true on success, otherwise false.
	      setPrototypeOf: function setPrototypeOf(object, proto) {
	        throwUnlessTargetIsObject(object);
	        if (proto !== null && !ES.TypeIsObject(proto)) {
	          throw new TypeError('proto must be an object or null');
	        }

	        // If they already are the same, we're done.
	        if (proto === Reflect.getPrototypeOf(object)) {
	          return true;
	        }

	        // Cannot alter prototype if object not extensible.
	        if (Reflect.isExtensible && !Reflect.isExtensible(object)) {
	          return false;
	        }

	        // Ensure that we do not create a circular prototype chain.
	        if (willCreateCircularPrototype(object, proto)) {
	          return false;
	        }

	        Object.setPrototypeOf(object, proto);

	        return true;
	      }
	    });
	  }
	  var defineOrOverrideReflectProperty = function (key, shim) {
	    if (!ES.IsCallable(globals.Reflect[key])) {
	      defineProperty(globals.Reflect, key, shim);
	    } else {
	      var acceptsPrimitives = valueOrFalseIfThrows(function () {
	        globals.Reflect[key](1);
	        globals.Reflect[key](NaN);
	        globals.Reflect[key](true);
	        return true;
	      });
	      if (acceptsPrimitives) {
	        overrideNative(globals.Reflect, key, shim);
	      }
	    }
	  };
	  Object.keys(ReflectShims).forEach(function (key) {
	    defineOrOverrideReflectProperty(key, ReflectShims[key]);
	  });
	  var originalReflectGetProto = globals.Reflect.getPrototypeOf;
	  if (functionsHaveNames && originalReflectGetProto && originalReflectGetProto.name !== 'getPrototypeOf') {
	    overrideNative(globals.Reflect, 'getPrototypeOf', function getPrototypeOf(target) {
	      return _call(originalReflectGetProto, globals.Reflect, target);
	    });
	  }
	  if (globals.Reflect.setPrototypeOf) {
	    if (valueOrFalseIfThrows(function () {
	      globals.Reflect.setPrototypeOf(1, {});
	      return true;
	    })) {
	      overrideNative(globals.Reflect, 'setPrototypeOf', ReflectShims.setPrototypeOf);
	    }
	  }
	  if (globals.Reflect.defineProperty) {
	    if (!valueOrFalseIfThrows(function () {
	      var basic = !globals.Reflect.defineProperty(1, 'test', { value: 1 });
	      // "extensible" fails on Edge 0.12
	      var extensible = typeof Object.preventExtensions !== 'function' || !globals.Reflect.defineProperty(Object.preventExtensions({}), 'test', {});
	      return basic && extensible;
	    })) {
	      overrideNative(globals.Reflect, 'defineProperty', ReflectShims.defineProperty);
	    }
	  }
	  if (globals.Reflect.construct) {
	    if (!valueOrFalseIfThrows(function () {
	      var F = function F() {};
	      return globals.Reflect.construct(function () {}, [], F) instanceof F;
	    })) {
	      overrideNative(globals.Reflect, 'construct', ReflectShims.construct);
	    }
	  }

	  if (String(new Date(NaN)) !== 'Invalid Date') {
	    var dateToString = Date.prototype.toString;
	    var shimmedDateToString = function toString() {
	      var valueOf = +this;
	      if (valueOf !== valueOf) {
	        return 'Invalid Date';
	      }
	      return ES.Call(dateToString, this);
	    };
	    overrideNative(Date.prototype, 'toString', shimmedDateToString);
	  }

	  // Annex B HTML methods
	  // http://www.ecma-international.org/ecma-262/6.0/#sec-additional-properties-of-the-string.prototype-object
	  var stringHTMLshims = {
	    anchor: function anchor(name) { return ES.CreateHTML(this, 'a', 'name', name); },
	    big: function big() { return ES.CreateHTML(this, 'big', '', ''); },
	    blink: function blink() { return ES.CreateHTML(this, 'blink', '', ''); },
	    bold: function bold() { return ES.CreateHTML(this, 'b', '', ''); },
	    fixed: function fixed() { return ES.CreateHTML(this, 'tt', '', ''); },
	    fontcolor: function fontcolor(color) { return ES.CreateHTML(this, 'font', 'color', color); },
	    fontsize: function fontsize(size) { return ES.CreateHTML(this, 'font', 'size', size); },
	    italics: function italics() { return ES.CreateHTML(this, 'i', '', ''); },
	    link: function link(url) { return ES.CreateHTML(this, 'a', 'href', url); },
	    small: function small() { return ES.CreateHTML(this, 'small', '', ''); },
	    strike: function strike() { return ES.CreateHTML(this, 'strike', '', ''); },
	    sub: function sub() { return ES.CreateHTML(this, 'sub', '', ''); },
	    sup: function sub() { return ES.CreateHTML(this, 'sup', '', ''); }
	  };
	  _forEach(Object.keys(stringHTMLshims), function (key) {
	    var method = String.prototype[key];
	    var shouldOverwrite = false;
	    if (ES.IsCallable(method)) {
	      var output = _call(method, '', ' " ');
	      var quotesCount = _concat([], output.match(/"/g)).length;
	      shouldOverwrite = output !== output.toLowerCase() || quotesCount > 2;
	    } else {
	      shouldOverwrite = true;
	    }
	    if (shouldOverwrite) {
	      overrideNative(String.prototype, key, stringHTMLshims[key]);
	    }
	  });

	  var JSONstringifiesSymbols = (function () {
	    // Microsoft Edge v0.12 stringifies Symbols incorrectly
	    if (!hasSymbols) { return false; } // Symbols are not supported
	    var stringify = typeof JSON === 'object' && typeof JSON.stringify === 'function' ? JSON.stringify : null;
	    if (!stringify) { return false; } // JSON.stringify is not supported
	    if (typeof stringify(Symbol()) !== 'undefined') { return true; } // Symbols should become `undefined`
	    if (stringify([Symbol()]) !== '[null]') { return true; } // Symbols in arrays should become `null`
	    var obj = { a: Symbol() };
	    obj[Symbol()] = true;
	    if (stringify(obj) !== '{}') { return true; } // Symbol-valued keys *and* Symbol-valued properties should be omitted
	    return false;
	  }());
	  var JSONstringifyAcceptsObjectSymbol = valueOrFalseIfThrows(function () {
	    // Chrome 45 throws on stringifying object symbols
	    if (!hasSymbols) { return true; } // Symbols are not supported
	    return JSON.stringify(Object(Symbol())) === '{}' && JSON.stringify([Object(Symbol())]) === '[{}]';
	  });
	  if (JSONstringifiesSymbols || !JSONstringifyAcceptsObjectSymbol) {
	    var origStringify = JSON.stringify;
	    overrideNative(JSON, 'stringify', function stringify(value) {
	      if (typeof value === 'symbol') { return; }
	      var replacer;
	      if (arguments.length > 1) {
	        replacer = arguments[1];
	      }
	      var args = [value];
	      if (!isArray(replacer)) {
	        var replaceFn = ES.IsCallable(replacer) ? replacer : null;
	        var wrappedReplacer = function (key, val) {
	          var parsedValue = replaceFn ? _call(replaceFn, this, key, val) : val;
	          if (typeof parsedValue !== 'symbol') {
	            if (Type.symbol(parsedValue)) {
	              return assignTo({})(parsedValue);
	            } else {
	              return parsedValue;
	            }
	          }
	        };
	        args.push(wrappedReplacer);
	      } else {
	        // create wrapped replacer that handles an array replacer?
	        args.push(replacer);
	      }
	      if (arguments.length > 2) {
	        args.push(arguments[2]);
	      }
	      return origStringify.apply(this, args);
	    });
	  }

	  return globals;
	}));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(143)))

/***/ },
/* 91 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 92 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 93 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 94 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 95 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 96 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 97 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 98 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 99 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 100 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 101 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 102 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 103 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 104 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 105 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 106 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 107 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 108 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 109 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 110 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0a67745be38d4caa6e00f14e13892f8b.eot";

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32400f4e08932a94d8bfd2422702c446.eot";

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f775f9cca88e21d45bebe185b27c0e5b.svg";

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a3de2170e4e9df77161ea5d3f31b2668.ttf";

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(119);


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(117)();
	// imports


	// module
	exports.push([module.id, ".fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-fw{width:1.28571429em;text-align:center}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(112) + ");src:url(" + __webpack_require__(111) + "?#iefix&v=4.5.0) format('embedded-opentype'),url(" + __webpack_require__(144) + ") format('woff2'),url(" + __webpack_require__(145) + ") format('woff'),url(" + __webpack_require__(114) + ") format('truetype'),url(" + __webpack_require__(113) + "#fontawesomeregular) format('svg');font-weight:400;font-style:normal}.fa-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);-webkit-transform:scale(1,-1);transform:scale(1,-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}", ""]);

	// exports


/***/ },
/* 117 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}

	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(116);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(118)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./node_modules/css-loader/index.js!../less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js", function() {
				var newContent = require("!!./node_modules/css-loader/index.js!../less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 120 */
/***/ function(module, exports) {

	/* ng-infinite-scroll - v1.2.0 - 2014-12-02 */
	var mod;

	mod = angular.module('infinite-scroll', []);

	mod.value('THROTTLE_MILLISECONDS', null);

	mod.directive('infiniteScroll', [
	  '$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS', function($rootScope, $window, $interval, THROTTLE_MILLISECONDS) {
	    return {
	      scope: {
	        infiniteScroll: '&',
	        infiniteScrollContainer: '=',
	        infiniteScrollDistance: '=',
	        infiniteScrollDisabled: '=',
	        infiniteScrollUseDocumentBottom: '='
	      },
	      link: function(scope, elem, attrs) {
	        var changeContainer, checkWhenEnabled, container, handleInfiniteScrollContainer, handleInfiniteScrollDisabled, handleInfiniteScrollDistance, handleInfiniteScrollUseDocumentBottom, handler, height, immediateCheck, offsetTop, pageYOffset, scrollDistance, scrollEnabled, throttle, useDocumentBottom, windowElement;
	        windowElement = angular.element($window);
	        scrollDistance = null;
	        scrollEnabled = null;
	        checkWhenEnabled = null;
	        container = null;
	        immediateCheck = true;
	        useDocumentBottom = false;
	        height = function(elem) {
	          elem = elem[0] || elem;
	          if (isNaN(elem.offsetHeight)) {
	            return elem.document.documentElement.clientHeight;
	          } else {
	            return elem.offsetHeight;
	          }
	        };
	        offsetTop = function(elem) {
	          if (!elem[0].getBoundingClientRect || elem.css('none')) {
	            return;
	          }
	          return elem[0].getBoundingClientRect().top + pageYOffset(elem);
	        };
	        pageYOffset = function(elem) {
	          elem = elem[0] || elem;
	          if (isNaN(window.pageYOffset)) {
	            return elem.document.documentElement.scrollTop;
	          } else {
	            return elem.ownerDocument.defaultView.pageYOffset;
	          }
	        };
	        handler = function() {
	          var containerBottom, containerTopOffset, elementBottom, remaining, shouldScroll;
	          if (container === windowElement) {
	            containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
	            elementBottom = offsetTop(elem) + height(elem);
	          } else {
	            containerBottom = height(container);
	            containerTopOffset = 0;
	            if (offsetTop(container) !== void 0) {
	              containerTopOffset = offsetTop(container);
	            }
	            elementBottom = offsetTop(elem) - containerTopOffset + height(elem);
	          }
	          if (useDocumentBottom) {
	            elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
	          }
	          remaining = elementBottom - containerBottom;
	          shouldScroll = remaining <= height(container) * scrollDistance + 1;
	          if (shouldScroll) {
	            checkWhenEnabled = true;
	            if (scrollEnabled) {
	              if (scope.$$phase || $rootScope.$$phase) {
	                return scope.infiniteScroll();
	              } else {
	                return scope.$apply(scope.infiniteScroll);
	              }
	            }
	          } else {
	            return checkWhenEnabled = false;
	          }
	        };
	        throttle = function(func, wait) {
	          var later, previous, timeout;
	          timeout = null;
	          previous = 0;
	          later = function() {
	            var context;
	            previous = new Date().getTime();
	            $interval.cancel(timeout);
	            timeout = null;
	            func.call();
	            return context = null;
	          };
	          return function() {
	            var now, remaining;
	            now = new Date().getTime();
	            remaining = wait - (now - previous);
	            if (remaining <= 0) {
	              clearTimeout(timeout);
	              $interval.cancel(timeout);
	              timeout = null;
	              previous = now;
	              return func.call();
	            } else {
	              if (!timeout) {
	                return timeout = $interval(later, remaining, 1);
	              }
	            }
	          };
	        };
	        if (THROTTLE_MILLISECONDS != null) {
	          handler = throttle(handler, THROTTLE_MILLISECONDS);
	        }
	        scope.$on('$destroy', function() {
	          return container.unbind('scroll', handler);
	        });
	        handleInfiniteScrollDistance = function(v) {
	          return scrollDistance = parseFloat(v) || 0;
	        };
	        scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
	        handleInfiniteScrollDistance(scope.infiniteScrollDistance);
	        handleInfiniteScrollDisabled = function(v) {
	          scrollEnabled = !v;
	          if (scrollEnabled && checkWhenEnabled) {
	            checkWhenEnabled = false;
	            return handler();
	          }
	        };
	        scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
	        handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);
	        handleInfiniteScrollUseDocumentBottom = function(v) {
	          return useDocumentBottom = v;
	        };
	        scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
	        handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);
	        changeContainer = function(newContainer) {
	          if (container != null) {
	            container.unbind('scroll', handler);
	          }
	          container = newContainer;
	          if (newContainer != null) {
	            return container.bind('scroll', handler);
	          }
	        };
	        changeContainer(windowElement);
	        handleInfiniteScrollContainer = function(newContainer) {
	          if ((newContainer == null) || newContainer.length === 0) {
	            return;
	          }
	          if (newContainer instanceof HTMLElement) {
	            newContainer = angular.element(newContainer);
	          } else if (typeof newContainer.append === 'function') {
	            newContainer = angular.element(newContainer[newContainer.length - 1]);
	          } else if (typeof newContainer === 'string') {
	            newContainer = angular.element(document.querySelector(newContainer));
	          }
	          if (newContainer != null) {
	            return changeContainer(newContainer);
	          } else {
	            throw new Exception("invalid infinite-scroll-container attribute.");
	          }
	        };
	        scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
	        handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);
	        if (attrs.infiniteScrollParent != null) {
	          changeContainer(angular.element(elem.parent()));
	        }
	        if (attrs.infiniteScrollImmediateCheck != null) {
	          immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck);
	        }
	        return $interval((function() {
	          if (immediateCheck) {
	            return handler();
	          }
	        }), 0, 1);
	      }
	    };
	  }
	]);


/***/ },
/* 121 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/app.html';
	var html = "<youtube-player id=youtube-player-container class=\"youtube-player navbar navbar-default navbar-fixed-bottom\" player-id=player auto-next></youtube-player><div id=sidebar class=\"sidebar sidebar-left-fixed ux-maker\" drawer-closed=closed><nav class=\"navbar navbar-transparent\" player-resizer=fullscreen><div class=\"navbar-brand col-md-12\" drawer-toggle=drawer-opened><span class=\"btn btn-navbar btn-link ux-maker sidebar-toggle\"><i class=\"fa fa-bars\"></i> </span>Ech<i class=\"fa fa-headphones\"></i>es</div><navigator></navigator></nav><now-playing></now-playing></div><div class=\"modal-backdrop sidebar-backdrop\" drawer-toggle></div><div class=\"container-fluid container-main drawer-opened\" drawer-closed=drawer-closed drawer-not-closed=drawer-opened><div class=row-fluid><div id=search-results class=\"ux-maker search-results clearfix main-view\" ui-view></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 122 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/feed-filter/feed-filter.tpl.html';
	var html = "<ul id=feed-filter class=\"nav navbar-nav feed-filter nicer-ux\"><li class=feed-item ng-repeat=\"feed in vm.data.items\" ng-class=\"{'active': feed === vm.active}\" ng-click=vm.setFeed(feed)><a title=\"Explore {{:: feed.label}}\" href=#explore><i class=\"fa fa-{{:: feed.icon}}\"></i> {{:: feed.label}}</a></ul>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 123 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/navigator/navigator.tpl.html';
	var html = "<ul id=library-nav class=\"nav nav-list nicer-ux library-nav navigator\"><li class=nav-header>Library<li ng-repeat=\"view in $ctrl.views\" ng-class=\"{ active: view.active }\"><a href=\"#{{:: view.ref }}\"><i class=\"fa fa-{{:: view.icon }}\"></i> {{:: view.label }}</a></ul>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 124 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/now-playing/now-playing.tpl.html';
	var html = "<div class=sidebar-pane><now-playlist-filter playlist=$ctrl.playlist on-save=$ctrl.togglePlaylistSaver(show) on-clear=$ctrl.clearPlaylist() on-change=$ctrl.onFilterChange(filter)></now-playlist-filter><section class=\"playlist-saver-container clearfix\" ng-if=\"$ctrl.showPlaylistSaver && $ctrl.playlist.length > 0\"><playlist-saver class=col-md-12 tracks=$ctrl.playlist on-cancel=$ctrl.togglePlaylistSaver() on-save=$ctrl.onPlaylistSave()></playlist-saver></section><now-playlist videos=$ctrl.playlist now-playing=$ctrl.nowPlaying filter=$ctrl.playlistSearch on-select=$ctrl.playVideo(video) on-remove=\"$ctrl.removeVideo($event, video, $index)\" on-sort=\"$ctrl.updateIndex($item, $indexTo)\" show-playlist-track=$ctrl.isPlaylistMedia(video)></now-playlist></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 125 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/now-playing/now-playlist-filter/now-playlist-filter.tpl.html';
	var html = "<h3 class=\"nav-header nav-header-fluid user-playlists-filter\">Now Playing <button class=\"btn btn-link btn-xs btn-clear\" title=\"Clear All Tracks In Now Playlist\" ng-disabled=!$ctrl.playlist.length ng-click=$ctrl.clearPlaylist()><span class=\"fa fa-trash-o\"></span></button> <button class=\"btn btn-link btn-xs btn-save\" title=\"Save All These Tracks To A New Playlist\" ng-disabled=!$ctrl.playlist.length ng-click=$ctrl.togglePlaylistSaver()><span class=\"fa fa-cloud-upload\"></span></button><div class=\"playlist-filter pull-right\"><i class=\"fa fa-search\" ng-show=$ctrl.isSearchFilled()></i> <i class=\"fa fa-remove text-danger\" ng-show=$ctrl.playlistSearch.length ng-click=$ctrl.clearFilter()></i> <input type=search ng-model=$ctrl.playlistSearch ng-change=$ctrl.handleFilterChange($ctrl.playlistSearch)></div></h3>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 126 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/now-playing/now-playlist/now-playlist.tpl.html';
	var html = "<section class=now-playlist ng-class=\"{\n\t\t\t'transition-in': nowPlaylist.videos.length,\n\t\t\t'slide-down': nowPlaylist.showPlaylistSaver\n\t\t}\"><ul class=\"nav nav-list xux-maker xnicer-ux\" sv-root sv-part=nowPlaylist.videos sv-on-sort=\"nowPlaylist.sortVideo($item, $indexTo)\"><li class=now-playlist-track ng-class=\"{ \n\t\t\t\t'active': nowPlaylist.nowPlaying.index === $index,\n\t\t\t\t'playlist-media': nowPlaylist.isPlaylistMedia(video)\n\t\t\t}\" ng-repeat=\"video in nowPlaylist.videos | filter:nowPlaylist.filter track by video.etag\" sv-element><a ng-click=\"nowPlaylist.selectVideo(video, $index)\"><span class=\"label label-primary fa fa-list-ul playlist-track\" uib-tooltip=\"Play Specific Tracks from the i in the play bar\"></span> <span class=track-number>{{ $index + 1 }}</span> <img class=video-thumb draggable=false ng-src=\"{{:: video.snippet.thumbnails.default.url }}\" sv-handle uib-tooltip=\"Drag to sort\"> <span class=video-title>{{:: video.snippet.title }}</span> <span class=\"badge badge-info\">{{:: video.time }}</span> <span class=\"label label-danger ux-maker remove-track\" title=\"Remove From Playlist\" ng-click=\"nowPlaylist.removeVideo($event, video, $index)\"><i class=\"fa fa-remove\"></i></span></a></ul></section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 127 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/now-playing/playlist-saver/playlist-saver.tpl.html';
	var html = "<div class=playlist-saver><div class=col-md-12><aside class=title>New Playlist For {{ $ctrl.tracks.length }} Tracks</aside></div><div class=\"col-md-12 text-center\"><input ng-model=$ctrl.playlist.title placeholder=\"Type A Name\" class=col-md-12></div><div class=col-md-12><button class=\"btn btn-xs btn-link\" ng-click=$ctrl.onCancel()>cancel</button> <button class=\"btn btn-xs btn-primary btn-save\" ng-click=$ctrl.save()><span class=\"fa fa-circle-o-notch fa-spin\" ng-show=$ctrl.inSaveMode></span> save</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 128 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/playlist-editor/playlist-editor.tpl.html';
	var html = "<div class=playlists-viewer><div class=modal-header><button type=button class=close ng-click=$ctrl.hide() aria-hidden=true>&times;</button><div class=thumbnail><img ng-src=\"{{:: $ctrl.PlaylistEditorSettings.getMedia().snippet.thumbnails.high.url }}\" class=media-thumb></div><h3>Add To A Playlist:</h3><div class=\"video-title ellipsis\">{{ $ctrl.PlaylistEditorSettings.getMedia().snippet.title }}</div><form class=form-inline><input class=form-control type=search placeholder=\"find or create a playlist\" ng-model=$ctrl.search ng-model-options=\"{ debounce: 500 }\" ng-change=$ctrl.isPlaylistNameExists()> <button class=\"btn btn-success btn-sm add-btn\" ng-show=$ctrl.showCreate ng-click=$ctrl.create()>Create New</button></form></div><div class=modal-body><h5 class=title>Select a playlist to add the video to it</h5><ul class=\"list-unstyled playlists user-playlist\"><li ng-repeat=\"playlist in $ctrl.playlists | filter:$ctrl.search | orderBy:'snippet.title'\"><div class=user-playlist href=#none ng-click=$ctrl.add(playlist)>{{:: playlist.snippet.title }} <span ng-show=playlist.inProcess>Updating Playlist...</span> <span class=\"badge badge-info\">{{ playlist.contentDetails.itemCount }}</span></div><span class=\"badge badge-danger remove\" ng-click=$ctrl.remove(playlist)>Remove</span></ul></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=$ctrl.hide()>Close</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 129 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/playlist-viewer/playlist-viewer.tpl.html';
	var html = "<div class=\"view-content youtube-results playlist-viewer\"><nav class=\"navbar col-md-12\"><span class=\"btn btn-navbar btn-link pull-left ux-maker sidebar-toggle\" drawer-toggle=drawer-opened><i class=\"fa fa-bars\"></i></span><h2><button class=\"btn btn-default\" ng-click=$ctrl.goBack()><i class=\"fa fa-chevron-left\"></i> Back</button> {{ $ctrl.playlist.snippet.title }}</h2></nav><div class=\"playlist-cover clearfix\" style=\"background-image: url({{ $ctrl.playlist.snippet.thumbnails.default.url }})\"><div class=\"col-md-2 playlist-thumbnail\"><img ng-src=\"{{ $ctrl.playlist.snippet.thumbnails.default.url }}\" title=\"Play All\" ng-click=$ctrl.playVideo($ctrl.videos[0])></div><div class=\"actions col-md-10\"><h4>Total {{ $ctrl.videos.length}} videos</h4><button class=\"btn btn-lg ux-maker play-media bg-primary\" uib-tooltip=\"Play All And Replace The Playlist\" ng-click=$ctrl.playPlaylist()><i class=\"fa fa-play\"></i></button> <button class=\"btn btn-lg ux-maker play-media bg-primary\" uib-tooltip=\"Queue this playlist to now playlist\" ng-click=$ctrl.queuePlaylist($ctrl.videos)><i class=\"fa fa-share\"></i></button></div></div><section class=videos><youtube-list class=\"list-unstyled ux-maker youtube-items-container clearfix\" videos=$ctrl.videos on-select=$ctrl.playVideo(video) on-queue=$ctrl.queueVideo(video) on-add=$ctrl.addVideo(video)></youtube-list></section></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 130 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/search-filter-panel/search-filter-panel.html';
	var html = "<div><ul class=\"navbar-nav nav\" id=search-presets><li class=btn-group><e-dropdown label=Presets items=$ctrl.presets on-select=$ctrl.updatePreset(item) icon=tag selected></e-dropdown></ul><ul class=\"navbar-nav nav\" id=duration-picker><li class=btn-group><e-dropdown label=Duration items=$ctrl.durations on-select=\"$ctrl.onDurationChange(item, index)\" icon=time selected></e-dropdown></ul></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 131 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/search-panel/search-panel.tpl.html';
	var html = "<div class=search-panel><form class=\"navbar-form form-search navbar-left\" id=media-explorer ng-submit=$ctrl.search()><div class=\"form-group clearfix\"><input placeholder=\"Explore Media\" id=media-search type=search class=form-control autocomplete=off ng-model=$ctrl.params.q ng-model-options=\"{ debounce: 300 }\" ng-change=$ctrl.resetPageToken() uib-typeahead=\"q for q in $ctrl.complete($viewValue)\" typeahead-on-select=\"$ctrl.updateSearch($item, $model, $label)\" typeahead-show-hint=true> <button class=\"btn btn-transparent btn-submit\" type=submit title=\"search with echoes\"><i class=\"fa fa-search\"></i></button></div></form></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 132 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/user-playlists/user-playlists.tpl.html';
	var html = "<div class=\"view-content youtube-results user-playlists\"><nav class=nav><div class=\"col-md-10 col-xs-9\"><span class=\"drawer btn btn-navbar btn-link pull-left ux-maker sidebar-toggle\" drawer-toggle=drawer-opened><i class=\"fa fa-bars\"></i></span><h2 class=title>My Playlists</h2></div><user-profile class=\"nav navbar-nav navbar-right col-md-offset-2 col-xs-offset-2\"></user-profile><div class=col-md-12><section class=\"col-md-6 search-form\"><input class=form-control ng-model=userPlaylists.search placeholder=\"find a playlist...\"></section></div></nav><div ng-if=!userPlaylists.isUserSignedIn() class=\"col-md-12 well text-center\"><a href=\"\" class=\"sign-in btn btn-primary btn-lg\" google-sign-in><span class=\"fa fa-google-plus-square\"></span> Sign In</a><p>to view your playlists</div><section class=videos-list><ul class=\"list-unstyled ux-maker youtube-items-container clearfix\"><youtube-playlist-item ng-repeat=\"playlist in userPlaylists.playlists | filter:userPlaylists.search | orderBy:'snippet.title'\" video=playlist on-play=userPlaylists.playPlaylist(playlist)></youtube-playlist-item></ul></section></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 133 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/user-profile/user-profile.tpl.html';
	var html = "<ul class=\"list-unstyled user-profile\" ng-class=\"{ 'user-signed-in': userProfile.data.user.id }\"><li uib-dropdown class=dropdown><a uib-dropdown-toggle class=dropdown-toggle data-toggle=dropdown href=\"\"><i class=\"fa fa-user icon-user\" style=\"background-image: url({{ userProfile.data.user.snippet.thumbnails.high.url }})\"></i> <span class=badge><i class=\"fa fa-star\"></i></span></a><ul class=\"uib-dropdown-menu dropdown-menu dropdown-menu-fade\"><li class=bg-primary><a href=http://orizens.github.io/echoes-ng2 target=_blank><i class=\"fa fa-star\"></i> NEW: Try Echoes 2</a><li><a href=http://github.com/orizens/echoes target=_blank><i class=\"fa fa-github\"></i> About Echoes</a><li><a href=http://github.com/orizens/echoes/issues target=_blank><i class=\"fa fa-medkit\"></i> Report An Issue</a><li><a href=https://chrome.google.com/webstore/detail/echoes-player/aaenpaopfebcmdaegggjbkhaedlbbkde target=_blank><i class=\"fa fa-google\"></i> Echoes ChromeApp</a><li><a href=\"\" class=\"sign-in pull-left\" ng-click=userProfile.signInDialog()><i class=\"fa fa-google-plus\"></i> Sign In </a><a href=\"\" class=\"sign-out pull-left\" ng-click=userProfile.signOut()><i class=\"fa fa-power-off\"></i> Sign Out </a><a href=\"\" class=sign-out ng-click=userProfile.reload()><i class=\"fa fa-refresh\"></i> Reload</a></ul></ul>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 134 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/youtube-player/media-info/media-info.html';
	var html = "<article class=media-info><h3 class=\"yt-media-title ellipsis hidden-xs\"><aside class=pull-left title=\"{{:: $ctrl.thumbTitle }}\" ng-click=$ctrl.onThumbClick()><img ng-src=\"{{ $ctrl.video.thumb }}\"> <i class=\"fa fa-arrows-alt\" ng-class=\"{ invisible: !$ctrl.hasContent() }\"></i></aside><a ng-attr-href=\"{{ $ctrl.getUrlToVideo() }}\" class=title>{{ $ctrl.video.title }}</a></h3><section uib-dropdown class=\"btn-group dropup dropup-right pull-right\" ng-show=$ctrl.hasContent()><button uib-dropdown-toggle class=\"btn dropdown-toggle bg-primary\" title=\"Currently Playing\" data-toggle=dropdown><i class=\"fa fa-info\"></i></button><div class=\"uib-dropdown-menu dropdown-menu dropdown-menu-fade\"><div class=track-info ng-click=$ctrl.seekToSeconds($event)><div ng-bind-html=$ctrl.video.desc></div><br><img ng-src=\"{{  $ctrl.video.thumb }}\" alt=\"Media Thumbnail\"></div></div></section></article>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 135 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/youtube-player/player-controls/player-controls.html';
	var html = "<div class=\"btn-group player-controls\"><button title=\"show / hide\" ng-click=$ctrl.handleOnAction($ctrl.States.SHOW_PLAYER) class=\"btn btn-lg navbar-btn show-player visible-xs\"><i class=\"fa fa-chevron-up\"></i></button> <button title=\"play previous track\" class=\"btn btn-lg navbar-btn previous\" ng-click=$ctrl.handleOnAction($ctrl.States.PLAY_PREVIOUS) ng-disabled=!$ctrl.playlistHasTracks()><i class=\"fa fa-step-backward\"></i></button> <button title=pause class=\"btn btn-lg navbar-btn pause\" ng-click=$ctrl.handleOnAction($ctrl.States.PAUSE)><i class=\"fa fa-pause\"></i></button> <button title=play class=\"btn btn-lg navbar-btn play\" ng-click=$ctrl.handleOnAction($ctrl.States.PLAY)><i class=\"fa fa-play\"></i></button> <button title=\"play next track\" class=\"btn btn-lg navbar-btn next\" ng-click=$ctrl.handleOnAction($ctrl.States.PLAY_NEXT) ng-disabled=\"$ctrl.playlistIsEmpty() || $ctrl.playlistHasOneTrack()\"><i class=\"fa fa-step-forward\"></i></button> <button title=\"add to playlist\" class=\"btn btn-lg navbar-btn add\" ng-click=$ctrl.handleOnAction($ctrl.States.ADD)><i class=\"fa fa-plus\"></i></button></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 136 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/youtube-player/youtube-player.tpl.html';
	var html = "<div class=youtube-player ng-class=\"{ \n    'show-youtube-player': $ctrl.showPlayer(),\n    'fullscreen': $ctrl.isFullScreen\n      }\"><div class=\"yt-player ux-maker\" ng-show=$ctrl.hasContent()><div class=\"overlay text-center\" title=\"maximize player to medium size\" ng-click=$ctrl.onShowPlayer()><i class=\"fa fa-expand\"></i></div><div class=social-shares><button ng-repeat=\"share in $ctrl.shares\" class=\"btn btn-{{:: share.color }} btn-sm\" title=\"{{:: share.title }}\" socialshare socialshare-provider=\"{{:: share.provider }}\" socialshare-text=\"Listening to {{ $ctrl.video.media.snippet.title }}\" socialshare-hashtags=\"echotube, youtube video, nowlistening\" socialshare-url=\"http://echotu.be/#/video/{{ $ctrl.video.mediaId }}\"><span class=\"{{:: share.icon }}\"></span></button> <button title=\"minimize player\" ng-click=$ctrl.onShowPlayer() class=\"btn btn-sm btn-primary navbar-btn show-player pull-right visible-md visible-lg\"><i class=\"fa fa-chevron-up\"></i></button></div><div id=player class=ux-maker></div></div><div class=container-fluid><div class=\"col-md-5 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-offset-1\"><media-info video=$ctrl.videoInfo on-seek-change=$ctrl.seekToSeconds(seconds) on-thumb-click=$ctrl.toggleFullScreen() thumb-title=\"maximize / minimize\"></media-info></div><div class=\"col-md-4 col-sm-4 col-xs-10 controls-container nicer-ux\" ng-class=\"{ 'yt-playing': $ctrl.isPlaying() }\"><player-controls playlist=$ctrl.nowPlaylist playlist-index=$ctrl.video.index on-play=$ctrl.play() on-pause=$ctrl.pause() on-play-next=$ctrl.playNextTrack() on-play-previous=$ctrl.playPreviousTrack() on-show-player=$ctrl.onShowPlayer() on-add=$ctrl.addToPlaylist()></player-controls></div><div class=\"col-md-3 hidden-xs hidden-sm\"><ul class=\"nav navbar-nav navbar-right social-badges\"><li class=social-badge><div class=g-follow data-annotation=bubble data-height=15 data-href=//plus.google.com/u/0/111830310196328233893 data-rel=publisher></div><li><a href=# class=\"facebook-page brand\"><iframe src=\"//www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fechoesplayer&amp;width=50&amp;layout=button_count&amp;action=like&amp;show_faces=false&amp;share=false&amp;height=21&amp;appId=683337491728445\" scrolling=no frameborder=0 style=\"border:none; overflow:hidden; width:80px; height:21px\" allowtransparency=true></iframe></a></ul></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 137 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/youtube-video/youtube-video.tpl.html';
	var html = "<div class=\"view-content youtube-video ux-maker\"><div class=\"panel panel-default\"><div class=panel-heading><h4><span class=\"btn btn-navbar btn-link pull-left ux-maker sidebar-toggle visible-xs-inline-block visible-lg-inline-block\" drawer-toggle=drawer-opened><i class=\"fa fa-bars\"></i> </span><button class=\"btn btn-primary\" ng-click=$ctrl.goBack()><i class=\"fa fa-chevron-left\"></i> Back</button> {{:: $ctrl.video.snippet.title}}</h4></div><div class=panel-body><div class=thumbnail><img ng-src=\"{{:: $ctrl.video.snippet.thumbnails.high.url}}\" alt=\"{{:: $ctrl.video.snippet.title}}\"><section class=actions><button class=\"btn btn-lg ux-maker play-media bg-primary\" title=\"Play this video now\" ng-click=$ctrl.playVideo()><i class=\"fa fa-play\"></i></button> <button class=\"btn btn-lg ux-maker play-media bg-primary\" title=\"Queue this video to now playlist\" ng-click=$ctrl.queueVideo()><i class=\"fa fa-share\"></i></button></section></div><div class=\"caption pull\"><span>{{:: $ctrl.video.snippet.publishedAt | date}}</span> <span class=\"label label-info\">{{:: $ctrl.video.time}}</span><div ng-bind-html=\":: $ctrl.video.snippet.description\"></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 138 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/components/youtube-videos/youtube-videos.tpl.html';
	var html = "<div class=\"view-content youtube-videos\" infinite-scroll=$ctrl.searchMore() infinite-scroll-distance=2><nav class=\"navbar col-xs-12\" player-resizer=fullscreen><span class=\"btn btn-navbar btn-link pull-left ux-maker sidebar-toggle visible-xs-inline-block\" drawer-toggle=drawer-opened><i class=\"fa fa-bars\"></i></span><div class=\"navbar-header pull-left\"><search-panel></search-panel></div><button type=button class=\"navbar-toggle btn btn-primary\" ng-click=$ctrl.toggleFilters()><i class=\"fa fa-filter\"></i></button><div class=\"collapse navbar-collapse\" ng-class=\"{ collapse: $ctrl.hideFilters }\"><search-panel-filter class=navbar-left></search-panel-filter><user-profile class=\"nav navbar-nav navbar-right\"></user-profile></div><feed-filter></feed-filter></nav><section ng-switch=$ctrl.getFeedType() class=videos-list><div ng-switch-when=video><youtube-list videos=$ctrl.videos class=\"list-unstyled ux-maker youtube-items-container clearfix\" on-select=$ctrl.playVideo(video) on-queue=$ctrl.queueVideo(video) on-add=$ctrl.addVideo(video)></youtube-list></div><div ng-switch-when=playlist><ul class=\"list-unstyled ux-maker youtube-items-container clearfix\"><youtube-playlist-item ng-repeat=\"video in $ctrl.videos track by video.id\" video=video on-play=$ctrl.playPlaylist(video) back=\"{{:: $ctrl.playlistBackState }}\"></youtube-playlist-item></ul></div></section></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 139 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/core/components/e-dropdown/e-dropdown.tpl.html';
	var html = "<div class=e-dropdown uib-dropdown is-open=vm.status.isOpen><div class=dropdown-toggle uib-dropdown-toggle ng-disabled=disabled><i class=\"glyphicon glyphicon-{{vm.icon}}\"></i> {{vm.label}} <span class=\"label label-primary\">{{ vm.displayLabel }}</span> <span class=caret></span></div><ul class=\"uib-dropdown-menu dropdown-menu-fade dropdown-menu\" role=menu><li ng-repeat=\"item in vm.items\" ng-click=\"vm.handleClick(item, $index)\" ng-class=\"{'active': $index === vm.activeIndex}\"><a>{{item}}</a></ul></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 140 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/core/components/youtube-components/youtube-list/youtube-list.tpl.html';
	var html = "<ul class=\"list-unstyled clearfix\"><li class=\"pull-left youtube-list-item\" ng-repeat=\"video in vm.videos track by $index\"><youtube-media video=video on-play=vm.playSelectedVideo(video) on-queue=vm.queueSelectedVideo(video) on-add=vm.add(video)></youtube-media></ul>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 141 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/core/components/youtube-components/youtube-media/youtube-media.html';
	var html = "<section class=\"youtube-item card ux-maker pull-left\" ng-class=\"{ 'show-description': vm.showDesc}\"><div class=media-title><div class=\"front face\"><div class=\"indicators clearfix\"><span class=\"pull-left item-is-playing playing-{{:: vm.isPlaying }}\"><i class=\"fa fa-play\"></i>Now Playing</span></div><section class=\"dropdown share\"><a class=dropdown-toggle data-toggle=dropdown href=\"\"><span class=\"fa fa-share-alt\"></span></a><ul class=\"dropdown-menu dropdown-menu-fade\"><li><a socialshare socialshare-provider=google+ socialshare-hashtags=\"echotube, youtube video, nowlistening\" socialshare-url=\"http://echotu.be/#/video/{{:: vm.video.id }}\"><span class=\"fa fa-google-plus-square\"></span> Google+</a><li><a socialshare socialshare-provider=twitter socialshare-url=\"http://echotu.be/#/video/{{:: vm.video.id }}\"><span class=\"fa fa-twitter-square\"></span> Twitter</a><li><a socialshare socialshare-provider=facebook socialshare-url=\"http://echotu.be/#/video/{{:: vm.video.id }}\"><span class=\"fa fa-facebook-square\"></span> Facebook</a></ul></section><div rel=tooltip class=media-thumb uib-tooltip=\"{{:: vm.video.snippet.title }}\" tooltip-placement=bottom ng-click=vm.playVideo(vm.video)><div class=thumbnail><img ng-src=\"{{:: vm.video.snippet.thumbnails.high.url}}\"></div><button class=\"btn btn-default btn-lg ux-maker play-media\"><i class=\"fa fa-play\"></i></button></div><section class=\"item-actions main-actions\"><h4 class=\"title ellipsis span11\"><a href=\"#/video/{{:: vm.video.id}}\" rel=tooltip class=\"media-thumb ellipsis\" uib-tooltip=\"{{:: vm.video.snippet.title}}\" tooltip-placement=bottom>{{:: vm.video.snippet.title}}</a></h4><section class=\"media-actions clearfix\"><button class=\"btn btn-link btn-xs add-to-playlist\" title=\"Queue this video to now playlist\" ng-click=vm.queueVideo(vm.video)><i class=\"fa fa-share\"></i> Queue</button> <button class=\"btn btn-link btn-xs add-to-playlist\" title=\"Add this video to a playlist\" ng-click=vm.add(vm.video)><i class=\"fa fa-plus\"></i> Add</button></section><span ng-click=vm.toggle(vm.showDesc) class=\"btn btn-default btn-xs media-desc\" title=\"more info about this video\"><i class=\"fa fa-info-circle\"></i> </span><span class=item-action><i class=\"fa fa-clock-o\"></i>{{:: vm.video.time}}</span> <span class=\"item-likes item-action\" rel=tooltip title=\"Number of Likes\"><i class=\"fa fa-thumbs-up\"></i> {{:: vm.video.statistics.likeCount | number}} </span><span class=\"item-views ellipsis item-action\" rel=tooltip title=\"Number of Views\"><i class=\"fa fa-eye\"></i> {{:: vm.video.statistics.viewCount | number}}</span></section></div><div class=\"description back face\"><h4><a href=\"#/video/{{:: vm.video.id}}\" rel=tooltip title=\"{{:: vm.video.snippet.title}}\" class=media-thumb>{{:: vm.video.snippet.title}}</a></h4><div ng-bind-html=\"::vm.video.snippet.description | linky\"></div></div><section class=\"item-actions close-desc\"><span ng-click=vm.toggle(vm.showDesc) class=\"btn btn-default btn-xs media-desc\" title=\"flip back...\"><i class=\"fa fa-times-circle\"></i></span></section></div></section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 142 */
/***/ function(module, exports) {

	var path = '/home/travis/build/orizens/echoes/src/core/components/youtube-components/youtube-playlist/youtube.playlist.tpl.html';
	var html = "<li class=\"well youtube-item youtube-list-item youtube-playlist-item col-md-3 ux-maker card pull-left\"><section class=\"media-title front\"><div class=\"indicators clearfix\"><span class=\"pull-left item-is-playing playing-<%= isPlaying %>\"><i class=icon-play></i>Now Playing </span><i class=\"fa fa-spinner fa-spin fa-2x icon-loading ng-hide\" ng-show=vm.loading></i></div><div class=media-thumb uib-tooltip=\"{{:: vm.video.snippet.title }}\" tooltip-placement=bottom><div class=thumbnail><img ng-src=\"{{:: vm.video.snippet.thumbnails.high.url }}\"></div><button class=\"btn btn-default btn-lg play-media\" ng-click=vm.playVideo(video)><i class=\"glyphicon glyphicon-play\"></i></button></div><section class=item-actions><a href=\"#playlist/{{:: vm.video.id}}/{{:: vm.back }}\"><h4 class=\"title ellipsis\" uib-tooltip=\"{{:: vm.video.snippet.title }}\" tooltip-placement=bottom>{{:: vm.video.snippet.title }}</h4><span class=\"item-action badge badge-info\"><i class=icon-list></i> {{:: vm.video.contentDetails.itemCount }}</span> videos</a></section></section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 143 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "db812d8a70a4e88e888744c1c9a27e89.woff2";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a35720c2fed2c7f043bc7e4ffb45e073.woff";

/***/ },
/* 146 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** app.a528e05c9ae00513672d.bundle.js
 **/